'use strict';

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ THEME ================*/
theme.ShippingRatesCalculation = function() {

    function ShippingRatesCalculation() {
        this.load();
    };

    ShippingRatesCalculation.prototype = $.extend({}, ShippingRatesCalculation.prototype, {
        load: function() {
            var $calculator = $('#shipping-calculator');

            if($calculator.length) {
                var $info = $('.shipping-calculator-info');

                Shopify.Cart.ShippingCalculator.show({
                    submitButton: theme.strings.shippingCalcSubmitButton,
                    submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                    customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
                    moneyFormat: theme.strings.shippingCalcMoneyFormat
                });

                $calculator.on('updated', function () {
                    setTimeout(function () {
                        var $result = $('#shipping-rates-feedback.success'),
                            html = $result.text(),
                            data = {
                                zip: $('#address_zip').val(),
                                province: $('#address_province').val(),
                                country: $('#address_country').val()
                            },
                            info = '';

                        $result.html(html);

                        var $price = $('<span>').addClass('price'),
                            $money = $result.find('span');

                        $money.replaceWith($price);
                        $price.append($money);

                        theme.ProductCurrency.update();

                        if($('#shipping-rates-feedback.success').length) {
                            $.each(data, function () {
                                if(this) {
                                    if(info) info += ', ';
                                    info += this;
                                }
                            });

                            $info.text(theme.strings.cart.general.shipping_calculator_data_info.replace('{{ data }}', info)).fadeIn({
                                complete: function () {
                                    $info.removeAttr('style');
                                }
                            }).removeClass('d-none');
                        } else {
                            $info.text('').addClass('d-none');
                        }
                    }, 100);
                });
            }
        }
    });

    theme.ShippingRatesCalculation = new ShippingRatesCalculation;
};
if(Shopify && typeof Shopify === 'object') {
    /*Shopify.onCartUpdate = function (e) {
        alert("There are now " + e.item_count + " items in the cart.")
    };*/
    /*Shopify.onCartShippingRatesUpdate = function (e, t) {
        var n = "";
        t.zip && (n += t.zip + ", "), t.province && (n += t.province + ", "), n += t.country, alert("There are " + e.length + " shipping rates available for " + n + ", starting at " + Shopify.formatMoney(e[0].price) + ".")
    };*/
    Shopify.onItemAdded = function (e) {
        theme.Popups.cartItemAdded(e.title);
    };
    /*Shopify.onItemAdded = function (e) {
        alert(e.title + " was added to your shopping cart.")
    };*/
    /*Shopify.onProduct = function (e) {
        alert("Received everything we ever wanted to know about " + e.title)
    };*/
    Shopify.addValueToString = function(str, obj) {
        $.each(obj, function(i) {
            str = str.replace('{{ ' + i + ' }}', this);
        });

        return str;
    };
    Shopify.handleize = function (str) {
        return str.toLowerCase().replace(/[-!"#$%&'* ,./:;<=>?@[\\\]_`{|}~]+/g, "-").replace(/[()]+/g, "").replace(/^-+|-+$/g, "");
    };
}

theme.Global = function() {

    function Global() {
        this.settings = {
            set_offset_with_fixed_body: [
                '.header__content--sticky',
                '.footbar',
                '.footer--fixed',
                '.presentation',
                '#admin_bar_iframe',
                '#preview-bar-iframe'
            ]
        };

        this.load();
    };

    Global.prototype = $.extend({}, Global.prototype, {
        load: function() {
            var ua = window.navigator.userAgent.toLowerCase(),
                current_bp,
                $scroll_example = $('.scroll-offset-example');

            window.ie = (/trident/gi).test(ua) || (/msie/gi).test(ua);
            window.edge = document.documentMode || /edge/.test(ua);
            window.ios = navigator.userAgent.match(/like Mac OS X/i);
            window.moz = typeof InstallTrigger !== 'undefined';
            window.$window = $(window);
            window.$html = $('html');
            window.$body = $html.find('body');

            if(ios) {
                $html.addClass('is-ios');
            } else if(edge) {
                $html.addClass('is-edge');
            } else if(ie) {
                $html.addClass('is-ie');
            } else if(moz) {
                $html.addClass('is-moz');
            }

            theme.rtl = $html.attr('dir') === 'rtl' ? true : false;

            theme.breakpoints = {
                values: {
                    xs: 0,
                    sm: 541,
                    md: 778,
                    lg: 1025,
                    xl: 1260
                }
            };
            theme.breakpoints.main = theme.breakpoints.values.lg;
            theme.current = {};

            function checkWindow() {
                theme.current.width = window.innerWidth;
                theme.current.height = window.innerHeight;
            };

            function checkBreakpoint() {
                theme.current.is_mobile = theme.current.width < theme.breakpoints.main;
                theme.current.is_desktop = !theme.current.is_mobile;

                $.each(theme.breakpoints.values, function(k, v) {
                    if(v > theme.current.width) {
                        return false;
                    }

                    theme.current.bp = k;
                });

                if(current_bp && current_bp != theme.current.bp) {
                    $(window).trigger('theme.changed.breakpoint');
                }

                current_bp = theme.current.bp;
            };

            function scrollPaddingStyle() {
                var $style = $('style.scroll-offset-style');

                theme.current.scroll_w = $scroll_example[0].offsetWidth - $scroll_example[0].clientWidth;

                if(theme.current.scroll_w > 0) {
                    if(!$style.length) {
                        var offset_scroll_style_html = 'body.overflow-hidden.offset-scroll{padding-right:' + theme.current.scroll_w + 'px;}.fixed-elem.offset-scroll{padding-right:' + theme.current.scroll_w + 'px;}';

                        $('head').append($('<style>').addClass('scroll-offset-style').html(offset_scroll_style_html));
                    }
                } else {
                    $style.remove();
                }
            };

            $(window).on('resize', $.debounce(250, function() {
                checkWindow();
                checkBreakpoint();

                $(window).trigger('theme.resize');
            }));

            $(window).on('theme.changed.breakpoint', function() {
                scrollPaddingStyle();
            });

            checkWindow();
            checkBreakpoint();
            scrollPaddingStyle();

            $(window).on('load', function () {
                theme.is_loaded = true;
            });
        },
        bodyHasScroll: function(prop) {
            var d = document,
                e = d.documentElement,
                b = d.body,
                client = "client" + prop,
                scroll = "scroll" + prop;

            return /CSS/.test(d.compatMode) ? (e[client] < e[scroll]) : (b[client] < b[scroll]);
        },
        fixBody: function() {
            if (this.bodyHasScroll('Height')) {
                $body.addClass('offset-scroll');

                $.each(this.settings.set_offset_with_fixed_body, function() {
                    $(this).addClass('offset-scroll fixed-elem');
                });
            }

            this._fixed_scroll_top = pageYOffset;

            $body.css({ top: pageYOffset * -1 });
            $body.addClass('overflow-hidden position-fixed left-0 w-100');
        },
        unfixBody: function() {
            $body.removeClass('offset-scroll overflow-hidden position-fixed left-0 w-100');

            $body.add($html).scrollTop(this._fixed_scroll_top);
            this._fixed_scroll_top = null;

            $body.css({ top: '' });

            $.each(this.settings.set_offset_with_fixed_body, function() {
                $(this).removeClass('fixed-elem offset-scroll');
            });
        },
        responsiveHandler: function(obj) {
            var namespace = obj.namespace ? obj.namespace : '.widthHandler',
                current_bp;
            
            function bind() {
                $.each(obj.events, function(event, func) {
                    if(obj.delegate) {
                        $(obj.element).on(event + namespace, obj.delegate, func);
                    } else {
                        $(obj.element).on(event + namespace, func);
                    }
                });
            };

            function unbind() {
                $.each(obj.events, function(event) {
                    $(obj.element).unbind(event + namespace);
                });
            };

            function on_resize() {
                if(theme.current.is_mobile !== current_bp) {
                    current_bp = theme.current.is_mobile;

                    if((obj.on_desktop && theme.current.is_desktop) || (obj.on_mobile && theme.current.is_mobile)) {
                        bind();
                    } else {
                        unbind();
                    }
                }
            };

            $(window).on('theme.resize' + namespace, function() {
                on_resize();
            });

            on_resize();

            return {
                unbind: function() {
                    $(window).unbind('theme.resize' + namespace);
                    unbind();
                }
            }
        },
    });

    theme.Global = new Global;
};



theme.ImagesLazyLoad = function() {

    function ImagesLazyLoad() {
        this.settings = {
            effectTime: 500
        };

        this.load();
    };

    ImagesLazyLoad.prototype = $.extend({}, ImagesLazyLoad.prototype, {
        load: function() {
            this.init();
        },
        init: function () {
            this.api = new LazyLoad({
                elements_selector: '[data-src]',
                callback_load: function (element) {
                    var $element = $(element);
                    
                    $element.next('.loader').remove();
                    $element.parent().addClass('loaded');
                    $element.removeAttr('data-src data-srcset').trigger('lazyloaded');
                }
            });
        },
        update: function () {
            this.api.update();
        }
    });

    theme.ImagesLazyLoad = new ImagesLazyLoad;
};
theme.Masonry = function() {

    function Masonry() {
        jQueryBridget('masonry', window.Masonry, $);
        
        this.load();
    };

    Masonry.prototype = $.extend({}, Masonry.prototype, {
        load: function() {
            this.init();
        },
        init: function (is_first) {
            var _ = this,
                $masonry = $('.masonry'),
                params = {
                    itemSelector: '[class*="col-"]'
                },
                timeout;

            this.$masonry = $masonry;

            function load() {
                $masonry.masonry(params).removeClass('invisible');

                setTimeout(function () {
                    _.update();
                }, 100);

                $masonry.on('lazyloaded', 'img', function() {
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        _.update();
                    }, 200);
                });
            };

            if(is_first) {
                load();
            } else {
                $(window).on('load', function () {
                    load();
                });
            }
        },
        update: function () {
            this.$masonry.masonry('layout');
        },
        destroy: function () {
            this.$masonry.unbind('lazyloaded').masonry('destroy');
        }
    });

    theme.Masonry = new Masonry;
};

theme.Position = function() {

    function Position() {
        this.settings = {
            name: 'data-js-position-name',
            desktop: 'data-js-position-desktop',
            mobile: 'data-js-position-mobile',
            all: 'data-js-position-all'
        };

        this.selectors = {
            elements: '.js-position'
        };

        this.load();
    };

    Position.prototype = $.extend({}, Position.prototype, {
        load: function() {
            var _ = this,
                current_position_is_desktop;

            function check_position() {
                if(current_position_is_desktop !== theme.current.is_desktop) {
                    _.update();

                    current_position_is_desktop = theme.current.is_desktop;
                }
            };

            $(window).on('theme.resize.position', function() {
                check_position();
            });
            
            check_position();

            var $elements_append_onload = $(this.selectors.elements).filter('[data-js-position-onload]');

            this.append($elements_append_onload, this.settings.all);
        },
        update: function(name) {
            var $elements = name ? $('[' + this.settings.name + '="' + name + '"]') : $(this.selectors.elements).not('[data-js-position-onload]'),
                append_to = theme.current.is_desktop ? this.settings.desktop : this.settings.mobile;

            this.append($elements, append_to);
        },
        append: function($elements, append_to) {
            var _ = this;

            $elements.each(function() {
                var $this = $(this),
                    append_to_name = $this.attr(_.settings.name);

                var $append_to = $('[' + append_to + '="' + append_to_name + '"]');

                if($append_to.length && !$.contains($append_to[0], $this[0])) {
                    if($append_to.find('[' + _.settings.name + '="' + append_to_name + '"]').length) {
                        $this.remove();
                    } else {
                        $this.appendTo($append_to);
                    }
                }
            });
        }
    });

    theme.Position = new Position;
};
theme.Parallax = function() {

    function Parallax() {
        this.load();
    };

    Parallax.prototype = $.extend({}, Parallax.prototype, {
        load: function () {
            $.widget( 'ui.parallax', {
                options: {
                    ratio: 1.2
                },
                params: {},
                _create: function() {
                    var _ = this;

                    this.params.start_width = this.element.width();
                    this.params.start_height = this.element.height();
                    this.params.start_ratio_height = this.params.start_height / this.params.start_width;

                    this._setOption('ratio', this.element.data('ratio'), true);
                    this._setOption('height', this.element.data('height'), true);
                    this._setOption('minHeight', this.element.data('min-height'), true);

                    if(this.options.height) {
                        var height_arr = this.options.height.split(',');

                        this.options.height = {
                            xs: height_arr[4],
                            sm: height_arr[3],
                            md: height_arr[2],
                            lg: height_arr[1],
                            xl: height_arr[0]
                        };
                    } else {
                        this.element.css({
                            paddingTop: _.params.start_ratio_height * 100 + '%'
                        });
                    }

                    if(this.options.minHeight) {
                        this.element.css({
                            minHeight: this.options.minHeight + 'px'
                        });
                    }

                    this.$content = this.element.children().first();

                    this._calculateSize();
                    this._calculatePosition();

                    this.element.css({
                        overflow: 'hidden',
                        position: 'relative'
                    });

                    this.$content.css({
                        position: 'absolute',
                        top: '0',
                        left: '50%',
                        transform: 'translateX(-50%)'
                    });

                    $window.on('theme.resize.parallax', function () {
                        _._calculateSize();
                        _._calculatePosition();
                    });

                    $window.on('scroll.parallax', function () {
                        _._calculatePosition();
                    });

                    this.element.addClass('parallax--init');
                },
                _calculateSize: function() {
                    this.params.current_width = this.element.width();

                    if(this.options.height) {
                        this.element.css({
                            paddingTop: this.options.height[theme.current.bp]
                        });
                    }

                    this.params.current_height = this.element.height();

                    this.params.current_scale_width = this.params.current_width * this.options.ratio;
                    this.params.current_scale_height = this.params.current_height * this.options.ratio;

                    this.params.stroke_scroll = this.params.current_height + window.innerHeight;
                    this.params.stroke_content = this.params.current_scale_height - this.params.current_height;
                    this.params.stroke_ratio = this.params.stroke_scroll / this.params.stroke_content;

                    this.$content.width(this.params.current_scale_width);
                },
                _calculatePosition: function() {
                    this.params.stroke_current = this.params.stroke_scroll - this.element[0].getBoundingClientRect().bottom;

                    this.params.stroke_current = Math.max(this.params.stroke_current, 0);
                    this.params.stroke_current = Math.min(this.params.stroke_current, this.params.stroke_scroll);

                    this.params.current_top = this.params.stroke_content * -1 + (this.params.stroke_current / this.params.stroke_ratio);

                    this.$content.css({
                        transform: 'translate(-50%, ' + this.params.current_top + 'px)'
                    });
                },
                _init: function () {

                },
                _setOption: function(key, value) {
                    $.Widget.prototype._setOption.apply(this, arguments);
                },
                destroy: function() {
                    $window.unbind('theme.resize.parallax scroll.parallax');

                    $.Widget.prototype.destroy.call(this);
                }
            });
        },
        init: function($parallax) {
            if(!$parallax.hasClass('parallax--init')) {
                $parallax.parallax();
            }
        },
        destroy: function ($parallax) {
            if($parallax.hasClass('parallax--init')) {
                $parallax.parallax('destroy');
            }
        }
    });

    theme.Parallax = new Parallax;
};

theme.Dropdown = function() {

    var settings = {
        namespace: '.dropdown'
    };

    function Dropdown() {
        this.selectors = {
            element: '.js-dropdown',
            button: '[data-js-dropdown-button]',
            dropdown: '[data-js-dropdown]'
        };

        this.load();
    };

    Dropdown.prototype = $.extend({}, Dropdown.prototype, {
        duration: function () {
            return theme.animations.dropdown.duration * 1000;
        },
        load: function() {
            var _ = this;

            theme.Global.responsiveHandler({
                namespace: settings.namespace,
                element: $body,
                delegate: this.selectors.button + ', ' + this.selectors.dropdown,
                on_desktop: true,
                events: {
                    'show hide close': function(e) {
                        var $element = $(this).parents(_.selectors.element),
                            $btn = $element.find(_.selectors.button),
                            $dropdown = $element.find(_.selectors.dropdown);

                        _['_' + e.type]($dropdown, $btn);
                    }
                }
            });

            theme.Global.responsiveHandler({
                namespace: settings.namespace,
                element: $body,
                delegate: this.selectors.button,
                on_desktop: true,
                events: {
                    'mouseenter': function() {
                        var $this = $(this),
                            $dropdown = $this.parents(_.selectors.element).find(_.selectors.dropdown);

                        if(!$this.hasClass('active') && !$dropdown.hasClass('show')) {
                            _._show($dropdown, $this);
                        }
                    },
                    'mousedown': function(e) {
                        var $this = $(this),
                            $dropdown = $this.parents(_.selectors.element).find(_.selectors.dropdown);

                        if(!$this.hasClass('active')) {
                            _._show($dropdown, $this, true);

                            $body.one('mousedown' + settings.namespace, function (e) {
                                if(!$(e.target).parents(_.selectors.dropdown + ', ' + _.selectors.button).length) {
                                    $(_.selectors.dropdown).trigger('hide');
                                }
                            });
                        } else {
                            _._hide($dropdown, $this);
                        }

                        e.preventDefault();
                        return false;
                    }
                }
            });

            theme.Global.responsiveHandler({
                namespace: settings.namespace,
                element: $body,
                delegate: this.selectors.element,
                on_desktop: true,
                events: {
                    'mouseleave': function() {
                        var $this = $(this),
                            $btn = $this.find(_.selectors.button),
                            $dropdown = $this.find(_.selectors.dropdown);

                        if(!$btn.hasClass('active')) {
                            _._hide($dropdown, $btn);
                        }
                    }
                }
            });
        },
        _show: function ($dropdown, $btn, is_click) {
            $(this.selectors.dropdown).not($dropdown).trigger('close');

            if(is_click) {
                $btn.addClass('active');
            }

            if($dropdown.hasClass('show')) {
                return;
            }

            $dropdown.addClass('show animate');

            $dropdown.velocity('stop', true).removeAttr('style');

            $dropdown.velocity('slideDown', {
                duration: this.duration(),
                begin: function () {
                    setTimeout(function () {
                        $dropdown.addClass('visible');
                    }, 0);
                },
                complete: function () {
                    $dropdown.removeAttr('style');
                }
            });
        },
        _hide: function ($dropdown, $btn) {
            $dropdown.velocity('stop', true);

            $dropdown.velocity('slideUp', {
                duration: this.duration(),
                begin: function () {
                    $dropdown.removeClass('visible');
                },
                complete: function () {
                    $dropdown.removeClass('show animate').removeAttr('style');
                }
            });

            $btn.removeClass('active');
            $body.unbind('click' + settings.namespace);
        },
        _close: function ($dropdown, $btn) {
            $dropdown.velocity('stop');
            $dropdown.removeClass('show animate visible').removeAttr('style');
            $btn.removeClass('active');
            $body.unbind('click' + settings.namespace);
        }
    });

    theme.Dropdown = new Dropdown;
};
theme.Select = function() {
    
    var settings = {
        namespace: '.select'
    }

    function Select() {
        this.selectors = {
            element: '.js-select',
            dropdown: '[data-js-select-dropdown]'
        };

        this.load();
    };

    Select.prototype = $.extend({}, Select.prototype, {
        load: function() {
            var _ = this;

            theme.Global.responsiveHandler({
                namespace: settings.namespace,
                element: $body,
                delegate: this.selectors.element + ' ' + this.selectors.dropdown + ' span',
                on_desktop: true,
                events: {
                    'click': function() {
                        var $this = $(this);
                        
                        if(!$this.hasClass('selected') && !$this[0].hasAttribute('disabled')) {
                            var value = $this.attr('data-value'),
                                $dropdown = $this.parents(_.selectors.dropdown),
                                $wrapper = $this.parents('.js-select'),
                                $select = $wrapper.find('select');

                            $select.val(value);

                            $dropdown.find('span').removeClass('selected');
                            $this.addClass('selected');

                            $dropdown.trigger('hide');
                            
                            $select.change();
                        }
                    }
                }
            });

            $body.on('change update' + settings.namespace, this.selectors.element + ' select', function() {
                var $this = $(this),
                    $dropdown_items = $this.parents(_.selectors.element).find(_.selectors.dropdown + ' span'),
                    value = $this.val();

                $dropdown_items.each(function() {
                    var $this = $(this);

                    $this[$this.attr('data-value') == value ? 'addClass' : 'removeClass']('selected');
                });
            });

            $(this.selectors.element + '[data-onload-check] select').trigger('update' + settings.namespace);
        }
    });

    theme.Select = new Select;
};
theme.StickyHeader = function() {

    function StickyHeader() {

    };

    StickyHeader.prototype = $.extend({}, StickyHeader.prototype, {
        init: function($sticky, params) {
            var effect = $sticky.attr('data-sticky-effect') || 1;

            if ($sticky.length) {
                var stickyHeader = {
                    _create: function() {
                        var _ = this,
                            $elem = this.bindings,
                            $sticky_m = $elem.find(this.options.mobile && this.options.mobile.sticky ? this.options.mobile.sticky : ''),
                            $sticky_d = $elem.find(this.options.desktop && this.options.desktop.sticky ? this.options.desktop.sticky : ''),
                            $spacer_m = $('<div>').addClass('header__spacer header__spacer--m').insertBefore($sticky_m),
                            $spacer_d = $('<div>').addClass('header__spacer header__spacer--d').insertBefore($sticky_d);

                        this.sticky_class = 'header__content--sticky';

                        function fix() {
                            _._fix(_.$sticky, _.$spacer);
                            _._move(_.options[_.bp]);
                        };

                        function unfix() {
                            _._unfix(_.$sticky, _.$spacer);
                            _._return(_.options[_.bp]);
                        };

                        function on_resize() {
                            var is_desktop = theme.current.is_desktop;

                            _.bp = is_desktop ? 'desktop' : 'mobile';
                            _.$sticky = is_desktop ? $sticky_d : $sticky_m;
                            _.$spacer = is_desktop ? $spacer_d : $spacer_m;

                            if(!_.$sticky.length) return;

                            if (is_desktop) {
                                $spacer_m.removeClass('header__spacer--visible');
                                $spacer_d.addClass('header__spacer--visible');

                                if ($sticky_m.hasClass(_.sticky_class)) {
                                    _._unfix($sticky_m, $spacer_m);
                                    _._return(_.options.mobile);
                                }
                            } else {
                                $spacer_d.removeClass('header__spacer--visible');
                                $spacer_m.addClass('header__spacer--visible');

                                if ($sticky_d.hasClass(_.sticky_class)) {
                                    _._unfix($sticky_d, $spacer_d);
                                    _._return(_.options.desktop);
                                }
                            }
                        };

                        function on_scroll() {
                            if(!_.$sticky.length) return;

                            var limit = _.options[_.bp].limit ? _.options[_.bp].limit : 0,
                                spacer_pos = _.$spacer[0].getBoundingClientRect();

                            if (limit === 'bottom') {
                                limit = _.$sticky.hasClass(_.sticky_class) ? _.$spacer.innerHeight() : _.$sticky.innerHeight();
                            }

                            limit *= -1;

                            if (spacer_pos.top < limit) {
                                if (!_.$sticky.hasClass(_.sticky_class)) {
                                    fix();
                                }

                                if(!ie) {
                                    _._check_height(_.$sticky, _.options[_.bp]);
                                }
                            } else {
                                if (_.$sticky.hasClass(_.sticky_class)) {
                                    unfix();
                                }
                            }
                        };

                        on_resize();
                        on_scroll();

                        $window.on({
                            'theme.resize.stickyHeader': function() {
                                on_resize();
                                on_scroll();
                            },
                            'scroll.stickyHeader': on_scroll
                        });
                    },
                    _fix: function($sticky, $spacer) {
                        var height = $sticky.innerHeight();

                        $spacer.height(height);

                        if(this.options[this.bp].fade) {
                            $sticky.css({ 'opacity': 0 }).velocity({ 'opacity': theme.animations.sticky_header.opacity }, this.options[this.bp].duration());
                        }

                        $sticky.addClass(this.sticky_class);
                    },
                    _unfix: function($sticky, $spacer) {
                        $spacer.removeAttr('style');

                        if(this.options[this.bp].fade) {
                            $sticky.velocity('stop', true);
                        }

                        $sticky.removeAttr('style').removeClass(this.sticky_class);
                    },
                    _move: function(obj) {
                        if (!obj.move) return;

                        $.each(obj.move, function() {
                            var $elem = $(this.elem),
                                $to = $(this.to),
                                method = this.method || 'append';

                            this.$elem = $elem;
                            this.$parent = $elem.parent();

                            $to[method]($elem);
                        });
                    },
                    _return: function(obj) {
                        if (!obj.move) return;

                        $.each(obj.move, function() {
                            var method = this.method || 'append';

                            this.$parent[method](this.$elem);
                            this.$elem = null;
                            this.$parent = null;
                        });
                    },
                    _check_height: function($sticky, obj) {
                        if(!obj.height) return;

                        var spacer_pos = this.$spacer[0].getBoundingClientRect(),
                            height = spacer_pos.bottom <= obj.height ? obj.height : spacer_pos.bottom;

                        $sticky.css({ 'min-height': height });
                    },
                    getStickyHeight: function() {
                        return this.options[this.bp] ? (this.options[this.bp].height || $(this.options[this.bp].sticky).innerHeight()) : 0;
                    },
                    destroy: function() {
                        $(window).unbind('resize.stickyHeader scroll.stickyHeader');

                        $.Widget.prototype.destroy.call(this);
                    }
                };

                $.widget('ui.stickyHeader', stickyHeader);

                $sticky.stickyHeader(params);

                this.$sticky = $sticky;

                return {
                    destroy: function() {
                        $sticky.stickyHeader('destroy');
                    }
                };
            }
        }
    });

    theme.StickyHeader = new StickyHeader;
};

/*DOCUMENTATION*/

//params example
/*
 {
 bp: 1024,
 mobile: {
 sticky: '.tt-header__nav',
 limit: 400,
 fade: true,
 duration: 400
 },
 desktop: {
 sticky: '.tt-header__menu',
 height: 60,
 move: [
 {
 elem: '.tt-header__sidebar',
 to: '.tt-header__menu',
 method: 'append'
 }
 ]
 }
 }

 //params info
 bp - responsive breakpoint (number)
 mobile, desktop - breakpoint params (object)
 bp.sticky - sticky element (selector)
 bp.limit - breakpoint to start sticky (number, 'bottom')
 bp.height - change sticky element height (number)
 bp.fade - fade effect (bool)
 bp.duration - effects duration (number)
 bp.move - move elements inside sticky (array of objects)
 bp.move.elem - items that are moved (selector)
 bp.move.to - element to which to move (selector)
 bp.move.method - jquery method move (string)
 */

theme.Loader = function() {

    function Loader() {
        this.$loader = $('#theme-loader .js-loader');
        
        this.load();
    };

    Loader.prototype = $.extend({}, Loader.prototype, {
        load: function () {
            var $loader = $body.find('.js-loader[data-js-page-loader]');

            $loader.on('transitionend', function () {
                $loader.remove();
            }).addClass('animate').removeClass('visible');

            if($loader.css('transition-duration') === '0s') {
                $loader.trigger('transitionend');
            }
        },
        set: function($elem, obj) {
            if(!$elem.find('> .js-loader').length) {
                var $clone = this.$loader.clone(),
                    $spinner = $clone.find('[data-js-loader-spinner]');

                if(obj) {
                    if(obj.bg === false) {
                        $clone.find('[data-js-loader-bg]').remove();
                    }
                    if(obj.spinner === false) {
                        $spinner.remove();
                    }
                    if(obj.fixed === true) {
                        $spinner.addClass('fixed');
                    }
                    if(obj.delay) {
                        $clone.addClass('delay');
                    }
                }

                if($elem.css('position') === 'static') {
                    $elem.addClass('loading-element');
                }

                $elem.append($clone);

                $clone.addClass('animate');

                setTimeout(function () {
                    $spinner.filter('.loader__spinner').addClass('animate');
                    $clone.addClass('visible');
                }, 0);
            }
        },
        unset: function ($elem) {
            $elem.find('> .loader').remove();
            $elem.removeClass('loading-element');
        }
    });

    theme.Loader = new Loader;
};

theme.Popups = function() {

    function Popups() {
        this.selectors = {
            popup: '.js-popup',
            button: '.js-popup-button',
            button_close: '[data-js-popup-close]',
            bg: '[data-js-popup-bg]'
        };

        this.load();
    };

    Popups.prototype = $.extend({}, Popups.prototype, {
        load: function() {
            if($(this.selectors.popup).length) {
                var _ = this;

                $body.on('click', this.selectors.button, function(e) {
                    var $this = $(this),
                        name = $this.attr('data-js-popup-button');

                    if(_.callByName(name, $this)) {
                        e.preventDefault();
                        return false;
                    }
                });

                $body.on('click', this.selectors.button_close, function(e) {
                    var $this = $(this),
                        name = $this.parents('[data-js-popup-name]').attr('data-js-popup-name');

                    _.closeByName(name, $this);

                    e.preventDefault();
                    return false;
                });

                $body.on('click', this.selectors.popup + ' [data-js-popup-name]', function(e) {
                    var $t = $(e.target);

                    if($t[0].hasAttribute('data-js-popup-name')) {
                        var name = $t.attr('data-js-popup-name');

                        _.closeByName(name, $t);
                    }
                });

                setTimeout(function() {
                    $body.find(_.selectors.popup + ' [data-js-auto-call="true"]').each(function() {
                        _.callByName($(this).attr('data-js-popup-name'));
                    });
                }, 0);
            }
        },
        getByName: function(name) {
            var $popup = $(this.selectors.popup),
                $content = $popup.find('[data-js-popup-name="' + name + '"]');

            return $content;
        },
        callByName: function(name, $target) {
            var _ = this,
                $popup = $(this.selectors.popup),
                $bg = $(this.selectors.bg),
                $content = $popup.find('[data-js-popup-name="' + name + '"]'),
                is_ajax = $content.attr('data-js-popup-ajax') !== undefined ? true : false;

            if($content.length) {
                if(theme.current.is_desktop && $content[0].hasAttribute('data-js-popup-mobile-only')) {
                    return false;
                }

                function onCall() {
                    $popup.scrollTop(0);

                    $bg.one('transitionend', function () {
                        $content.add($bg).removeClass('animate');

                        $content.trigger('call.after', [$content, $target ? $target : null]);
                    });

                    $content.add($bg).addClass('animate');

                    setTimeout(function () {
                        $content.add($bg).addClass('visible');

                        if($bg.css('transition-duration') === '0s') {
                            $bg.trigger('transitionend');
                        }
                    }, 0);

                    if($content[0].hasAttribute('data-js-popup-mobile-only')) {
                        $window.on('theme.changed.breakpoint.popups', function() {
                            if(!theme.current.is_mobile) {
                                _.closeByName(name);
                            }
                        });
                    }
                };

                $bg.unbind('transitionend');

                $content.trigger('call.before', [$content, $target ? $target : null]);

                $popup.addClass('active');

                $popup.find('[data-js-popup-name]').removeClass('show visible');
                $popup.add($content).addClass('show');

                theme.Global.fixBody();

                if(is_ajax) {
                    $content.addClass('is-process-loading');

                    theme.Loader.set($popup, {
                        fixed: true,
                        delay: true
                    });

                    $content.on('contentloaded', function () {
                        $content.removeClass('is-process-loading');

                        onCall();

                        theme.Loader.unset($popup);
                    });
                } else {
                    onCall();
                }

                $body.on('keyup.popups', function(e) {
                    if(e.keyCode === 27) {
                        _.closeAll();
                    }
                });

                $content.trigger('call.visible', [$content, $target ? $target : null]);

                return true;
            } else {
                return false;
            }
        },
        closeByName: function(name, $target) {
            var $popup = $(this.selectors.popup),
                $bg = $(this.selectors.bg),
                $content = $popup.find('[data-js-popup-name="' + name + '"]'),
                duration = $bg.css('transition-duration');

            if($content.length) {
                $content.unbind('contentloaded').removeClass('is-process-loading');
                $bg.unbind('transitionend');
                $body.unbind('keyup.popups');
                $window.unbind('theme.changed.breakpoint.popups');

                $content.trigger('close.before', [$content, $target ? $target : null]);

                theme.Loader.unset($popup);

                $bg.one('transitionend', function () {
                    $popup.add($content).removeClass('show');
                    $content.add($bg).removeClass('animate');

                    theme.Global.unfixBody();

                    $popup.removeClass('active');

                    $content.trigger('close.after', [$content, $target ? $target : null]);
                });

                $content.add($bg).addClass('animate');

                if(!$bg.hasClass('visible') || $bg.css('transition-duration') === '0s') {
                    $bg.trigger('transitionend');
                }

                $content.add($bg).removeClass('visible');

                return true;
            } else {
                return false;
            }
        },
        closeAll: function() {
            var _ = this,
                $popup = $(this.selectors.popup + '.active'),
                $content = $popup.find('[data-js-popup-name]').filter('.show, .is-process-loading');
            
            if($content.length) {
                $content.each(function () {
                    _.closeByName($content.attr('data-js-popup-name'));
                });

                return true;
            } else {
                return false;
            }
        },
        cartItemAdded: function(title) {
            alert(theme.strings.general.popups.cart.item_added.replace('{{ title }}', title));
        },
        cartLimitIsExceeded: function(limit) {
            alert(theme.strings.general.popups.cart.limit_is_exceeded.replace('{{ limit }}', limit));
        },
        addHandler: function(name, event, func) {
            $body.on(event, '[data-js-popup-name="' + name + '"]', function(e, $popup, $target) {
                func($popup, $target);
            });
        },
        removeHandler: function(name, event) {
            $body.unbind(event);
        }
    });

    theme.Popups = new Popups;
};



theme.PopupAccount = function() {

    function PopupAccount() {
        this.settings = {
            popup_name: 'account'
        };

        this.selectors = {
            account: '.js-popup-account',
            show_sign_up: '.js-popup-account-show-sign-up'
        };

        this.load();
    };

    PopupAccount.prototype = $.extend({}, PopupAccount.prototype, {
        load: function() {
            var _ = this;

            $body.on('click', this.selectors.show_sign_up, function(e) {
                var $account = $(_.selectors.account);

                $account.find('.popup-account__login').addClass('d-none-important');
                $account.find('.popup-account__sign-up').removeClass('d-none-important');

                e.preventDefault();
                return false;
            });

            theme.Popups.addHandler(_.settings.popup_name, 'close.after', function() {
                var $account = $(_.selectors.account);

                $account.find('.popup-account__login').removeClass('d-none-important');
                $account.find('.popup-account__sign-up').addClass('d-none-important');
            });
        }
    });

    theme.PopupAccount = new PopupAccount;
};



theme.PopupSearch = function() {

    function PopupSearch() {
        this.settings = {
            popup_name: 'navigation'
        };

        this.selectors = {
            search: '.js-popup-search-ajax'
        };

        this.load();
    };

    PopupSearch.prototype = $.extend({}, PopupSearch.prototype, {
        load: function() {
            var _ = this,
                q = '',
                ajax;

            function resultToHTML($search, $results, data) {
                if(data.count > 0) {
                    var $template = $($('#template-search-ajax')[0].content),
                        $fragment = $(document.createDocumentFragment()),
                        limit = +$search.attr('data-js-max-products') - 1;

                    $.each(data.results, function(i) {
                        var $item = $template.clone(),
                            $image = $item.find('.product-search__image img'),
                            $title = $item.find('.product-search__title a'),
                            $price = $item.find('.product-search__price .price'),
                            $links = $item.find('a');

                        $links.attr('href', this.url);
                        $title.html(this.title);
                        $image.attr('src', this.thumbnail).attr('srcset', this.thumbnail + ' 1x, ' + this.thumbnail2x + ' 2x').removeAttr('data-src data-srcset');

                        if(this.price) {
                            theme.ProductCurrency.setPrice($price, this.price, this.compare_at_price);
                        } else {
                            $price.remove();
                        }

                        $fragment.append($item);

                        return i < limit;
                    });

                    $results.html('');
                    $results.append($fragment);

                    theme.ProductCurrency.update();
                } else {
                    $results.html('');
                }

                $results[data.count > 0 ? 'removeClass' : 'addClass']('d-none-important');
            };

            function processResult($search, $content, q, data) {
                var $results = $search.find('.search__result'),
                    $view_all = $search.find('.search__view-all'),
                    $button_view_all = $view_all.find('a'),
                    $empty_result = $search.find('.search__empty'),
                    $menu_mobile = $('[data-js-menu-mobile]'),
                    $navigation = $('[data-js-popup-navigation-button]'),
                    navigation_button_status = q === '' ? 'close' : 'search';

                $button_view_all.attr('href', '/search?q=' + q);
                $view_all[data.count > 0 ? 'removeClass' : 'addClass']('d-none-important');
                $empty_result[q === '' || data.count > 0 ? 'addClass' : 'removeClass']('d-none-important');
                $menu_mobile[q === '' ? 'removeClass' : 'addClass']('d-none-important');

                $navigation.attr('data-js-popup-navigation-button', navigation_button_status);

                theme.Menu.closeMobileMenu();

                $results.addClass('invisible');

                resultToHTML($search, $results, data);

                $results.removeClass('invisible');

                theme.Loader.unset($search);
            };

            $body.on('keyup', this.selectors.search + ' input', $.debounce(500, function (e) {
                var $search = $(this).parents(_.selectors.search);

                if(e.keyCode !== 27) {
                    var $this = $(this),
                        value = $this.val(),
                        $content = $search.find('.search__content');

                    if(value !== q) {
                        q = value;

                        if(q === '') {
                            processResult($search, $content, q, { count: 0 });
                        } else {
                            if (ajax) {
                                ajax.abort();
                            }

                            theme.Loader.set($search);

                            ajax = $.getJSON({
                                url: '/search',
                                type: 'POST',
                                data: { q: q, view: 'json'},
                                success: function (data) {
                                    processResult($search, $content, q, data);
                                }
                            });
                        }
                    }
                }
            }));

            function clear() {
                var $search = $(_.selectors.search),
                    $content = $search.find('.search__content');

                q = '';

                $search.find('input').val('');
                processResult($search, $content, q, { count: 0 });
            };

            $body.on('keyup', this.selectors.search + ' input', function(e) {
                if(e.keyCode === 27) {
                    var $search = $(this).parents(_.selectors.search),
                        $content = $search.find('.search__content');

                    q = '';

                    theme.Popups.closeByName('navigation');
                    processResult($search, $content, q, { count: 0 });
                }
            });

            theme.Popups.addHandler(this.settings.popup_name, 'close.before', function() {
                clear();
            });

            theme.Popups.addHandler(this.settings.popup_name, 'call.after', function($content) {
                if(theme.current.is_desktop) {
                    $content.find('input').focus();
                }
            });

            theme.Global.responsiveHandler({
                namespace: '.searchMobileBack',
                element: $body,
                delegate: '[data-js-popup-navigation-button="search"]',
                on_mobile: true,
                events: {
                    'click': function() {
                        clear();
                    }
                }
            });
        }
    });

    theme.PopupSearch = new PopupSearch;
};



theme.PopupCart = function() {

    function PopupCart() {
        this.settings = {
            popup_name: 'cart'
        };

        this.selectors = {
            cart: '.js-popup-cart-ajax'
        };

        this.load();
    };

    PopupCart.prototype = $.extend({}, PopupCart.prototype, {
        load: function() {
            var _ = this;

            theme.Popups.addHandler(this.settings.popup_name, 'call.visible', function($popup, $target) {
                _.update(function () {
                    $popup.trigger('contentloaded');
                });
            });
        },
        _resultToHTML: function($items, data) {
            var $template = $($('#template-cart-ajax')[0].content),
                $fragment = $(document.createDocumentFragment());

            $.each(data.items, function(i) {
                var $item = $template.clone(),
                    $product = $item.find('.product-cart'),
                    $image = $item.find('.product-cart__image img'),
                    $title = $item.find('.product-cart__title a'),
                    $variant = $item.find('.product-cart__variant'),
                    $price = $item.find('.product-cart__price .price'),
                    $quantity = $item.find('.product-cart__quantity'),
                    $remove = $item.find('.product-cart__remove'),
                    $links = $item.find('a').not('.product-cart__remove');

                $product.attr('data-product-variant-id', this.variant_id);
                $links.attr('href', this.url);
                $title.html(this.product_title);
                $image.attr('src', Shopify.resizeImage(this.image, '100x')).attr('srcset', Shopify.resizeImage(this.image, '100x') + ' 1x, ' + Shopify.resizeImage(this.image, '100x@2x') + ' 2x').removeAttr('data-src data-srcset');
                $quantity.html(this.quantity);
                $remove.attr('href', '/cart/change?line=' + (i + 1) + '&amp;quantity=0');

                if(this.variant !== 'Default variant') {
                    $variant.html(this.variant_title).removeClass('d-none-important');
                }

                theme.ProductCurrency.setPrice($price, this.price);

                $fragment.append($item);
            });

            $items.html('');
            $items.append($fragment);
        },
        update: function(callback) {
            var _ = this;

            if (this.ajax) {
                this.ajax.abort();
            }

            this.ajax = $.getJSON("/cart.js", function (data) {
                var $cart = $(_.selectors.cart),
                    $content = $cart.find('.popup-cart__content'),
                    $empty = $cart.find('.popup-cart__empty'),
                    $items = $cart.find('.popup-cart__items'),
                    $count = $cart.find('[data-js-popup-cart-count]'),
                    $subtotal = $cart.find('[data-js-popup-cart-subtotal]');

                $count.html(theme.strings.general.popups.cart.count.replace('{{ count }}', data.item_count));
                $content[data.item_count > 0 ? 'removeClass' : 'addClass']('d-none-important');
                $empty[data.item_count > 0 ? 'addClass' : 'removeClass']('d-none-important');

                if(data.item_count > 0) {
                    theme.ProductCurrency.setPrice($subtotal, data.total_price);

                    _._resultToHTML($items, data);

                    theme.ProductCurrency.update();
                } else {
                    $items.add($subtotal).html('');
                }

                if(callback) {
                    callback();
                }
            });
        }
    });

    theme.PopupCart = new PopupCart;
};



theme.PopupSubscription = function() {

    function PopupSubscription() {
        this.settings = {
            popup_name: 'subscription'
        };

        this.selectors = {
            popup: '.popup-subscription'
        };

        this.load();
    };

    PopupSubscription.prototype = $.extend({}, PopupSubscription.prototype, {
        load: function() {
            var $popup = theme.Popups.getByName(this.settings.popup_name);

            if($popup.length) {
                var $subscription = $(this.selectors.popup),
                    cookie = $.cookie('subscription');

                if(cookie !== 'off') {
                    var $dont_show = $subscription.find('[data-js-popup-subscription-dont-show]'),
                        show_once = $subscription.attr('data-js-show-once') || false,
                        delay = +$subscription.attr('data-js-delay') || 3,
                        cookies_life = +$subscription.attr('data-js-cookies-life') || 1;

                    theme.Popups.addHandler(this.settings.popup_name, 'close.after', function() {
                        if(show_once === 'true' || $dont_show.is(':checked')) {
                            var date = new Date(),
                                timer = 24 * 60 * 60 * 1000 * cookies_life;

                            date.setTime(date.getTime() + timer);

                            $.cookie('subscription', 'off', {
                                expires: date,
                                path: '/'
                            });
                        }
                    });

                    setTimeout(function () {
                        theme.Popups.callByName('subscription');
                    }, delay * 1000);
                }
            }
        }
    });

    theme.PopupSubscription = new PopupSubscription;
};



theme.PopupQuickView = function() {

    function PopupQuickView() {
        this.settings = {
            popup_name: 'quick-view'
        };

        this.load();
    };

    PopupQuickView.prototype = $.extend({}, PopupQuickView.prototype, {
        load: function() {
            var _ = this;

            theme.Popups.addHandler(this.settings.popup_name, 'call.visible', function($popup, $target) {
                var $content = $popup.find('[data-js-quick-view]'),
                    $product = $target.parents('[data-js-product]');

                $content.html('');
                _.$gallery = null;

                _.getProduct($product, function (data) {
                    _.insertContent($content, data);

                    $popup.trigger('contentloaded');
                });
            });

            theme.Popups.addHandler(this.settings.popup_name, 'call.after', function($popup) {
                if(_.$gallery && _.$gallery.length) {
                    _.$gallery.productGallery('update');
                }

                theme.Tooltip.init({
                    appendTo: $popup[0]
                });
            });

            theme.Popups.addHandler(this.settings.popup_name, 'close.after', function() {
                if (_.ajax) {
                    _.ajax.abort();
                }

                if(_.$gallery && _.$gallery.length) {
                    theme.ProductGallery.destroy(_.$gallery);
                    _.$gallery = null;
                }
            });
        },
        getProduct: function ($product, success) {
            if (this.ajax) {
                this.ajax.abort();
            }

            var handle = $product.attr('data-product-handle'),
                variant = $product.attr('data-product-variant-id');

            if(handle) {
                this.ajax = $.ajax({
                    type: 'GET',
                    url: 'https://' + window.location.hostname + '/products/' + handle + '?variant=' + variant,
                    data: {
                        view: 'quick-view'
                    },
                    cache: false,
                    dataType: 'html',
                    success: function (data) {
                        success(data);
                    }
                });
            }
        },
        insertContent: function ($content, data) {
            $content.html(data);

            var $product = $content.find('[data-js-product]'),
                $gallery = $product.find('[data-js-product-gallery]'),
                $countdown = $product.find('[data-js-product-countdown] .js-countdown'),
                $text_countdown = $product.find('.js-text-countdown'),
                $visitors = $product.find('.js-visitors');

            if($gallery.length) {
                this.$gallery = $gallery;

                theme.ProductGallery.init($gallery);
            }

            theme.ProductReview.update();

            if($countdown.length) {
                theme.ProductCountdown.init($countdown);
            }

            if($text_countdown.length) {
                theme.ProductTextCountdown.init($text_countdown);
            }
            
            if($visitors.length) {
                theme.ProductVisitors.init($visitors);
            }

            theme.StoreLists.checkProductStatus($product);
        }
    });

    theme.PopupQuickView = new PopupQuickView;
};



theme.Notifications = function() {

    function Notifications() {
        this.selectors = {
            elems: '.js-notification'
        };

        this.settings = {
            close_limit: 40,
            translate_limit: 50,
            opacity_limit: 0.4
        };

        this.load();
    };

    Notifications.prototype = $.extend({}, Notifications.prototype, {
        load: function() {
            var _ = this,
                dif;

            $body.on('mousedown', this.selectors.elems, function(e) {
                if(e.target.tagName === 'A' || $(e.target).parents('[data-js-action]').length) {
                    return;
                }

                _.is_holded = true;

                var $this = $(this),
                    start_posX = e.screenX;

                dif = 0;

                $this.addClass('animate');
                setTimeout(function () {
                    $this.addClass('pressed');
                }, 0);

                $body.on('mousemove.notification', function(e) {
                    var posX = e.screenX,
                        set_posX = Math.min(start_posX + _.settings.translate_limit, Math.max(start_posX - _.settings.translate_limit, posX));

                    dif = set_posX - start_posX;

                    $this.removeClass('animate');

                    setTimeout(function () {
                        $this.css({
                            transform: 'translateX(' + dif + 'px) scale(0.95)',
                            opacity: Math.max((_.settings.translate_limit - Math.abs(dif)) / _.settings.translate_limit, _.settings.opacity_limit)
                        });
                    }, 0);

                    setTimeout(function () {
                        $this.addClass('animate');
                    }, 0);
                });

                $body.one('mouseup.notification', function() {
                    $this.trigger('mouseup');
                });

                e.preventDefault();
                return false;
            });

            $body.on('mouseup', this.selectors.elems, function() {
                var $this = $(this);

                _.is_holded = false;
                
                $body.unbind('mousemove.notification mouseup.notification');

                setTimeout(function () {
                    if(Math.abs(dif) > _.settings.close_limit) {
                        var $notification = $this.find('[data-js-notification-inner]'),
                            $btn_close = $notification.find('[data-js-action="close"]').first();

                        if($notification.hasClass('d-none')) {
                            return;
                        }

                        $this.one('transitionend', function() {
                            dif = 0;

                            $this.trigger('mouseup').trigger('transitionend');

                            $btn_close.trigger('click');
                            $notification.trigger('transitionend');

                            $this.trigger('onpressedend');
                        });

                        $this.css({
                            transform: 'translateX(' + (dif + 20) + 'px) scale(0.95)',
                            opacity: 0
                        });
                    } else {
                        $this.removeClass('pressed');

                        $this.one('transitionend' ,function () {
                            $this.removeClass('animate');
                            $this.trigger('onpressedend');
                        });

                        $this.css({
                            transform: '',
                            opacity: ''
                        });
                    }

                    if($this.css('transition-duration') === '0s') {
                        $this.trigger('transitionend');
                    }
                }, 0);
            });

            $body.on('close', this.selectors.elems, function() {
                var $this = $(this);

                $body.unbind('mousemove.notification');
                $this.trigger('mouseup').trigger('transitionend');
            });
        },
        _cookies: function($container) {
            var _ = this,
                $notification = $container.find('.js-notification-cookies');

            if($notification.length) {
                var $btn_close = $notification.find('[data-js-action="close"]'),
                    cookie = $.cookie('notification-cookies'),
                    show_once = $notification.attr('data-js-show-once'),
                    delay = +$notification.attr('data-js-delay'),
                    cookies_life = +$notification.attr('data-js-cookies-life');

                if(cookie !== 'off') {
                    setTimeout(function () {
                        _._show($notification, function () {
                            $btn_close.one('click', function() {
                                if(show_once === 'true') {
                                    var date = new Date(),
                                        timer = 24 * 60 * 60 * 1000 * cookies_life;

                                    date.setTime(date.getTime() + timer);

                                    $.cookie('notification-cookies', 'off', {
                                        expires: date,
                                        path: '/'
                                    });
                                }

                                $(this).off();

                                _._hide($notification, function () {
                                    $notification.remove();
                                });
                            });
                        });
                    }, delay * 1000);
                }

                return $btn_close;
            }
        },
        _products: function($container) {
            var _ = this,
                $notification = $container.find('.js-notification-products');

            if(!$notification.length) {
                return;
            }

            var $btns_close = $notification.find('[data-js-action="close"]'),
                $items = $notification.find('[data-js-notification-products-item]'),
                delay = +$notification.attr('data-js-delay'),
                interval_min = +$notification.attr('data-js-interval-min'),
                interval_max = +$notification.attr('data-js-interval-max'),
                max_time_life = +$notification.attr('data-js-max-time-life'),
                $current_item,
                $image,
                $image_preload,
                image_src,
                interval_random,
                max_time_life_interval;

            function randomInteger(min, max) {
                return Math.round(min - 0.5 + Math.random() * (max - min + 1));
            };

            function hide() {
                _._hide($notification, function () {
                    autoplay();
                });
            };

            function autoplay() {
                clearInterval(max_time_life_interval);
                if(!$notification.hasClass('d-none') || _.is_holded) {
                    if(_.is_holded) {
                        $notification.parents('.js-notification').one('onpressedend', function() {
                            hide();
                        });
                    } else if($notification.is(':hover')) {
                        $notification.one('mouseleave', function() {
                            hide();
                        });
                    } else {
                        hide();
                    }
                } else {
                    $current_item = $items.eq(randomInteger(0, $items.length - 1));
                    $image = $current_item.find('[ data-js-notification-products-item-image]');
                    interval_random = randomInteger(interval_min, interval_max);

                    $items.addClass('d-none');
                    $current_item.removeClass('d-none');

                    _._show($notification, function () {
                        setTimeout(function () {
                            autoplay();
                        }, interval_random * 1000);

                        if(max_time_life !== 0) {
                            max_time_life_interval = setTimeout(function () {
                                _._hide($notification);
                            }, max_time_life * 1000);
                        }
                    }, function(onVisible) {
                        if(!$image[0].hasAttribute('style')) {
                            $image_preload = $('<img>');

                            $image_preload.appendTo($image);

                            image_src = $image.attr('data-image-src');

                            $image_preload.one('load', function () {
                                $image.css({
                                    'background-image': 'url(' + image_src + ')'
                                });

                                onVisible();
                            });

                            $image_preload.attr('src', image_src);
                        } else {
                            onVisible();
                        }
                    });
                }
            };

            setTimeout(function () {
                autoplay();
            }, delay * 1000);

            $btns_close.on('click', function() {
                _._hide($notification);
            });

            return $btns_close;
        },
        _show: function ($notification, callback, beforeShow) {
            $notification.unbind('transitionend');

            if(callback) {
                $notification.one('transitionend', function () {
                    callback();
                });
            }

            $notification.removeClass('d-none');
            $notification.addClass('animate');

            function onVisible() {
                setTimeout(function () {
                    $notification.addClass('visible');
                }, 0);

                if($notification.css('transition-duration') === '0s') {
                    $notification.trigger('transitionend');
                }
            };

            if(beforeShow) {
                beforeShow(onVisible);
            } else {
                onVisible();
            }
        },
        _hide: function ($notification, callback) {
            $notification.unbind('transitionend');

            $notification.one('transitionend', function () {
                $notification.addClass('d-none').removeClass('animate').removeAttr('style');

                $notification.parents('.js-notification').trigger('close');

                if(callback) {
                    callback();
                }
            });

            $notification.removeClass('visible');

            if($notification.css('transition-duration') === '0s') {
                $notification.trigger('transitionend');
            }
        },
        init: function ($container) {
            this._products($container);
            this._cookies($container);
        },
        destroy: function ($container) {
            $container.find('.js-notification-cookies, .js-notification-products').find('[data-js-action="close"]').off();
        }
    });

    theme.Notifications = new Notifications;
};
theme.ProductFootbar = function() {

    function ProductFootbar() {

    };

    ProductFootbar.prototype = $.extend({}, ProductFootbar.prototype, {
        duration: function () {
            return theme.animations.footbar_product.duration * 1000;
        },
        init: function($container) {
            var _ = this,
                $footbar = $container.find('.js-footbar-product'),
                $limit = $('[data-js-footbar-product-limit]');

            if($footbar.length && $limit.length) {
                $window.on('theme.resize.productFootbar scroll.productFootbar', function () {
                    _._update($footbar, $limit);
                });

                this._update($footbar, $limit);
            }
        },
        _update: function ($footbar, $limit) {
            var limit = $limit[0].getBoundingClientRect(),
                topSpacing = theme.StickyHeader.$sticky ? theme.StickyHeader.$sticky.stickyHeader('getStickyHeight') : 0;

            if(limit.top < topSpacing && !$footbar.hasClass('show')) {
                $footbar.addClass('show animate');

                $footbar.velocity('stop', true);

                $footbar.velocity('slideDown', {
                    duration: this.duration(),
                    begin: function () {
                        setTimeout(function () {
                            $footbar.addClass('visible');
                        }, 0);
                    },
                    complete: function () {
                        $footbar.removeAttr('style');
                    }
                });
            } else if(limit.top >= topSpacing && $footbar.hasClass('visible')) {
                $footbar.velocity('stop', true);

                $footbar.velocity('slideUp', {
                    duration: this.duration(),
                    begin: function () {
                        $footbar.removeClass('visible');
                    },
                    complete: function () {
                        $footbar.removeClass('show animate').removeAttr('style');
                    }
                });
            }
        },
        destroy: function () {
            $window.unbind('theme.resize.productFootbar scroll.productFootbar');
        }
    });

    theme.ProductFootbar = new ProductFootbar;
};
theme.ProductCurrency = function() {

    function ProductCurrency() {

    };

    ProductCurrency.prototype = $.extend({}, ProductCurrency.prototype, {
        load: function() {
            if(theme.multipleСurrencies) {
                var cookieCurrency;

                try {
                    cookieCurrency = Currency.cookie.read();
                } catch(err) {}

                $('span.money span.money').each(function () {
                    $(this).parents('span.money').removeClass('money');
                });

                $('span.money').each(function () {
                    $(this).attr('data-currency-' + Currency.shopCurrency, $(this).html());
                });

                if (cookieCurrency == null) {
                    if (Currency.shopCurrency !== Currency.defaultCurrency) {
                        Currency.convertAll(Currency.shopCurrency, Currency.defaultCurrency);
                    } else {
                        Currency.currentCurrency = Currency.defaultCurrency;
                    }
                } else if (cookieCurrency === Currency.shopCurrency) {
                    Currency.currentCurrency = Currency.shopCurrency;
                } else {
                    Currency.convertAll(Currency.shopCurrency, cookieCurrency);
                }
            }
        },
        setCurrency: function(newCurrency) {
            if(theme.multipleСurrencies) {
                if (newCurrency == Currency.currentCurrency) {
                    Currency.convertAll(Currency.shopCurrency, newCurrency);
                } else {
                    Currency.convertAll(Currency.currentCurrency, newCurrency);
                }
            }
        },
        setPrice: function($price, price, compare_at_price) {
            price = +price;
            compare_at_price = +compare_at_price;

            var html = '',
                sale = compare_at_price && compare_at_price > price;

            $price[sale ? 'addClass' : 'removeClass']('price--sale');

            if(sale) {
                html += '<span>';
                html += Shopify.formatMoney(compare_at_price, theme.moneyFormat);
                html += '</span>';

                if($price[0].hasAttribute('data-js-show-sale-separator')) {
                    html += theme.strings.priceSaleSeparator;
                }
            }

            html += '<span>';
            html += Shopify.formatMoney(price, theme.moneyFormat);
            html += '</span>';

            $price.html(html);
        },
        update: function() {
            if(theme.multipleСurrencies) {
                Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency);
            }
        }
    });

    theme.ProductCurrency = new ProductCurrency;
};
theme.ProductQuantity = function() {

    function ProductQuantity() {
        this.selectors = {
            quantity: '.js-product-quantity'
        };

        this.load();
    };

    ProductQuantity.prototype = $.extend({}, ProductQuantity.prototype, {
        load: function() {
            var _ = this;

            $body.on('click', this.selectors.quantity + ' [data-control]', function(e) {
                var $this = $(this),
                    $quantity = $this.parents(_.selectors.quantity),
                    $input = $quantity.find('input'),
                    direction = $this.attr('data-control'),
                    min = $input.attr('min') || 1,
                    max = $input.attr('max') || Infinity,
                    val = +$input.val(),
                    set_val;

                if(!$.isNumeric(val)) {
                    $input.val(min);
                    return;
                }

                if(direction === '+') {
                    set_val = ++val;
                } else if(direction === '-') {
                    set_val = --val;
                }

                if(set_val < min) {
                    set_val = min;
                } else if(set_val > max) {
                    set_val = max;
                }

                if(set_val < 0) {
                    set_val = 0;
                }

                $input.val(set_val);
                $input.trigger('custom.change');

                _.dublicate($quantity);
            });

            $(document).on('keydown', this.selectors.quantity + ' input', function (e) {
                var keyArr = [8, 9, 27, 37, 38, 39, 40, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];

                if($.inArray(e.keyCode, keyArr) === -1) {
                    e.preventDefault();
                    return false;
                }
            });

            $(document).on('focus', this.selectors.quantity + ' input', function () {
                $(this).select();
            });

            $(document).on('blur', this.selectors.quantity + ' input', function () {
                var $this = $(this),
                    $quantity = $this.parents(_.selectors.quantity),
                    val = +$this.val(),
                    min = $this.attr('min') || 1,
                    max = $this.attr('max') || Infinity;

                if(!$.isNumeric(val) || val < min) {
                    $this.val(min);
                } else if(val > max) {
                    $this.val(max);
                }

                _.dublicate($quantity);
            });
        },
        dublicate: function ($quantity) {
            var connect = $quantity.attr('data-js-quantity-connect');

            if($quantity.length && connect !== undefined) {
                var $input = $(this.selectors.quantity + '[data-js-quantity-connect="' + connect + '"]').find('input'),
                    value = $quantity.find('input').val();

                $input.val(value);
                $input.trigger('custom.change');
            }
        }
    });

    theme.ProductQuantity = new ProductQuantity;
};
theme.ProductCountdown = function() {

    function ProductCountdown() {
        this.selectors = {

        };

        this.load();
    };

    ProductCountdown.prototype = $.extend({}, ProductCountdown.prototype, {
        load: function() {
            this.init($('.js-countdown').not('.countdown--init'));
        },
        init: function($elems) {
            var $countdown = $elems.not('.countdown--init');

            $countdown.each(function () {
                var $this = $(this),
                    date = $this.data('date');

                if(!date) {
                    return;
                }

                var hideZero = $this.data('hidezero') || true;

                //remove timezone
                var remove_from = date.indexOf(' +');

                if(remove_from != -1) {
                    date = date.slice(0, remove_from);
                }
                //END:remove timezone

                var date_obj = new Date(date.replace(/-/g, "/"));

                if(date_obj.getTime() - new Date().getTime() <= 0) return;

                var t = $this.countdown(date_obj, function (e) {
                    var format = '',
                        structure = [
                            ['totalDays', theme.strings.countdown.days],
                            ['hours', theme.strings.countdown.hours],
                            ['minutes', theme.strings.countdown.minutes],
                            ['seconds', theme.strings.countdown.seconds]
                        ];

                    for(var i = 0; i < structure.length; i++) {
                        var prop = structure[i][0],
                            time = e.offset[prop],
                            postfix = structure[i][1];

                        if (i === 0 && time === 0 && hideZero === true) {
                            continue;
                        }

                        if($this.hasClass('countdown--type-01')) {
                            format += '<span class="countdown__section">' +
                                '<span class="countdown__time">' + time + '</span>' +
                                '<span class="countdown__postfix">' + postfix + '</span>' +
                                '</span>';

                        } else if($this.hasClass('countdown--type-02')) {
                            if(time < 10) time = '0' + time;
                            else time += '';
                            
                            format += '<span class="countdown__section">' +
                                '<span class="countdown__time">';

                            for(var j = 0; j < time.length; j++) {
                                format += '<span>' + time.charAt(j) + '</span>';
                            }

                            format += '</span>' +
                                '<span class="countdown__postfix">' + postfix + '</span>' +
                                '</span>';
                        }
                    }

                    $(this).html(format);
                });

                $this.addClass('countdown--init');
            });
        },
        destroy: function($countdown) {
            if($countdown.hasClass('countdown--init')) {
                $countdown.countdown('remove').off().removeClass('countdown--init').html('');
            }
        },
        reinit: function($countdown, date) {
            this.destroy($countdown);

            var $new_countdown = $countdown.clone();

            $countdown.replaceWith($new_countdown);

            $countdown.remove();

            if(date) {
                $new_countdown.attr('data-date', date);
            }

            this.init($new_countdown);
        }
    });

    theme.ProductCountdown = new ProductCountdown;
};
theme.ProductTextCountdown = function() {

    function ProductTextCountdown() {
        this.selectors = {

        };

        this.load();
    };

    ProductTextCountdown.prototype = $.extend({}, ProductTextCountdown.prototype, {
        load: function() {
            this.init($('.js-text-countdown').not('.text-countdown--init'));
        },
        init: function($elems) {
            var $countdown = $elems.not('.text-countdown--init');

            $countdown.each(function () {
                var $this = $(this),
                    $counter = $this.find('[data-js-text-countdown-counter]'),
                    $date = $this.find('[data-js-text-countdown-delivery]'),
                    reset_time = +$this.attr('data-reset-time'),
                    delivery_time = +$this.attr('data-delivery-time'),
                    hideZero = $this.attr('data-hidezero') || true,
                    date_counter = new Date(),
                    structure = [
                        ['hours', theme.strings.text_countdown.hours],
                        ['minutes', theme.strings.text_countdown.minutes]
                    ],
                    days_of_week = [
                        theme.strings.text_countdown.days_of_week.sunday,
                        theme.strings.text_countdown.days_of_week.monday,
                        theme.strings.text_countdown.days_of_week.tuesday,
                        theme.strings.text_countdown.days_of_week.wednesday,
                        theme.strings.text_countdown.days_of_week.thursday,
                        theme.strings.text_countdown.days_of_week.friday,
                        theme.strings.text_countdown.days_of_week.saturday
                    ],
                    date_now,
                    date_delivery,
                    delivery_html,
                    format,
                    prop,
                    time,
                    postfix;

                date_counter.setDate(date_counter.getDate() + 1);
                date_counter.setHours(reset_time, 0, 0, 0);

                var t = $counter.countdown(date_counter, function (e) {
                    format = '';
                    delivery_html = '';

                    for(var i = 0; i < structure.length; i++) {
                        prop = structure[i][0];
                        time = e.offset[prop];
                        postfix = structure[i][1];

                        if (i === 0 && time === 0 && hideZero === true) {
                            continue;
                        }

                        if(i !== 0) {
                            format += ' ';
                        }

                        format += time + ' ' + postfix;
                    }

                    $(this).html(format);

                    date_delivery = new Date();
                    date_delivery.setDate(date_delivery.getDate() + delivery_time);

                    date_now = new Date();

                    if(date_now.getHours() >= date_counter.getHours() && date_now.getMinutes() >= date_counter.getMinutes() && date_now.getSeconds() >= date_counter.getSeconds()) {
                        date_delivery.setDate(date_delivery.getDate() + 1);
                    }

                    delivery_html += days_of_week[date_delivery.getDay()];
                    delivery_html += ' ';
                    delivery_html += ('0' + date_delivery.getDate()).slice(-2) + '/' + ('0' + (date_delivery.getMonth() + 1)).slice(-2) + '/' + date_delivery.getFullYear();

                    $date.html(delivery_html);
                });

                $this.addClass('text-countdown--init');
            });
        },
        destroy: function($countdown) {
            if($countdown.hasClass('text-countdown--init')) {
                $countdown.countdown('remove').off().removeClass('text-countdown--init').html('');
            }
        }
    });

    theme.ProductTextCountdown = new ProductTextCountdown;
};
theme.ProductVisitors = function() {

    function ProductVisitors() {
        this.selectors = {

        };

        this.load();
    };

    ProductVisitors.prototype = $.extend({}, ProductVisitors.prototype, {
        load: function() {
            this.init($('.js-visitors').not('.visitors--init'));
        },
        init: function($elems) {
            var $countdown = $elems.not('.visitors--init');

            function randomInteger(min, max) {
                return Math.round(min - 0.5 + Math.random() * (max - min + 1));
            };

            $countdown.each(function () {
                var $this = $(this),
                    $counter = $this.find('[data-js-counter]'),
                    min = $this.attr('data-min'),
                    max = $this.attr('data-max'),
                    interval_min = $this.attr('data-interval-min'),
                    interval_max = $this.attr('data-interval-max'),
                    stroke = +$this.attr('data-stroke'),
                    current_value,
                    new_value;

                $this.addClass('visitors--processing');

                function update() {
                    setTimeout(function() {
                        if(!$this.hasClass('visitors--processing')) {
                            return;
                        }

                        current_value = +$counter.text();
                        new_value = randomInteger(min, max);

                        if(Math.abs(current_value - new_value) > stroke) {
                            new_value = new_value > current_value ? current_value + stroke : current_value - stroke;
                            new_value = randomInteger(current_value, new_value);
                        }

                        $counter.text(new_value);

                        update();
                    }, randomInteger(interval_min, interval_max) * 1000);
                };

                update();

                $this.addClass('visitors--init');
            });
        },
        destroy: function($countdown) {
            if($countdown.hasClass('visitors--init')) {
                $countdown.off().removeClass('visitors--processing visitors--init').html('');
            }
        }
    });

    theme.ProductVisitors = new ProductVisitors;
};
theme.ProductImagesNavigation = function() {

    function ProductImagesNavigation() {
        this.selectors = {
            images_nav: '.js-product-images-navigation'
        };

        this.load();
    };

    ProductImagesNavigation.prototype = $.extend({}, ProductImagesNavigation.prototype, {
        load: function() {
            var _ = this;

            $body.on('click', '[data-js-product-images-navigation]:not([data-disabled])', function() {
                var $this = $(this),
                    $product = $this.parents('[data-js-product]'),
                    direction = $this.attr('data-js-product-images-navigation');

                theme.ProductImagesHover.disable($product.find('img'));

                var data = theme.ProductOptions.switchByImage($product, direction, null, function (data) {
                    _._updateButtons($product, data.is_first, data.is_last);
                });
            });
        },
        switch: function($product, data) {
            var $image = $product.find('[data-js-product-image] img');

            if($image.length) {
                theme.ProductImagesHover.disable($image);

                var image = data.update_variant.featured_image;

                if(!image || !image.src) {
                    if(data.json.images[0]) {
                        image = data.json.images[0];
                    }
                }

                if(image && image.src && image.id !== $image.attr('data-image-id')) {
                    var src = Shopify.resizeImage(image.src, data.json.image_size);

                    this.changeSrc($image, src, image.id);

                    if($image.parents(this.selectors.images_nav).length) {
                        this._updateButtons($product, +data.json.images[0].id === +image.id, +data.json.images[data.json.images.length - 1].id === +image.id);
                    }
                }
            }
        },
        changeSrc: function ($image, src, id) {
            var $parent = $image.parent();

            id = id || 'null';

            theme.Loader.set($parent);

            $image.one('load', function () {
                theme.Loader.unset($parent);
            });
            
            $image.attr('srcset', src).attr('src', src).attr('data-image-id', id);
        },
        _updateButtons: function($product, is_first, is_last) {
            $product.find('[data-js-product-images-navigation="prev"]')[is_first ? 'attr' : 'removeAttr']('data-disabled', 'disabled');
            $product.find('[data-js-product-images-navigation="next"]')[is_last ? 'attr' : 'removeAttr']('data-disabled', 'disabled');
        }
    });

    theme.ProductImagesNavigation = new ProductImagesNavigation;
};



theme.ProductImagesHover = function() {

    function ProductImagesHover() {
        this.selectors = {
            images_hover: '.js-product-images-hover'
        };

        this.load();
    };

    ProductImagesHover.prototype = $.extend({}, ProductImagesHover.prototype, {
        load: function() {
            function changeImage($wrap, $image, src, id) {
                $wrap.attr('data-js-product-image-hover', $image.attr('srcset'));
                $wrap.attr('data-js-product-image-hover-id', $image.attr('data-image-id'));

                theme.ProductImagesNavigation.changeSrc($image, src, id);
            };

            theme.Global.responsiveHandler({
                namespace: '.product-collection.images.hover',
                element: $body,
                delegate: this.selectors.images_hover,
                on_desktop: true,
                events: {
                    'mouseenter': function() {
                        var $this = $(this),
                            $image = $this.find('img'),
                            src = $this.attr('data-js-product-image-hover'),
                            id = $this.attr('data-js-product-image-hover-id');

                        if(src) {
                            changeImage($this, $image, src, id);

                            $this.one('mouseleave', function () {
                                var src = $this.attr('data-js-product-image-hover'),
                                    id = $this.attr('data-js-product-image-hover-id');
                                
                                changeImage($this, $image, src, id);
                            });
                        }
                    }
                }
            });
        },
        disable: function ($image) {
            $image.parents(this.selectors.images_hover).removeClass('js-product-images-hover').unbind('mouseleave');
        }
    });

    theme.ProductImagesHover = new ProductImagesHover;
};



theme.ProductOptions = function() {

    function ProductOptions() {
        this.selectors = {
            options: '.js-product-options',
            options_attr: '[data-js-product-options]'
        };

        this.afterChange = [];

        this.load();
    };

    ProductOptions.prototype = $.extend({}, ProductOptions.prototype, {
        load: function() {
            var _ = this,
                timeout,
                xhr;

            function onProcess(e) {
                var $this = $(this);

                if ($this.hasClass('active') || $this.hasClass('disabled')) {
                    return;
                }

                var $options = $this.parents(_.selectors.options),
                    $section = $this.parents('[data-property]'),
                    $values = $section.find('[data-js-option-value]'),
                    $product = $this.parents('[data-js-product]'),
                    json = $product.attr('data-json-product'),
                    current_values = {},
                    update_variant = null,
                    is_avilable = true;

                if(e.type === 'click') {
                    $values.removeClass('active');
                    $this.addClass('active');
                }

                _._loadJSON($product, json, function (json) {
                    var $active_values = $options.find('[data-js-option-value].active').add($options.find('option:selected'));

                    $.each($active_values, function() {
                        var $this = $(this);

                        current_values[$this.parents('[data-property]').data('property')] = '' + $this.data('value');
                    });

                    $.each(json.variants, function() {
                        var variant_values = {},
                            current_variant = true;

                        $.each(this.options, function(i) {
                            variant_values[Shopify.handleize(json.options[i])] = Shopify.handleize(this);
                        });

                        $.each(current_values, function(i) {
                            if(current_values[i] !== variant_values[i]) {
                                current_variant = false;
                                return false;
                            }
                        });

                        if(current_variant && current_values.length === variant_values.length) {
                            update_variant = this;
                            return false;
                        }
                    });

                    if(!update_variant) {
                        update_variant = _._getDefaultVariant(json);
                        is_avilable = false;
                    }

                    _._switchVariant($product, {
                        update_variant: update_variant,
                        json: json,
                        current_values: current_values,
                        is_avilable: is_avilable
                    });
                });
            };

            $body.on('click', this.selectors.options + ' [data-js-option-value]', onProcess);

            $body.on('mouseenter', this.selectors.options + '[data-js-options-onhover] [data-js-option-value]', $.debounce(400, onProcess));

            $body.on('change', '[data-js-option-select]', function (e, onupdate) {
                if(onupdate) {
                    return;
                }
                
                var $this = $(this).find('option:selected');

                onProcess.call($this, e);
            });

            $body.on('change', '[data-js-product-variants="control"]', function () {
                var $this = $(this),
                    $product = $this.parents('[data-js-product]'),
                    id = $this.find('option:selected').attr('value'),
                    json = $product.attr('data-json-product'),
                    update_variant = null,
                    is_avilable = true;

                _._loadJSON($product, json, function (json) {
                    $.each(json.variants, function() {
                        if(+this.id === +id) {
                            update_variant = this;
                            return false;
                        }
                    });

                    if(!update_variant) {
                        update_variant = _._getDefaultVariant(json);
                        is_avilable = false;
                    }
                    
                    _._switchVariant($product, {
                        update_variant: update_variant,
                        json: json,
                        is_avilable: is_avilable,
                        dontUpdateVariantsSelect: true
                    });
                });
            });

            theme.Global.responsiveHandler({
                namespace: '.product.load-json',
                element: $body,
                delegate: '[data-js-product][data-js-product-json-preload]',
                on_desktop: true,
                events: {
                    'mouseenter': function() {
                        var $this = $(this);

                        clearTimeout(timeout);

                        timeout = setTimeout(function () {
                            if(!$this.attr('data-json-product')) {
                                xhr = _._loadJSON($this, null, function() {
                                    xhr = null;
                                }, false);
                            }
                        }, 300);
                    },
                    'mouseleave': function() {
                        clearTimeout(timeout);

                        if(xhr) {
                            xhr.abort();
                            xhr = null;
                        }
                    }
                }
            });
        },
        _loadJSON: function ($product, json, callback, animate) {
            if($product[0].hasAttribute('data-js-process-ajax-loading-json')) {
                $product.one('json-loaded', function () {
                    if(callback) {
                        callback(JSON.parse($product.attr('data-json-product')));
                    }
                });

                return;
            }

            animate = animate === undefined ? true : animate;

            if(json) {
                if(callback) {
                    callback(typeof json == 'object' ? json : JSON.parse(json));
                }
            } else {
                $product.attr('data-js-process-ajax-loading-json', true);

                if(animate) {
                    theme.Loader.set($product);
                }

                var handle = $product.attr('data-product-handle');

                var xhr = $.ajax({
                    type: 'GET',
                    url: '/products/' + handle,
                    data: {
                        view: 'get_json'
                    },
                    cache: false,
                    dataType: 'html',
                    success: function (data) {
                        json = JSON.parse(data);
                        $product.attr('data-json-product', JSON.stringify(json));

                        if(animate) {
                            theme.Loader.unset($product);
                        }

                        if(callback) {
                            callback(json);
                        }

                        $product.trigger('json-loaded');
                    },
                    complete: function () {
                        $product.removeAttr('data-js-process-ajax-loading-json');
                    }
                });

                return xhr;
            }
        },
        switchByImage: function($product, get_image, id, callback) {
            var _ = this,
                $image = $product.find('[data-js-product-image] img'),
                json = $product.attr('data-json-product'),
                data = false;

            this._loadJSON($product, json, function (json) {
                var json_images = json.images,
                    current_image_id = (get_image === 'by_id') ? +id : +$image.attr('data-image-id'),
                    image_index,
                    update_variant,
                    is_avilable = true;

                $.each(json_images, function(i) {
                    if(+this.id === current_image_id) {
                        image_index = i;
                        return false;
                    }
                });

                if(image_index || image_index === 0) {
                    if(get_image === 'prev' && image_index !== 0) {
                        image_index--;
                    } else if(get_image === 'next' && image_index !== json_images.length - 1) {
                        image_index++;
                    }

                    $.each(json.variants, function() {
                        if(this.featured_image && +this.featured_image.id === +json_images[image_index].id) {
                            update_variant = this;
                            return false;
                        }
                    });

                    if(!update_variant) {
                        update_variant = _._getDefaultVariant(json);
                        update_variant.featured_image = json_images[image_index];
                        is_avilable = false;
                    }

                    _._updateOptions($product, {
                        update_variant: update_variant,
                        json: json
                    });
                    
                    _._switchVariant($product, {
                        update_variant: update_variant,
                        json: json,
                        is_avilable: is_avilable
                    });

                    data = {
                        index: image_index,
                        image: json_images[image_index],
                        is_first: image_index === 0,
                        is_last: image_index === json_images.length - 1
                    };
                }

                callback(data);
            });
        },
        _switchVariant: function($product, data) {
            data.update_variant.metafields = $.extend({}, data.json.metafields);

            $.each(data.json.variants_metafields, function() {
                if(+this.variant_id === +data.update_variant.id) {
                    data.update_variant.metafields = $.extend(true, data.update_variant.metafields, this.metafields);
                }
            });

            $product.attr('data-product-variant-id', data.update_variant.id);

            this._updateContent($product, data);
        },
        _getDefaultVariant: function(json) {
            var default_variant = {};

            $.each(json.variants, function() {
                if(+this.id === +json.default_variant_id) {
                    Object.assign(default_variant, this);
                    return false;
                }
            });

            return default_variant;
        },
        _updateContent: function($product, data) {
            var clone_id = $product.attr('data-js-product-clone-id'),
                $clone_product = $('[data-js-product-clone="' + clone_id + '"]');

            this._updateFormVariantInput($product, data);
            this._updatePrice($product, $clone_product, data);
            this._updateLabelSale($product, data);
            this._updateLabelInStock($product, data);
            this._updateLabelOutStock($product, data);
            this._updateLabelHot($product, data);
            this._updateLabelNew($product, data);
            this._updateCountdown($product, data);
            this._updateAddToCart($product, $clone_product, data);
            this._updateSKU($product, data);
            this._updateBarcode($product, data);
            this._updateAvailability($product, data);
            this._updateStockCountdown($product, data);
            this._updateGallery($product, data);
            this._updateLinks($product, data);
            this._updateHistory($product, data);

            theme.StoreLists.checkProductStatus($product);
            theme.ProductImagesNavigation.switch($product, data);

            if(!data.dontUpdateVariantsSelect) {
                this._updateVariantsSelect($product, data);
            }

            if($clone_product.length) {
                this._updateOptions($clone_product, data, true);
                theme.ProductImagesNavigation.switch($clone_product, data);
            }
        },
        _updateOptions: function($product, data, set_current) {
            var $options = $product.find(this.selectors.options_attr);

            if($options.length) {
                $options.find('[data-js-option-value]').removeClass('active');

                if(set_current) {
                    $.each(data.current_values, function(i, k) {
                        $options.find('[data-property="' + i + '"] [data-js-option-value][data-value="' + k + '"]').addClass('active');
                        $options.find('[data-js-option-select][data-property="' + i + '"]').val(k).trigger('change', [ true ]);
                    });
                } else {
                    $.each(data.json.options, function(i) {
                        $options.find('[data-property="' + Shopify.handleize(this) + '"] [data-js-option-value][data-value="' + Shopify.handleize(data.update_variant.options[i]) + '"]').addClass('active');
                        $options.find('[data-js-option-select][data-property="' + Shopify.handleize(this) + '"]').val(data.update_variant.options[i]).trigger('change', [ true ]);
                    });
                }
            }
        },
        _updateFormVariantInput: function ($product, data) {
            var $input = $product.find('[data-js-product-variant-input]');

            $input.attr('value', data.update_variant.id);
        },
        _updateVariantsSelect: function($product, data) {
            var $select = $product.find('[data-js-product-variants]');

            if($select.length) {
                $select.val(data.update_variant.id).change();
            }
        },
        _updateAddToCart: function($product, $clone_product, data) {
            var $button = $product.add($clone_product).find('[data-js-product-button-add-to-cart]');
            
            if($button.length) {
                data.is_avilable && data.update_variant.available ? $button.removeAttr('disabled data-button-status') : $button.attr('disabled', 'disabled').attr('data-button-status', 'sold-out');
            }
        },
        _updatePrice: function($product, $clone_product, data) {
            var $price = $product.add($clone_product).find('[data-js-product-price]'),
                $details = $product.find('[data-js-product-price-sale-details]');

            if($price.length) {
                theme.ProductCurrency.setPrice($price, data.update_variant.price, data.update_variant.compare_at_price);
            }

            if($details.length) {
                var details;

                $.each(data.json.variants_price_sale_details, function () {
                    if(+this.id === +data.update_variant.id) {
                        details = this.details;
                    }
                });

                $details.html(details ? details : '')[details ? 'removeClass' : 'addClass']('d-none-important');
            }

            if($price.length || $details.length) {
                theme.ProductCurrency.update();
            }
        },
        _updateLabelSale: function($product, data) {
            var $label = $product.find('[data-js-product-label-sale]');
            
            if($label.length) {
                var html = '',
                    sale = (data.update_variant.compare_at_price && data.update_variant.compare_at_price > data.update_variant.price);

                $label[!sale ? 'addClass' : 'removeClass']('d-none-important');

                if(sale) {
                    var percent = Math.round(100 - data.update_variant.price * 100 / data.update_variant.compare_at_price);
                    html += theme.strings.label.sale;
                    html = Shopify.addValueToString(html, {
                        'percent': percent
                    });
                }

                $label.html(html);
            }
        },
        _updateLabelInStock: function($product, data) {
            var $label = $product.find('[data-js-product-label-in-stock]');

            if($label.length) {
                $label[!data.update_variant.available ? 'addClass' : 'removeClass']('d-none-important');
            }
        },
        _updateLabelOutStock: function($product, data) {
            var $label = $product.find('[data-js-product-label-out-stock]');

            if($label.length) {
                $label[data.update_variant.available ? 'addClass' : 'removeClass']('d-none-important');
            }
        },
        _updateLabelHot: function($product, data) {
            var $label = $product.find('[data-js-product-label-hot]');

            if($label.length) {
                $label[data.update_variant.metafields.labels && data.update_variant.metafields.labels.hot ? 'removeClass' : 'addClass']('d-none-important');
            }
        },
        _updateLabelNew: function($product, data) {
            var $label = $product.find('[data-js-product-label-new]');

            if($label.length) {
                $label[data.update_variant.metafields.labels && data.update_variant.metafields.labels.new ? 'removeClass' : 'addClass']('d-none-important');
            }
        },
        _updateCountdown: function($product, data) {
            var $countdown = $product.find('[data-js-product-countdown]'),
                date = data.update_variant.metafields.countdown && data.update_variant.metafields.countdown.date ? data.update_variant.metafields.countdown.date : false;

            if($countdown.length) {
                var $countdown_init = $countdown.find('.js-countdown'),
                    need_coundown = date && data.update_variant.compare_at_price && data.update_variant.compare_at_price > data.update_variant.price;

                if(need_coundown && $countdown_init.attr('data-date') !== date) {
                    theme.ProductCountdown.reinit($countdown_init, date);
                }

                $countdown[!need_coundown ? 'addClass' : 'removeClass']('d-none-important');
            }
        },
        _updateSKU: function($product, data) {
            var $sku = $product.find('[data-js-product-sku]');

            if($sku.length) {
                $sku[data.update_variant.sku ? 'removeClass' : 'addClass']('d-none-important');

                $sku.find('span').html(data.update_variant.sku);
            }
        },
        _updateBarcode: function($product, data) {
            var $barcode = $product.find('[data-js-product-barcode]');

            if($barcode.length) {
                $barcode[data.update_variant.barcode ? 'removeClass' : 'addClass']('d-none-important');

                $barcode.find('span').html(data.update_variant.barcode);
            }
        },
        _updateAvailability: function($product, data) {
            var $availability = $product.find('[data-js-product-availability]');

            if($availability.length) {
                var html = '',
                    quantity = 0;

                $.each(data.json.variants_quantity, function() {
                    if(+this.id === +data.update_variant.id) {
                        quantity = +this.quantity;
                    }
                });

                if(data.update_variant.available) {
                    html += theme.strings.availability_value_in_stock;
                    html = Shopify.addValueToString(html, {
                        'count': quantity,
                        'item': quantity === 1 ? theme.strings.layout.cart.items_count.one : theme.strings.layout.cart.items_count.other
                    });
                } else {
                    html += theme.strings.availability_value_out_stock;
                }

                $availability.attr('data-availability', data.update_variant.available).find('span').html(html);
            }
        },
        _updateStockCountdown: function ($product, data) {
            var $stock_countdown = $product.find('[data-js-product-stock-countdown]'),
                $title = $stock_countdown.find('[data-js-product-stock-countdown-title]'),
                $progress = $stock_countdown.find('[data-js-product-stock-countdown-progress]'),
                min = +$stock_countdown.attr('data-min'),
                quantity = 0;

            $.each(data.json.variants_quantity, function () {
                if(+this.id === +data.update_variant.id) quantity = +this.quantity;
            });

            if($title) {
                $title.html(Shopify.addValueToString(theme.strings.stock_countdown.title, {
                    'quantity': '<span class="stock-countdown__counter">' + quantity + '</span>'
                }));
            }

            if($progress) {
                $progress.width(quantity / (min / 100) + '%');
            }

            if($stock_countdown.length) {
                $stock_countdown[quantity > 0 && quantity < min ? 'removeClass' : 'addClass']('d-none-important');
            }
        },
        _updateGallery: function ($product, data) {
            var $gallery = $product.find('[data-js-product-gallery]');

            if($gallery.find('.fotorama').length) {
                var image = data.update_variant.featured_image;

                if(!image || !image.src) {
                    if(data.json.images[0]) {
                        image = data.json.images[0];
                    }
                }

                $gallery.productGallery('switchImageById', image.id);
            }
        },
        _updateLinks: function ($product, data) {
            var url = decodeURIComponent(window.location.origin) + '/products/' + data.json.handle + '?variant=' + data.update_variant.id;

            $product.find('a[href*="products/' + data.json.handle + '"]').attr('href', url);
        },
        _updateHistory: function ($product, data) {
            var $options = $product.find(this.selectors.options);

            if($options.length && $options[0].hasAttribute('data-js-change-history')) {
                var url = decodeURIComponent(window.location.origin) + '/products/' + data.json.handle + '?variant=' + data.update_variant.id;

                history.replaceState({foo: 'product'}, url, url);
            }
        }
    });

    theme.ProductOptions = new ProductOptions;
};



theme.ProductsView = function() {

    function ProductsView() {
        this.selectors = {
            view: '.js-products-view'
        };
        
        this.init();
    };

    ProductsView.prototype = $.extend({}, ProductsView.prototype, {
        init: function() {
            var _ = this,
                obj_view = localStorage.getItem('products-view');

            if(window.location.href.indexOf('products-view=reset') !== -1) {
                obj_view = null;
                localStorage.setItem('products-view', null);
            }

            if(obj_view) {
                var $wrappers = $(this.selectors.view + ' [data-js-products-grid-buttons]');

                obj_view = JSON.parse(obj_view);

                $wrappers.each(function () {
                    var $wrapper = $(this),
                        is_default = true;

                    $.each(obj_view, function (k, v) {
                        if($wrapper.attr('data-value-' + k) !== v) {
                            var active_attr = 'data-active-' + k;

                            $wrapper.attr('data-value-' + k, v);
                            $wrapper.find('[data-value]').removeAttr(active_attr);
                            $wrapper.find('[data-value="' + v +  '"]').attr(active_attr, true);

                            is_default = false;
                        }
                    });

                    if(!is_default) {
                        _.update($wrapper);
                    }
                });
            }

            $body.on('click', this.selectors.view + ' [data-js-products-grid-buttons] [data-value]', function() {
                var $this = $(this),
                    $wrapper = $this.parents('[data-js-products-grid-buttons]'),
                    value = $this.attr('data-value'),
                    bp = theme.current.bp,
                    active_attr = 'data-active-' + bp;

                if(!$this[0].hasAttribute(active_attr)) {
                    var obj_values = {};

                    $wrapper.find('[data-value]').removeAttr(active_attr);
                    $this.attr(active_attr, true);
                    $wrapper.attr('data-value-' + bp, value);

                    _.update($wrapper);

                    $.each(theme.breakpoints.values, function (k, v) {
                        obj_values[k] = $wrapper.attr('data-value-' + k);
                    });

                    localStorage.setItem('products-view', JSON.stringify(obj_values));
                }
            });
        },
        update: function ($wrapper) {
            var $products = $wrapper.parents(this.selectors.view).find('[data-js-products]'),
                grid_class = '';

            $.each(theme.breakpoints.values, function(k) {
                var grid_value = $('[data-js-products-grid-buttons]').attr('data-value-' + k),
                    column_size = (grid_value === 'list' ? 12 : 12 / +grid_value);

                $products[+grid_value === 1 ? 'addClass' : 'removeClass']('products-view-centered-' + k);
                $products[grid_value === 'list' ? 'addClass' : 'removeClass']('products-view-list-' + k);

                grid_class += ' col-';

                if(k !== 'xs') {
                    grid_class += k + '-';
                }

                grid_class += column_size;
            });

            $products.find('[data-js-product]').parent().attr('class', grid_class);
        }
    });

    theme.ProductsView = new ProductsView;
};
theme.ProductReview = function() {

    function ProductReview() {

    };

    ProductReview.prototype = $.extend({}, ProductReview.prototype, {
        update: function() {
            if(window.SPR) {
                var $spr = $('[src*="productreviews.shopifycdn.com"]');

                $spr.replaceWith($('<script>').attr('src', $spr.attr('src'))).remove();
            }
        }
    });

    theme.ProductReview = new ProductReview;
};
theme.ProductGallery = function() {

    function ProductGallery() {
        this.load();
    };

    ProductGallery.prototype = $.extend({}, ProductGallery.prototype, {
        load: function() {
            $.widget( 'ui.productGallery', {
                options: {
                    bp: 1024,
                    bp_slick: 1024,
                    fotorama: {
                        size: 3,
                        nav: false,
                        arrows: false,
                        allowfullscreen: true,
                        auto: false,
                        shadows: false,
                        transition: 'slide',
                        clicktransition: 'crossfade'
                    },
                    slick: {
                        preview: {
                            vertical: true,
                            verticalSwiping: true,
                            slidesToShow: 6,
                            slidesToScroll: 6,
                            dots: false,
                            arrows: true,
                            infinite: false,
                            touchMove: false,
                            responsive: [
                                {
                                    breakpoint: 1259,
                                    settings: {
                                        slidesToShow: 4,
                                        slidesToScroll: 4
                                    }
                                }
                            ]
                        },
                        panorama: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            customPaging: '10px',
                            dots: false,
                            arrows: true,
                            infinite: false,
                            touchMove: false,
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                },
                                {
                                    breakpoint: 779,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                },
                                {
                                    breakpoint: 542,
                                    settings: {
                                        slidesToShow: 1
                                    }
                                }
                            ]
                        }
                    },
                    zoom: {
                        zoomType: "inner",
                        cursor: "crosshair",
                        easing : true,
                        zoomWindowFadeIn: 150,
                        zoomWindowFadeOut: 150
                    },
                    zoomEnable: true,
                    arrows: true,
                    btnZoom: false,
                    fullscreen: true
                },
                _create: function() {
                    this.$gallery = this.element;
                    this.$main = this.$gallery.find('[data-js-product-gallery-main]');
                    this.$preview = this.$gallery.find('[data-js-product-gallery-preview]');
                    this.$collage = this.$gallery.find('[data-js-product-gallery-collage]');
                    this.preview_type = this.$preview.attr('data-type');
                    this.$main_act_img = null;
                    this.$zoomWrapper = this.$gallery.find('[data-js-product-gallery-zoom]');
                    this.slick_state = null;
                    this.zoom_activate = true;
                    this.zoom_state = false;
                    this.id = 'id' + Math.ceil(Math.random() * 10000000);
                    this.index_id_obj = this.$main.data('index-id');
                    this.zoom_src = this.$main.data('zoom-images');

                    var _ = this,
                        arrows = this.$main.data('arrows'),
                        fullscreen = this.$main.data('fullscreen'),
                        zoom = this.$main.data('zoom'),
                        active_image = this.$gallery.data('active-image');

                    if(arrows != undefined) {
                        this.options.arrows = arrows;
                    }

                    if(fullscreen != undefined) {
                        this.options.fullscreen = fullscreen;
                    }

                    if(zoom != undefined) {
                        this.options.zoomEnable = zoom;
                    }

                    if(active_image != undefined) {
                        this.options.fotorama.startindex = active_image;
                        this.options.slick.initialSlide = active_image;
                    }

                    this.options.fotorama.allowfullscreen = this.options.fullscreen;

                    if(this.$main.find('img').length === 1) {
                        this.$main.addClass('product-page-gallery__main--single');
                    }

                    this.fotorama = this.$main.fotorama(this.options.fotorama).data('fotorama');

                    if(this.options.fullscreen) {
                        this.$btn_full = this.$gallery.find('[data-js-product-gallery-btn-fullscreen]');

                        this.$main.on({
                            'fotorama:fullscreenenter': function () {
                                _._zoomDestroy();
                            },
                            'fotorama:fullscreenexit': function () {
                                _._checkSlick();
                                _._checkCollage();

                                _._zoomInit();
                            }
                        });

                        this.$btn_full.on('click', function() {
                            _.fotorama.requestFullScreen();
                        });
                    }

                    if(this.options.btnZoom) {
                        this.$btn_zoom_toggle = $('<div>').addClass('fotorama__btn-zoom').append($('<i>').addClass('icon-zoom-in'));

                        this.$main.append(this.$btn_zoom_toggle);

                        this.$btn_zoom_toggle.on('click', function() {
                            if(_.zoom_state) _.zoomToggle('off');
                            else _.zoomToggle('on');
                        });
                    }

                    if(this.options.arrows) {
                        this.$arrow_prev = this.$gallery.find('[data-js-product-gallery-main-btn-prev]');
                        this.$arrow_next = this.$gallery.find('[data-js-product-gallery-main-btn-next]');

                        this.$arrow_prev.on('click', function() {
                            _._setEffect('crossfade', function() {
                                _.fotorama.show('<');
                            });
                        });

                        this.$arrow_next.on('click', function() {
                            _._setEffect('crossfade', function() {
                                _.fotorama.show('>');
                            });
                        });
                    }

                    //slick
                    this.$prev_slides = this.$preview.find('img');

                    this.$preview.on('init', function() {
                        _.$preview.removeClass('invisible');
                    });

                    this.$preview.one('init', function() {
                        _.slick_is_init = true;
                    });

                    this.$preview.on('mousedown', '.slick-slide', function() {
                        $(this).one({
                            'mouseup': function(e) {
                                var $this = $(this);

                                _.switchImage($this);
                            }
                        });
                    });

                    //collage
                    this.$collage_slides = this.$collage.find('img');

                    this.$collage.on('click', 'img', function() {
                        var $this = $(this);

                        _.switchImage($this);
                    });

                    this.$gallery.on('click', '[data-js-product-gallery-btn-video]', function () {
                        _.switchImage(null, 'video');
                    });

                    this._slickInit();

                    this.$gallery.addClass('product-page-gallery--loaded');

                    function fotoramaChangeEvent() {
                        _.$main.on('fotorama:show.change', function(e, fotorama) {
                            _.$main.unbind('fotorama:showend.change fotorama:load.change');

                            _._zoomDestroy();

                            _._checkBtns(fotorama);

                            _.$main.one('fotorama:load.change', function() {
                                _._zoomInit();
                            });

                            _.$main.one('fotorama:showend.change', function(e, fotorama) {
                                if(_.$main.find('.fotorama__active img').attr('src')) {
                                    _.$main.trigger('fotorama:load.change');
                                }

                                _._checkSlick();
                                _._checkCollage();
                            });
                        });
                    };

                    this.$main.one('fotorama:load', function(e, fotorama) {
                        _._zoomInit();

                        _._checkBtns(fotorama);

                        fotoramaChangeEvent();

                        _.$main.removeClass('invisible');

                        _.fotorama_is_init = true;
                    });

                    $(window).on('theme.changed.breakpoint.productgallery' + this.id, function() {
                        _._slickInit();
                        _._checkSlick();
                        _._checkCollage();
                        _._zoomDestroy();
                        _._zoomInit();
                    });
                },
                _slickInit: function() {
                    var this_state = window.innerWidth > this.options.bp_slick ? true : false;

                    if(this_state !== this.slick_state) {
                        if(this.preview_type === 'panorama' || this_state) {
                            if(this.$preview.hasClass('slick-initialized')) {
                                this.$preview.slick('setPosition');
                            } else {
                                if(this.preview_type === 'panorama') {
                                    var preview_obj = this.options.slick.panorama;
                                } else {
                                    var preview_obj = this.options.slick.preview;

                                    var slidesToShow = this.$preview.attr('data-slides-to-show');

                                    if(slidesToShow !== undefined) {
                                        preview_obj.slidesToShow = +slidesToShow;
                                    }
                                }

                                this.$preview.slick($.extend(preview_obj, {
                                    prevArrow: this.$gallery.find('[data-js-product-gallery-preview-btn-prev]'),
                                    nextArrow: this.$gallery.find('[data-js-product-gallery-preview-btn-next]')
                                }));
                            }
                        } else {
                            if(this.$preview.hasClass('slick-initialized')) {
                                this.$preview.addClass('invisible');
                                this.$preview.slick('destroy');
                            }
                            this.slick_is_init = true;
                        }

                        this.slick_state = this_state;
                    }
                },
                _checkSlick: function(image_id) {
                    if(this.$main.hasClass('fotorama--fullscreen') || !this.$preview.hasClass('slick-initialized')) {
                        return;
                    }

                    if(!image_id) {
                        if(!this.fotorama) {
                            return;
                        }

                        image_id = this.index_id_obj[this.fotorama.activeIndex];
                    }

                    var $current_slide = this.$prev_slides.filter('[data-js-product-gallery-image-id="' + image_id + '"]'),
                        slide_index = this.$prev_slides.index($current_slide);

                    this.$prev_slides.removeClass('current');
                    $current_slide.addClass('current');
                    this.$preview.slick('slickGoTo', slide_index);
                },
                _checkCollage: function (image_id) {
                    if(this.$main.hasClass('fotorama--fullscreen') || !this.$collage.length) {
                        return;
                    }

                    if(!image_id) {
                        if(!this.fotorama) {
                            return;
                        }

                        image_id = this.index_id_obj[this.fotorama.activeIndex];
                    }

                    var $current_slide = this.$collage_slides.filter('[data-js-product-gallery-image-id="' + image_id + '"]');

                    this.$collage_slides.removeClass('current');
                    $current_slide.addClass('current');
                },
                _checkBtns: function(fotorama) {
                    if(this.options.arrows) {
                        var index = fotorama.activeFrame.i;

                        if(index === 1) this.$arrow_prev.addClass('disabled');
                        else this.$arrow_prev.removeClass('disabled');

                        if(index === fotorama.size) this.$arrow_next.addClass('disabled');
                        else this.$arrow_next.removeClass('disabled');
                    }
                },
                _zoomInit: function () {
                    this.$main_act_img = this.$main.find('.fotorama__active').not('fotorama__stage__frame--video').find('.fotorama__img').not('.fotorama__img--full');

                    if(this.fotorama && this.options.zoomEnable && this.$main_act_img.length && window.innerWidth > this.options.bp && this.zoom_activate && !this.$main.hasClass('fotorama--fullscreen')) {
                        var _ = this,
                            set_zoom_src = this.zoom_src[this.fotorama.activeIndex];

                        if(!set_zoom_src) return;

                        this.$main_act_img.attr('data-zoom-image', set_zoom_src);

                        this.$main_act_img.elevateZoom(this.options.zoom);

                        function replaceCont() {
                            setTimeout(function() {
                                _.$zoomContainer = $('body > .zoomContainer');
                                if(_.$zoomContainer.length) _.$zoomContainer.appendTo(_.$zoomWrapper);
                                else replaceCont();
                            }, 20);
                        };

                        replaceCont();

                        this.$zoomWrapper.removeClass('d-none-important');

                        this.$main.addClass('fotorama--zoom');

                        this.zoom_state = true;
                    }
                },
                _zoomDestroy: function () {
                    if(this.options.zoomEnable && this.zoom_state && this.$main_act_img.length && this.$zoomContainer) {
                        $.removeData(this.$main_act_img, 'elevateZoom');
                        this.$main_act_img.removeAttr('data-zoom-image');

                        this.$zoomContainer.remove();
                        this.$zoomContainer = null;

                        this.$zoomWrapper.addClass('d-none-important');

                        this.$main.removeClass('fotorama--zoom');

                        this.zoom_state = false;
                    }
                },
                zoomToggle: function(state) {
                    if(this.$btn_zoom_toggle) {
                        var $icon = this.$btn_zoom_toggle.find('i');

                        $icon.removeAttr('class');

                        if(state === 'on') {
                            $icon.addClass('icon-zoom-in');

                            this.zoom_activate = true;

                            this._zoomInit();
                        } else if(state === 'off') {
                            $icon.addClass('icon-zoom-out');

                            this.zoom_activate = false;

                            this._zoomDestroy();
                        }
                    }
                },
                _setEffect: function(effect, func) {
                    var _ = this;

                    this.fotorama.setOptions({ transition: effect });

                    func();

                    this.$main.one('fotorama:showend', function() {
                        _.fotorama.setOptions({ transition: 'slide' });
                    });
                },
                switchImage: function($slide, image_id) {
                    if($slide && $slide.hasClass('current')) return;

                    var _ = this,
                        image_id = image_id || $slide.data('js-product-gallery-image-id');

                    if(this.fotorama) {
                        (function recurs_wait() {
                            if(_.fotorama_is_init) {
                                var index = 0,
                                    i = 0;

                                for(; i < _.index_id_obj.length; i++) {
                                    if(_.index_id_obj[i] == image_id) index = i;
                                }

                                _._setEffect('crossfade', function() {
                                    _.fotorama.show(index);
                                });
                            } else {
                                _.$main.one('fotorama:load', function() {
                                    recurs_wait();
                                });

                                _.$preview.on('init', function() {
                                    recurs_wait();
                                });
                            }
                        })();
                    } else if(this.preview_type === 'panorama') {
                        this._checkSlick(image_id);
                    }
                },
                switchImageById: function(image_id) {
                    var _ = this,
                        $slides = this.$prev_slides.add(this.$collage_slides),
                        $slide = $slides.filter('[data-js-product-gallery-image-id="' + image_id + '"]');

                    _.switchImage($slide);
                },
                update: function () {
                    if(this.$preview.hasClass('slick-initialized')) {
                        this.$preview.slick('setPosition');
                    }
                },
                _init: function () {

                },
                _setOption: function(key, value) {
                    $.Widget.prototype._setOption.apply(this, arguments);
                },
                destroy: function() {
                    this._zoomDestroy();

                    this.$preview.unbind('mousedown');

                    this.$preview.slick('destroy');

                    $(this.$gallery, this.$btn_full, this.$arrow_prev, this.$arrow_next, this.$btn_zoom_toggle).off().remove();

                    this.fotorama.destroy();

                    $(window).unbind('theme.changed.breakpoint.productgallery' + this.id);

                    $.Widget.prototype.destroy.call(this);
                }
            });
        },
        init: function ($gallery) {
            if(!$gallery.hasClass('product-page-gallery--loaded')) {
                $gallery.productGallery();
            }
        },
        destroy: function ($gallery) {
            if($gallery.hasClass('product-page-gallery--loaded')) {
                $gallery.productGallery('destroy');
            }
        }
    });

    theme.ProductGallery = new ProductGallery;
};
theme.DynamicCheckout = function() {

    function DynamicCheckout() {
        this.load();
    };

    DynamicCheckout.prototype = $.extend({}, DynamicCheckout.prototype, {
        load: function() {
            function update() {
                var $this = $(this),
                    $dynamic_checkout = $this.parents('.js-dynamic-checkout'),
                    $button_wrapper = $dynamic_checkout.find('[data-js-dynamic-checkout-button-wrapper]');

                $button_wrapper[$this.is(':checked') ? 'removeClass' : 'addClass']('disabled');
            };

            $body.on('change', '.js-dynamic-checkout [data-js-dynamic-checkout-confirmation]', update);

            $('.js-dynamic-checkout [data-js-dynamic-checkout-confirmation]').each(update);
        }
    });

    theme.DynamicCheckout = new DynamicCheckout;
};
theme.Cart = function() {

    function Cart() {
        this.selectors = {
            button_add: '.js-product-button-add-to-cart',
            button_remove: '.js-product-button-remove-from-cart'
        };

        this.load();
    };

    Cart.prototype = $.extend({}, Cart.prototype, {
        load: function() {
            var _ = this;

            function callback($button, variant_id, quantity) {
                var limit_is_exceeded = false,
                    current_variant,
                    clone_id = $button.attr('data-js-button-add-to-cart-clone-id');
                
                if(clone_id !== undefined) {
                    $button = $button.add($('[data-js-button-add-to-cart-clone="' + clone_id + '"]'));
                }

                $button.each(function () {
                    var $this = $(this);

                    $this.css({
                        'min-width': $this.outerWidth() + 'px'
                    });
                });

                $button.removeAttr('disabled').attr('data-button-status', 'added');

                setTimeout(function() {
                    $button.removeAttr('data-button-status').removeClass('active').removeAttr('style');
                }, 2000);

                _.updateValues(null, function(data) {
                    $.each(data.items, function() {
                        if(+this.variant_id === +variant_id) {
                            current_variant = this;

                            if(quantity > this.quantity) {
                                theme.Popups.cartLimitIsExceeded(this.quantity);

                                limit_is_exceeded = true;
                            }

                            return false;
                        }
                    });
                    
                    if(!limit_is_exceeded && current_variant) {
                        theme.Popups.callByName('cart');
                    }
                });
            };

            $body.on('click', this.selectors.button_add, function(e) {
                var $this = $(this);

                if(!$this.hasClass('active') && $this.attr('data-button-status') !== 'added') {
                    $this.addClass('active').attr('disabled', 'disabled');

                    var $form = $this.parents('form'),
                        form_serialize_array = $form.serializeArray(),
                        form_data_object = {};

                    $.each(form_serialize_array, function() {
                        form_data_object[this.name] = this.value;
                    });

                    Shopify.getCart(function(data) {
                        var cart_has_product = false,
                            quantity = +form_data_object.quantity || 1;

                        $.each(data.items, function() {
                            if(+this.variant_id === +form_data_object.id) {
                                quantity += this.quantity;

                                Shopify.changeItem(form_data_object.id, quantity, function() {
                                    callback($this, form_data_object.id, quantity);
                                });

                                cart_has_product = true;

                                return false;
                            }
                        });

                        if(!cart_has_product) {
                            Shopify.addItem(form_data_object.id, quantity, function() {
                                callback($this, form_data_object.id, quantity);
                            });
                        }
                    });

                    e.preventDefault();
                    return false;
                }
            });

            $body.on('click', this.selectors.button_remove, function(e) {
                var $this = $(this),
                    $product = $this.parents('[data-js-product]'),
                    id = +$product.attr('data-product-variant-id');

                Shopify.removeItem(id, function(data) {
                    _.updateValues(data);

                    if(!theme.Popups.getByName('cart').hasClass('d-none-important')) {
                        theme.PopupCart.update();
                    }
                });

                e.preventDefault();
                return false;
            });
        },
        updateValues: function(data, callback) {
            var _ = this;

            function process(data) {
                _.updateHeaderCount(data);
                _.updateFreeShipping(data);
            };

            if(data) {
                process(data);
            } else {
                Shopify.getCart(function(data) {
                    process(data);

                    if(callback && typeof callback === 'function') {
                        callback(data);
                    }
                });
            }
        },
        updateHeaderCount: function(data) {
            $('[data-js-cart-count-mobile]').attr('data-js-cart-count-mobile', data.item_count).html(data.item_count);
            $('[data-js-cart-count-desktop]').attr('data-js-cart-count-desktop', data.item_count).html(theme.strings.header.cart_count_desktop.replace('{{ count }}', data.item_count));
        },
        updateFreeShipping: function(data) {
            var $free_shipping = $('.js-free-shipping'),
                $progress = $free_shipping.find('[data-js-progress]'),
                $text = $free_shipping.find('[data-js-text]'),
                value = +$free_shipping.attr('data-value'),
                total = +data.total_price,
                procent = Math.min(total / (value / 100), 100),
                money = Math.max(value - total, 0),
                text_html = money > 0 ? theme.strings.cart.general.free_shipping_html.replace('{{ value }}', Shopify.formatMoney(money, theme.moneyFormat)) : theme.strings.cart.general.free_shipping_complete;

            $progress.css({
                width: procent + '%'
            });

            $text.html(text_html);
        }
    });

    theme.Cart = new Cart;
};



theme.StoreLists = function() {
    
    function Engine(namespace, callback) {
        this.namespace = namespace;

        this.selectors = {
            button: '.js-store-lists-add-' + namespace,
            button_remove: '.js-store-lists-remove-' + namespace,
            button_clear: '.js-store-lists-clear-' + namespace,
            has_items: '[data-js-store-lists-has-items-' + namespace + ']',
            dhas_items: '[data-js-store-lists-dhas-items-' + namespace + ']'
        };

        if(theme.customer) {
            this.current_storage = namespace + '-customer-' + theme.customer_id;

            this.app_obj = {
                namespace: namespace,
                customerid: theme.customer_id,
                shop: theme.permanent_domain,
                domain: theme.host,
                iid: theme.lists_app.iid
            };
        } else {
            this.current_storage = namespace + '-guest';
        }

        this.load(callback);
    };

    Engine.prototype = $.extend({}, Engine.prototype, {
        load: function(callback) {
            var _ = this;

            if(theme.customer) {
                var customer_storage = localStorage.getItem(this.current_storage),
                    customer_items = customer_storage ? JSON.parse(customer_storage) : [],
                    guest_storage = localStorage.getItem(this.namespace + '-guest'),
                    guest_items = guest_storage ? JSON.parse(guest_storage) : [],
                    sort_db_obj = {},
                    sort_new_obj = {},
                    items_new_array = [],
                    items_new_json;
                
                var sortObject = function(obj) {
                    return Object.keys(obj).sort().reduce((p, c) => (p[c] = obj[c], p), {});
                };

                var loadData = function() {
                    _.getCustomerList(function (data) {
                        if(data.status !== 200) return;

                        var i = 0;

                        if(data.items && data.items.length) {
                            customer_items = customer_items.concat(data.items);

                            for(; i < data.items.length; i++) {
                                $.each(data.items[i], function (k, v) {
                                    sort_db_obj[k] = v;
                                });
                            }

                            sort_db_obj = sortObject(sort_db_obj);
                        }

                        for(i = 0; i < customer_items.length; i++) {
                            $.each(customer_items[i], function (k, v) {
                                sort_new_obj[k] = v;
                            });
                        }

                        sort_new_obj = sortObject(sort_new_obj);

                        $.each(sort_new_obj, function (k, v) {
                            var obj = {};

                            obj[k] = v;
                            items_new_array.push(obj);
                        });

                        items_new_json = JSON.stringify(items_new_array);

                        if(JSON.stringify(sort_db_obj) !== JSON.stringify(sort_new_obj)) {
                            localStorage.setItem(_.current_storage, items_new_json);

                            _.setCustomerList(items_new_json);
                        }

                        _.updateHeaderCount();
                        _.checkProductStatus();
                        
                        localStorage.removeItem(_.namespace + '-guest');
                    });
                };

                if(guest_items.length) {
                    callback({
                        trigger: function (is_active) {
                            if(is_active) customer_items = customer_items.concat(guest_items);

                            loadData();
                        },
                        info: {
                            namespace: _.namespace,
                            count: guest_items.length
                        }
                    });
                } else {
                    loadData();
                }
            } else {
                this.checkProductStatus();
            }

            $body.on('click', this.selectors.button, function(e) {
                e.preventDefault();

                var $this = $(this);

                $this.attr('disabled', 'disabled');

                var $product = $this.parents('[data-js-product]'),
                    handle = $product.attr('data-product-handle'),
                    id = +$product.attr('data-product-variant-id');

                if($this.attr('data-button-status') === 'added') {
                    _.removeItem(id, handle, function(data) {
                        $this.removeAttr('data-button-status');
                        $this.removeAttr('disabled');
                    });
                } else {
                    _.addItem(id, handle, function(data) {
                        $this.attr('data-button-status', 'added');
                        $this.removeAttr('disabled');
                    });
                }

                e.preventDefault();
                return false;
            });

            function removeCallback($product, handle) {
                var find = '[data-js-store-lists-product-' + _.namespace + ']',
                    $popup = theme.Popups.getByName(_.namespace);

                if(handle) find += '[data-product-handle="' + handle + '"]';

                $(find).each(function () {
                    var $this = $(this);

                    $($this.parent('[class*="col"]').length ? $this.parent() : $this).remove();
                });

                if($product && typeof $product !== undefined && $product.length) $product.remove();

                if(!$popup.hasClass('d-none-important')) {
                    theme.StoreLists.popups[_.namespace].update($popup);
                }
            };

            $body.on('click', this.selectors.button_remove, function() {
                var $this = $(this),
                    $product = $this.parents('[data-js-product]'),
                    handle = $product.attr('data-product-handle'),
                    id = +$product.attr('data-product-variant-id');

                _.removeItem(id, handle, function() {
                    removeCallback($product, handle);
                });
            });

            $body.on('click', this.selectors.button_clear, function() {
                _.clear(function() {
                    removeCallback();
                });
            });
        },
        setCustomerList: function(items, callback) {
            if(theme.customer) {
                $.ajax({
                    type: "POST",
                    url: "https://" + theme.lists_app.url + "/api/massadd",
                    data: $.extend({}, this.app_obj, {
                        purge: 'yes',
                        items: items
                    }),
                    cache: false,
                    success: function(data) {
                        if(callback) callback(data);
                    }
                });
            }
        },
        getCustomerList: function(callback) {
            if(theme.customer) {
                $.ajax({
                    type: 'POST',
                    url: 'https://' + theme.lists_app.url + '/api/getlist',
                    data: this.app_obj,
                    cache: false,
                    success: function(data) {
                        if(callback) callback(data);
                    }
                });
            }
        },
        addCustomerItem: function(id, handle, callback) {
            if(theme.customer) {
                $.ajax({
                    type: 'POST',
                    url: 'https://' + theme.lists_app.url + '/api/add',
                    data: $.extend({}, this.app_obj, {
                        key: id,
                        value: handle
                    }),
                    cache: false,
                    success: function(data) {
                        if(callback) callback(data);
                    }
                });
            }
        },
        removeCustomerItem: function(id, callback) {
            if(theme.customer) {
                $.ajax({
                    type: 'POST',
                    url: 'https://' + theme.lists_app.url + '/api/delete',
                    data: $.extend({}, this.app_obj, {
                        key: id,
                        _method: 'DELETE'
                    }),
                    cache: false,
                    success: function(data) {
                        if(callback) callback(data);
                    }
                });
            }
        },
        clearCustomerItem: function(callback) {
            if(theme.customer) {
                $.ajax({
                    type: 'POST',
                    url: 'https://' + theme.lists_app.url + '/api/massdelete',
                    data: $.extend({}, this.app_obj, {
                        _method: 'DELETE'
                    }),
                    cache: false,
                    success: function(data) {
                        if(callback) callback(data);
                    }
                });
            }
        },
        addItem: function(id, handle, callback) {
            var storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [],
                obj = {};

            obj[id] = handle;

            items.push(obj);

            localStorage.setItem(this.current_storage, JSON.stringify(items));

            this.checkProductStatus();
            this.updateHeaderCount();

            this.addCustomerItem(id, handle);

            if(callback) callback();
        },
        removeItem: function(id, handle, callback) {
            var storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [];

            $.each(items, function (i) {
                if(this[id] && this[id] === handle) {
                    items.splice(i, 1);
                    return false;
                }
            });

            localStorage.setItem(this.current_storage, JSON.stringify(items));

            this.checkProductStatus();

            $(this.selectors.has_items)[items.length > 0 ? 'removeClass' : 'addClass']('d-none-important');
            $(this.selectors.dhas_items)[items.length > 0 ? 'addClass' : 'removeClass']('d-none-important');

            this.updateHeaderCount();

            this.removeCustomerItem(id);

            if (callback) callback();
        },
        clear: function (callback) {
            localStorage.removeItem(this.current_storage);

            this.checkProductStatus();

            $(this.selectors.has_items).addClass('d-none-important');
            $(this.selectors.dhas_items).removeClass('d-none-important');

            this.updateHeaderCount();

            this.clearCustomerItem();

            if (callback) callback();
        },
        checkProductStatus: function($products) {
            $products = $products || $('[data-js-product]');

            var _ = this,
                storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [],
                $active_products = $();

            $.each(items, function () {
                $.each(this, function (k, v) {
                    var $selected_product = $products.filter('[data-product-handle="' + v + '"][data-product-variant-id="' + k + '"]');

                    if ($selected_product.length) {
                        $active_products = $active_products.add($selected_product);
                    }
                });
            });

            $products.not($active_products).find(_.selectors.button).removeAttr('data-button-status');
            $active_products.find(_.selectors.button).attr('data-button-status', 'added');
        },
        updateHeaderCount: function(callback) {
            var storage = localStorage.getItem(this.current_storage),
                count = storage ? JSON.parse(storage).length : 0;

            $('[data-js-' + this.namespace + '-count]').attr('data-js-' + this.namespace + '-count', count).html(count);

            if (callback) callback();
        }
    });

    function Popup(namespace) {
        this.namespace = namespace;

        this.load();
    };

    Popup.prototype = $.extend({}, Popup.prototype, {
        load: function() {
            var _ = this;

            theme.Popups.addHandler(this.namespace, 'call.visible', function($popup) {
                _.update($popup, function () {
                    $popup.trigger('contentloaded');
                });
            });

            theme.Popups.addHandler(this.namespace + '-full', 'call.visible', function($popup) {
                _.updateFull($popup, function () {
                    $popup.trigger('contentloaded');
                });
            });
        },
        _resultToHTML: function($items, data, callback) {
            var $template = $($('#template-' + this.namespace + '-ajax')[0].content),
                $fragment = $(document.createDocumentFragment());

            for(var i = 0; i < data.params.length; i++) {
                $.each(data.params[i], function (k, v) {
                    var product = null,
                        variant = null;

                    $.each(data.products, function () {
                        if(this.handle === v) {
                            product = this;
                        }
                    });

                    if(!product) return;

                    $.each(product.variants, function() {
                        if(+this.id === +k) {
                            variant = this;
                            return false;
                        }
                    });

                    var image = variant.featured_image ? variant.featured_image.src : product.featured_image;

                    var $item = $template.clone(),
                        $product = $item.find('.product-store-lists'),
                        $image = $item.find('.product-store-lists__image img'),
                        $title = $item.find('.product-store-lists__title a'),
                        $variant = $item.find('.product-store-lists__variant'),
                        $price = $item.find('.product-store-lists__price .price'),
                        $links = $item.find('a').not('.product-store-lists__remove');
                    
                    $product.attr('data-product-variant-id', k);
                    $product.attr('data-product-handle', v);
                    $links.attr('href', '/products/' + v + '?variant=' + k);
                    $title.html(product.title);
                    $image.attr('src', Shopify.resizeImage(image, '100x')).attr('srcset', Shopify.resizeImage(image, '100x') + ' 1x, ' + Shopify.resizeImage(image, '100x@2x') + ' 2x').removeAttr('data-src data-srcset');

                    if(variant.title !== 'Default Title') {
                        $variant.html(variant.title).removeClass('d-none-important');
                    }

                    theme.ProductCurrency.setPrice($price, variant.price, variant.compare_at_price);

                    $fragment.append($item);
                });
            }

            $items.html('');
            $items.append($fragment);

            if(callback) {
                callback();
            }
        },
        _getProducts: function(wishlist, callback) {
            var _ = this,
                handles = [];

            if (this.xhr) this.xhr.abort();

            for(var i = 0; i < wishlist.length; i++) {
                $.each(wishlist[i], function () {
                    handles.push(this)
                });
            }

            handles = handles.join('+');

            _.xhr = $.ajax({
                type: 'GET',
                url: '/collections/all',
                cache: false,
                data: {
                    view: 'products_by_handle',
                    constraint: handles
                },
                dataType: 'html',
                success: function (data) {
                    callback({
                        params: wishlist,
                        products: JSON.parse(data)
                    });
                }
            });
        },
        update: function($popup, callback) {
            var _ = this,
                storage = localStorage.getItem(theme.StoreLists.lists[this.namespace].current_storage),
                items = storage ? JSON.parse(storage) : [],
                $content = $popup.find('.popup-' + this.namespace + '__content'),
                $empty = $popup.find('.popup-' + this.namespace + '__empty'),
                $items = $popup.find('.popup-' + this.namespace + '__items'),
                $count = $popup.find('[data-js-popup-' + this.namespace + '-count]');

            $count.html(theme.strings.general.popups[this.namespace].count.replace('{{ count }}', items.length));
            $content[items.length > 0 ? 'removeClass' : 'addClass']('d-none-important');
            $empty[items.length > 0 ? 'addClass' : 'removeClass']('d-none-important');

            if(items.length > 0) {
                var data = this._getProducts(items, function(data) {
                    _._resultToHTML($items, data, callback);

                    theme.ProductCurrency.update();
                });
            } else {
                $items.html('');

                if(callback) {
                    callback();
                }
            }
        },
        updateFull: function ($popup, callback) {
            var _ = this,
                $content = $popup.find('.popup-' + this.namespace + '-full__content');

            $content.html('');

            var obj = {
                type: 'GET',
                data: {
                    view: _.namespace
                },
                cache: false,
                success: function(data) {
                    $content.html(data);
                    theme.ImagesLazyLoad.update();
                    theme.ProductCurrency.update();

                    if(callback) {
                        callback();
                    }
                }
            };

            if(theme.customer) {
                $.extend(obj, {
                    url: '/cart'
                });
            } else {
                var storage = localStorage.getItem(theme.StoreLists.lists[this.namespace].current_storage),
                    items = storage ? JSON.parse(storage) : [],
                    constraint = [];

                for(var i = 0; i < items.length; i++) {
                    $.each(items[i], function (v, k) {
                        constraint.push(k + '=' + v);
                    });
                }

                constraint.join('+');

                $.extend(true, obj, {
                    url: '/collections/all',
                    data: {
                        constraint: constraint
                    }
                });
            }

            $.ajax(obj);
        }
    });


    function StoreLists() {
        this.namespaces = [
            'wishlist',
            'compare'
        ];

        this.load();
    };

    StoreLists.prototype = $.extend({}, StoreLists.prototype, {
        lists: {},
        popups: {},
        load: function () {
            var triggers_array = [];

            for(var i = 0; i < this.namespaces.length; i++) {
                this.lists[this.namespaces[i]] = new Engine(this.namespaces[i], function (obj) {
                    triggers_array.push(obj);
                });
                this.popups[this.namespaces[i]] = new Popup(this.namespaces[i]);
            }

            if(triggers_array.length) {
                var $button_confirm = $('[data-js-button-transfer-data]');

                $button_confirm.one('click', function () {
                    $button_confirm.attr('data-js-active', true);
                    theme.Popups.closeByName('confirm-transfer-data');
                });

                theme.Popups.addHandler('confirm-transfer-data', 'close.after', function() {
                    $button_confirm.off();

                    for(var i = 0; i < triggers_array.length; i++) {
                        triggers_array[i].trigger($button_confirm.attr('data-js-active') === 'true');
                    }
                });

                var $info = $('[data-js-transfer-data-info]');

                for(var i = 0; i < triggers_array.length; i++) {
                    var $li = $('<li>'),
                        html = theme.strings.general.popups.confirm_transfer_data.info,
                        title;

                    switch(triggers_array[i].info.namespace) {
                        case 'wishlist':
                            title = theme.strings.general.popups.confirm_transfer_data.wishlist_title;
                            break;
                        case 'compare':
                            title = theme.strings.general.popups.confirm_transfer_data.compare_title;
                            break;
                    }

                    html = html.replace('{{ title }}', title);
                    html = html.replace('{{ count }}', triggers_array[i].info.count);
                    html = html.replace('{{ name }}', triggers_array[i].info.count > 1 ? theme.strings.general.popups.confirm_transfer_data.name_plural : theme.strings.general.popups.confirm_transfer_data.name_single);

                    $li.html(html);

                    $info.append($li);
                }

                theme.Popups.callByName('confirm-transfer-data');
            }
        },
        checkProductStatus: function () {
            $.each(this.lists, function () {
                this.checkProductStatus();
            });
        },
        updateHeaderCount: function () {
            $.each(this.lists, function () {
                this.updateHeaderCount();
            });
        }
    });

    theme.StoreLists = new StoreLists;
};



theme.Menu = function() {

    function Menu() {
        this.settings = {
            popup_name: 'navigation',
            button_navigation: 'data-js-popup-navigation-button'
        };

        this.selectors = {
            popup_navigation: '.js-popup-navigation'
        }
    };

    Menu.prototype = $.extend({}, Menu.prototype, {
        is_open_animate: false,
        duration: function () {
            return window.theme.animations.menu.duration > 0.1 ? (window.theme.animations.menu.duration - 0.1) * 1000 : 0;
        },
        init: function($menu, params) {
            var _ = this,
                $panel = $menu.find('.menu__panel'),
                $megamenus = $panel.find('.menu__megamenu'),
                $dropdowns = $panel.find('.menu__dropdown'),
                $popup_navigation = $(this.selectors.popup_navigation),
                $button_navigation = $popup_navigation.find('[' + this.settings.button_navigation + ']'),
                $curtain = $menu.find('.menu__curtain');

            this.$menu = $menu;
            this.$panel = $panel;
            this.$megamenus = $megamenus;
            this.$dropdowns = $dropdowns;
            this.$curtain = $curtain;

            this.handlerMenu = theme.Global.responsiveHandler({
                namespace: params.namespace,
                element: $menu,
                delegate: 'a',
                on_mobile: true,
                events: {
                    'click': function(e) {
                        var $this = $(this),
                            $item = $this.parent(),
                            $list = $item.find('.menu__list').first();

                        $panel.unbind('transitionend');

                        if($list.length) {
                            var level = $item.parents('.menu__level-02').length ? 3 : 2;

                            $item.addClass('open');

                            $item.find('.menu__list').first().addClass('show');

                            $panel.attr('data-mobile-level', level);

                            if($menu.length) {
                                $menu.scrollTop(0);
                            }

                            $button_navigation.attr(_.settings.button_navigation, 'back');

                            e.preventDefault();
                            return false;
                        }
                    }
                }
            });

            this.handlerBack = theme.Global.responsiveHandler({
                namespace: params.namespace,
                element: $popup_navigation,
                delegate: '[' + this.settings.button_navigation + '="back"]',
                on_mobile: true,
                events: {
                    'click': function() {
                        var level = $panel.attr('data-mobile-level') - 1,
                            button_status = level > 1 ? 'back' : 'close';

                        var $item = $menu.find('.menu__item.open').last();

                        $item.removeClass('open');

                        $panel.one('transitionend', function () {
                            $item.find('.menu__list').first().removeClass('show');
                        });

                        $panel.attr('data-mobile-level', level);

                        $menu.scrollTop(0);

                        $button_navigation.attr(_.settings.button_navigation, button_status);

                        if($panel.css('transition-duration') === '0s') {
                            $panel.trigger('transitionend');
                        }
                    }
                }
            });

            theme.Popups.addHandler(this.settings.popup_name, 'close.before.closeMobileMenu', function() {
                if(theme.current.is_mobile) {
                    _.closeMobileMenu();

                    $button_navigation.attr(_.settings.button_navigation, 'close');
                }
            });

            this.handlerDropdown = theme.Global.responsiveHandler({
                namespace: params.namespace,
                element: $panel,
                delegate: '> .menu__item',
                on_desktop: true,
                events: {
                    'mouseenter mouseleave': function(e) {
                        _._toggleMegamenu($(this), e);
                    }
                }
            });

            return {
                destroy: function() {
                    theme.Popups.removeHandler(_.settings.popup_name, 'close.before.closeMobileMenu');
                    _.handlerMenu.unbind();
                    _.handlerBack.unbind();
                    _.handlerDropdown.unbind();
                }
            }
        },
        _toggleMegamenu: function ($item, e) {
            var _ = this,
                $megamenu = $item.find('.menu__megamenu'),
                $dropdown = $item.find('.menu__dropdown');

            if(e.type === 'mouseenter') {
                if($megamenu.length) {
                    this.is_open_animate = true;

                    $megamenu.velocity('stop', true);
                    this.$dropdowns.velocity('finish');

                    this.$megamenus.not($megamenu).removeClass('show animate visible').removeAttr('style');
                    this.$dropdowns.removeClass('show animate visible').removeAttr('style');

                    $megamenu.addClass('show overflow-hidden');

                    var max_height = theme.current.height - $megamenu[0].getBoundingClientRect().top,
                        height = Math.min($megamenu.children().innerHeight(), max_height);

                    $megamenu.css({
                        'max-height': max_height
                    });

                    this.$curtain.velocity({
                        height: height,
                        tween: [height, this.$curtain.height()]
                    }, {

                        duration: this.duration(),
                        begin: function () {
                            _.$curtain.addClass('show');
                            $megamenu.addClass('animate visible');
                        },
                        progress: function (elements, c, r, s, t) {
                            $megamenu.height(t);
                        },
                        complete: function () {
                            $megamenu.removeClass('overflow-hidden').removeAttr('style');

                            _.is_open_animate = false;
                        }
                    });
                } else if($dropdown.length) {
                    $dropdown.addClass('show');

                    $dropdown.velocity('stop', true);
                    this.$megamenus.velocity('finish');

                    this.$dropdowns.not($dropdown).removeClass('show animate visible').removeAttr('style');
                    this.$megamenus.removeClass('show animate visible').removeAttr('style');

                    $dropdown.velocity('slideDown', {
                        duration: this.duration(),
                        begin: function () {
                            setTimeout(function () {
                                $dropdown.addClass('animate visible');
                            }, 0);
                        },
                        complete: function () {
                            $dropdown.removeAttr('style');
                        }
                    });
                }
            } else if(e.type === 'mouseleave') {
                if($megamenu.length && $megamenu.hasClass('show')) {
                    this.$curtain.velocity('stop');

                    $megamenu.velocity({
                        height: 0,
                        tween: [0, $megamenu.height()]
                    }, {
                        duration: this.duration(),
                        begin: function () {
                            $megamenu.addClass('overflow-hidden').removeClass('visible');
                        },
                        progress: function (elements, c, r, s, t) {
                            _.$curtain.height(t);
                        },
                        complete: function () {
                            $megamenu.removeClass('show animate overflow-hidden').removeAttr('style');

                            if(!_.is_open_animate) {
                                _.$curtain.removeClass('show').removeAttr('style');
                            }
                        }
                    });
                } else if($dropdown.length) {
                    $dropdown.velocity('slideUp', {
                        duration: this.duration(),
                        begin: function () {
                            $dropdown.removeClass('visible');
                        },
                        complete: function () {
                            $dropdown.removeClass('show animate').removeAttr('style');
                        }
                    });
                }
            }
        },
        closeMobileMenu: function() {
            if(theme.current.is_mobile) {
                var $panel = this.$menu.find('.menu__panel');

                $panel.find('.menu__item').removeClass('open');

                $panel.attr('data-mobile-level', '1');

                this.$menu.scrollTop(0);
            }
        }
    });

    theme.Menu = new Menu;
};

theme.Accordion = function() {

    function Accordion() {
        this.settings = {
            elements: 'data-js-accordion',
            button: 'data-js-accordion-button',
            duration: function () {
                return theme.animations.accordion.duration * 1000;
            }
        };

        this.selectors = {
            elements: '[' + this.settings.elements + ']',
            button: '[' + this.settings.button + ']',
            content: '[data-js-accordion-content]',
            input: '[data-js-accordion-input]'
        };

        this.load();
    };

    Accordion.prototype = $.extend({}, Accordion.prototype, {
        load: function() {
            var _ = this;

            function toggle(e) {
                var $this = $(this),
                    $input = $this.find(_.selectors.input),
                    $sticky = $('.js-sticky-sidebar');

                if($input.length) {
                    if(e.target.tagName === 'INPUT') {
                        return;
                    } else if($.contains($this.find('label')[0], e.target) && !$input.prop('checked') && $this.hasClass('open')) {
                        return;
                    }
                }

                var $element = $this.parents(_.selectors.elements).first(),
                    $content = $element.find(_.selectors.content).first();

                $this.toggleClass('open');

                $content.velocity('stop');

                if($this.hasClass('open')) {
                    $content.removeClass('d-none');

                    $content.velocity('slideDown', {
                        duration: _.settings.duration(),
                        progress: function () {
                            theme.StickySidebar.update($sticky);
                        },
                        complete: function () {
                            $content.removeAttr('style');

                            theme.StickySidebar.update($sticky);
                        }
                    });
                } else {
                    $content.velocity('slideUp', {
                        duration: _.settings.duration(),
                        progress: function () {
                            theme.StickySidebar.update($sticky);
                        },
                        complete: function () {
                            $content.addClass('d-none');
                            $content.removeAttr('style');

                            theme.StickySidebar.update($sticky);
                        }
                    });
                }

                $element.find(_.selectors.button)
                    .not($this)
                    .not($element.find(_.selectors.content).find(_.selectors.button))
                    .add($element.find('[' + _.settings.button + '="inner"]'))
                    [$this.hasClass('open') ? 'addClass' : 'removeClass']('open');
            };

            $body.on('click', '[' + this.settings.elements + '="all"] ' + this.selectors.button, toggle);

            theme.Global.responsiveHandler({
                namespace: '.accordion',
                element: $body,
                delegate: '[' + this.settings.elements + '="only-mobile"] ' + this.selectors.button,
                on_mobile: true,
                events: {
                    'click': toggle
                }
            });
        }
    });

    theme.Accordion = new Accordion;
};

theme.Tabs = function() {

    function Tabs() {

        this.selectors = {
            elements: '[data-js-tabs]'
        };

        this.load();
    };

    Tabs.prototype = $.extend({}, Tabs.prototype, {
        init: function ($tabs) {
            var $tabs = $tabs || $('.js-tabs').not('.tabs--init');

            var tabsObj = {
                singleOpen: true,
                anim_tab_duration: function () {
                    return theme.animations.tabs.duration * 1000;
                },
                anim_scroll_duration: function () {
                    return theme.animations.tabs.scroll_duration * 1000;
                },
                toggleOnDesktop: true,
                scrollToOpenMobile: true,
                effect: 'slide',
                offsetTop: '.header__content.header__content--sticky'
            };

            if($tabs.hasClass('product-tabs')) {
                tabsObj = $.extend(tabsObj, {
                    goToTab: [
                        {
                            elem: '.spr-badge-caption',
                            tab: 'reviews'
                        }
                    ]
                });
            }

            $tabs.ttTabs(tabsObj);
        },
        load: function() {
            $.fn.ttTabs = function (options) {
                function ttTabs(tabs) {
                    var $tabs = $(tabs),
                        $head = $tabs.find('[data-js-tabs-head]'),
                        $slider = $tabs.find('[data-js-tabs-slider]'),
                        $head_btns = $tabs.find('[data-js-tabs-btn]'),
                        $body_btns = $tabs.find('[data-js-tabs-btn-mobile]'),
                        $body_tabs = $tabs.find('[data-js-tabs-tab]'),
                        $btn_prev = $tabs.find('[data-js-tabs-nav-prev]'),
                        $btn_next = $tabs.find('[data-js-tabs-nav-next]'),
                        breakpoint = 1024,
                        type = $tabs.attr('data-type'),
                        scrollToOpenMobile = (options.scrollToOpenMobile !== undefined) ? options.scrollToOpenMobile : true,
                        singleOpen = (options.singleOpen !== undefined) ? options.singleOpen : true,
                        toggleOnDesktop = (options.toggleOnDesktop !== undefined) ? options.toggleOnDesktop : true,
                        effect = (options.effect !== undefined) ? options.effect : 'slide',
                        goToTab = options.goToTab;

                    function _closeTab($btn, data) {
                        var $animElem,
                            this_effect = data.effect || effect,
                            anim_obj = {
                                duration: options.anim_tab_duration(),
                                complete: function () {
                                    $(this).removeAttr('style');
                                }
                            };

                        function _anim_func($animElem) {
                            switch(this_effect) {
                                case 'toggle':
                                    $animElem.hide().removeAttr('style');
                                    break;
                                case 'slide':
                                    $animElem.velocity('slideUp', anim_obj);
                                    break;
                                default:
                                    $animElem.velocity('slideUp', anim_obj);
                            }
                        };

                        if(data.desktop || singleOpen) {
                            $head_btns.removeClass('active');
                            $animElem = $body_tabs.filter('.active').removeClass('active').find('[data-js-tabs-content]').stop();

                            _anim_func($animElem);
                        } else {
                            var index = $head_btns.index($btn);

                            $btn.removeClass('active');
                            $animElem = $body_tabs.eq(index).removeClass('active').find('[data-js-tabs-content]').stop();

                            _anim_func($animElem);
                        }
                    };

                    function _openTab($btn, data) {
                        var index = $head_btns.index($btn),
                            $body_tab_act = $body_tabs.eq(index),
                            $animElem,
                            $sticky = $('.js-sticky-sidebar'),
                            this_effect = data.effect || effect,
                            anim_obj = {
                                duration: options.anim_tab_duration(),
                                progress: function () {
                                    theme.StickySidebar.update($sticky);
                                },
                                complete: function () {
                                    if(data.after) {
                                        data.after($body_tab_act);
                                    }

                                    theme.StickySidebar.update($sticky);
                                }
                            };

                        function _anim_func($animElem) {
                            if($slider.hasClass('slick-initialized')) {
                                var btn_l = $btn.last().get(0).getBoundingClientRect().left,
                                    btn_r = $btn.last().get(0).getBoundingClientRect().right,
                                    slider_l = $slider.get(0).getBoundingClientRect().left,
                                    slider_r = $slider.get(0).getBoundingClientRect().right;

                                if(btn_r > slider_r) $slider.slick('slickNext');
                                else if(btn_l < slider_l) $slider.slick('slickPrev');
                            }

                            switch(this_effect) {
                                case 'toggle':
                                    $animElem.show();
                                    if(data.after) {
                                        data.after($body_tab_act);
                                    }
                                    break;
                                case 'slide':
                                    $animElem.velocity('slideDown', anim_obj);
                                    break;
                                default:
                                    $animElem.velocity('slideDown', anim_obj);
                            }
                        };

                        $btn.addClass('active');
                        $animElem = $body_tab_act.addClass('active').find('> div').stop();

                        _anim_func($animElem);
                    };

                    function _toTab(tab) {
                        var wind_w = window.innerWidth,
                            desktop = wind_w > breakpoint,
                            $btn = $head_btns.filter('[data-tab="' + tab + '"]');

                        function afterOpen() {
                            var tob_t = type === 'horizontal' && desktop ? $tabs.offset().top : $body_btns.eq($head_btns.index($btn)).offset().top,
                                header_h = theme.StickyHeader.$sticky ? theme.StickyHeader.$sticky.stickyHeader('getStickyHeight') : 0;

                            $('html, body').velocity( 'scroll' , {
                                offset: tob_t - header_h,
                                duration: options.anim_scroll_duration()
                            });
                        };

                        if(!$btn.hasClass('active')) {
                            _closeTab($btn, {
                                desktop: desktop,
                                effect: 'toggle'
                            });

                            _openTab($btn, {
                                desktop: desktop,
                                effect: 'toggle',
                                after: function () {
                                    afterOpen();
                                }
                            });
                        } else {
                            afterOpen();
                        }
                    };

                    function _btn_disabled(currentSlide) {
                        var btn_last_r = $head_btns.last().get(0).getBoundingClientRect().right,
                            slider_r = $slider.get(0).getBoundingClientRect().right;

                        if(currentSlide === 0) $btn_prev.addClass('disabled');
                        else $btn_prev.removeClass('disabled');

                        if(btn_last_r <= slider_r) $btn_next.addClass('disabled');
                        else $btn_next.removeClass('disabled');
                    };

                    function _slider_init() {
                        if($slider.hasClass('slick-initialized')) return;

                        $head.addClass('tabs__head--slider');

                        $slider.slick({
                            infinite: false,
                            slidesToShow: 1,
                            variableWidth: true,
                            draggable: false,
                            dots: false,
                            arrows: false
                        });

                        $btn_prev.addClass('disabled');

                        $slider.on('afterChange', function(e, slick, currentSlide) {
                            _btn_disabled(currentSlide);
                        });

                        $btn_prev.on('click', function() {
                            if($(this).hasClass('disabled')) return;
                            $slider.slick('slickPrev');
                        });

                        $btn_next.on('click', function() {
                            if($(this).hasClass('disabled')) return;
                            $slider.slick('slickNext');
                        });
                    };

                    function _slider_destroy() {
                        if(!$slider.hasClass('slick-initialized')) return;

                        $($slider, $btn_prev, $btn_next).off();

                        $slider.slick('unslick');

                        $head.removeClass('tabs__head--slider');
                    };

                    $head_btns.on('click', function (e, trigger) {
                        var $this = $(this),
                            wind_w = window.innerWidth,
                            desktop = wind_w > breakpoint,
                            trigger = (trigger === 'trigger') ? true : false;

                        if($this.hasClass('active')) {
                            if(desktop && !toggleOnDesktop) return;

                            _closeTab($this, {
                                desktop: desktop
                            });
                        } else {
                            _closeTab($this, {
                                desktop: desktop
                            });

                            _openTab($this, {
                                desktop: desktop,
                                after: function ($body_tab_act) {
                                    if (!desktop && !trigger && scrollToOpenMobile) {
                                        var tob_t = $body_tab_act.find('[data-js-tabs-btn-mobile]').offset().top,
                                            header_h = theme.StickyHeader.$sticky ? theme.StickyHeader.$sticky.stickyHeader('getStickyHeight') : 0;

                                        $('html, body').velocity('stop').velocity('scroll', {
                                            offset: tob_t - header_h,
                                            duration: options.anim_scroll_duration()
                                        });
                                    }
                                }
                            });
                        }
                    });

                    $body_btns.on('click', function () {
                        var $this = $(this),
                            $parent = $this.parent(),
                            index = $body_tabs.index($parent);

                        $head_btns.eq(index).trigger('click');
                    });

                    if($.isArray(goToTab) && goToTab.length) {
                        $(goToTab).each(function () {
                            var _ = this;

                            $body.on('click', this.elem, function (e) {
                                _toTab(_.tab, _.scrollTo, _.focus);

                                e.preventDefault();
                                return false;
                            });
                        });
                    }

                    if(type === 'horizontal') {
                        $(window).on('theme.resize updateTabs', function () {
                            var wind_w = window.innerWidth,
                                desktop = wind_w > breakpoint,
                                head_w = $slider.innerWidth(),
                                btns_w = 0;

                            $head_btns.each(function () {
                                btns_w += $(this).innerWidth();
                            });

                            if(desktop) {
                                var $btn_act = $head_btns.filter('.active');

                                if(!singleOpen && $btn_act.length > 1) {
                                    var $save_active = $btn_act.first();

                                    _closeTab('', {
                                        desktop: desktop
                                    });

                                    _openTab($save_active, {
                                        desktop: desktop
                                    });
                                }

                                if(btns_w > head_w) {
                                    _slider_init();
                                    if($slider.hasClass('slick-initialized')) {
                                        setTimeout(function() {
                                            _btn_disabled($head_btns.index($('[data-js-tabs-btn].slick-current')));
                                        }, 0);
                                    }
                                } else {
                                    _slider_destroy();
                                }
                            } else {
                                _slider_destroy();
                            }
                        });
                    }

                    $head_btns.filter('[data-active="true"]').trigger('click', ['trigger']);

                    $(window).trigger('updateTabs');

                    $tabs.addClass('tabs--init');

                    return $tabs;
                };

                $(this).each(function() {
                    new ttTabs(this);
                });
            };

            this.init();
        }
    });

    theme.Tabs = new Tabs;
};
theme.RangeOfPrice = function() {

    function RangeOfPrice() {
        this.dom = {};
    };

    RangeOfPrice.prototype = $.extend({}, RangeOfPrice.prototype, {
        init: function() {
            this.dom.$range = $('.js-range-of-price');

            if(this.dom.$range.length) {
                var params = {
                    type: "double",
                    force_edges: true,
                    prettify: function (data) {
                        return Shopify.formatMoney(data * 100, theme.moneyFormat);
                    }
                };

                if (Currency) {
                    this.dom.$range.on('change', function () {
                        theme.ProductCurrency.update();
                    });

                    $.extend(params, {
                        onStart: function () {
                            setTimeout(function () {
                                theme.ProductCurrency.update();
                            }, 0);
                        },
                        onFinish: function () {
                            theme.ProductCurrency.update();
                            theme.Collections.onChangeControls();
                        }
                    });
                }

                this.dom.$range.ionRangeSlider(params);
            }
        },
        destroy: function () {
            if(this.dom.$range && this.dom.$range.data('ionRangeSlider')) {
                this.dom.$range.ionRangeSlider('destroy');
                delete this.dom;
            }
        },
        update: function(from, to) {
            if(this.dom.$range) {
                var api = this.dom.$range.data('ionRangeSlider');

                api.update({
                    from: from,
                    to: to
                });
            }
        },
        reset: function() {
            if(this.dom.$range.length) {
                var api = this.dom.$range.data('ionRangeSlider');

                api.update({
                    from: api.result.min,
                    to: api.result.max
                });
            }
        }
    });

    theme.RangeOfPrice = new RangeOfPrice;
};



theme.Collections = function() {

    function Collections() {
        this.dom = {
            $collections: $('.js-collections')
        };

        if(this.dom.$collections.length) {
            this.load(); 
        }
    };

    Collections.prototype = $.extend({}, Collections.prototype, {
        current: {
            url: null,
            ajax: null
        },
        url: {
            collection: null,
            params: null
        },
        controls: {
            collection: null,
            params: null
        },
        content: {
            collection: null
        },
        _parseUrl: function() {
            var _ = this;

            this.current.url = decodeURIComponent(window.location.href);
            this.current.ajax = this.current.url;

            if(this.current.ajax.indexOf('view=') != -1) {
                $.each([6, 12, 18, 24], function() {
                    _.current.ajax.replace('view=' + this, 'view=' + this + '-ajax');
                });
            } else {
                this.current.ajax += this.current.ajax.indexOf('?') != -1 ? '&' : '?';
                this.current.ajax += 'view=ajax';
            }

            var search = this.current.url.split('collections/')[1].split('/');

            this.url.collection = search[0].split('?')[0];
            this.url.params = null;

            var is_custom_filter = this.current.url.indexOf('custom-filter') != -1 ? true : false;

            function parseParams(values) {
                $.each(values, function() {
                    if(this === 'custom-filter') {
                        return;
                    }

                    if(!_.url.params) {
                        _.url.params = {};
                    }

                    var param = this.split('='),
                        prop = param[0],
                        val = param[1];

                    if(prop === 'tag') {
                        prop = 'constraint';
                    }

                    if(!_.url.params[prop]) {
                        _.url.params[prop] = [];
                    }

                    _.url.params[prop].push(val);
                });
            };

            this.current.url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, k, v) {
                var values = v.split('+');

                if(is_custom_filter && k === 'constraint') {
                    parseParams(values);
                } else {
                    if(!_.url.params) {
                        _.url.params = {};
                    }

                    _.url.params[k] = values;
                }
            });

            if(search[1] && search[1].split('?')[0].length) {
                var values = search[1].split('?')[0].split('+');

                if(!_.url.params) {
                    _.url.params = {};
                }

                if(!_.url.params.constraint) {
                    _.url.params.constraint = [];
                }

                $.each(values, function () {
                    _.url.params.constraint.push(this);
                });
            }
        },
        _buildUrl: function(unset_url_params) {
            var _ = this,
                params = {},
                params_ajax = {},
                collection = this.controls.collection ? this.controls.collection : this.url.collection;

            this.current.url = '/collections/' + collection;

            if(this.controls.params) {
                if(this.controls.params.vendor || this.controls.params.type || this.controls.params.title || this.controls.params.price || this.controls.params.only_available || window.page.default.only_available) {
                    params.constraint = 'custom-filter';
                    params_ajax.constraint = 'custom-filter';
                    
                    $.each(['constraint', 'vendor', 'type', 'title', 'price', 'page', 'only_available'], function () {

                        if(_.controls.params[this]) {
                            var name = this === 'constraint' ? 'tag' : this,
                                is_unset = false;

                            $.each(unset_url_params, function () {
                                if(name === this) is_unset = true;
                            });

                            name = '+' + name + '=';

                            var value = name + _.controls.params[this].join(this === 'price' ? '-' : name);

                            if(!is_unset) params.constraint += value.replace(/ /gi, '-');
                            params_ajax.constraint += value.replace(/ /gi, '-');
                        }
                    });

                    if(!this.controls.params.only_available && window.page.default.only_available) {
                        params_ajax.constraint += '+only_available=true';
                    }

                    $.each(['sort_by', 'view'], function () {
                        if(_.controls.params[this]) {
                            var value =  _.controls.params[this][0];

                            params[this] = value;
                            params_ajax[this] = value;
                        }
                    });
                } else {
                    $.each(this.controls.params, function(k, v) {
                        var value = v.join('+');

                        params[k] = value;
                        params_ajax[k] = value;
                    });

                    $.each(unset_url_params, function () {
                        delete params[this];
                    });
                }
            }

            params_ajax.view = params_ajax.view ? params_ajax.view + '-ajax' : 'ajax';

            params = $.param(params);
            params_ajax = $.param(params_ajax);

            this.current.ajax = this.current.url;

            if(params) this.current.url += '?' + decodeURIComponent(params);
            if(params_ajax) this.current.ajax += '?' + decodeURIComponent(params_ajax);
        },
        _setUrl: function() {
            history.pushState({foo: 'filters'}, this.current.url, this.current.url);
        },
        _parseControls: function() {
            var _ = this,
                params = {};

            this.controls.collection = null;
            this.controls.params = null;

            $.each(['collection'], function() {
                var value = $('[name="' + this + '"]:checked').val();

                if(value) _.controls[this] = value;
            });

            if(!this.controls.collection) this.controls.collection = this.url.collection;

            $.each({
                'sort_by': 'sort_by',
                'view': 'view_length',
                'only_available': 'only_available'
            }, function(k, v) {
                var value = $('[name="' + v + '"]').val(),
                    default_value = window.page.default[v] + '';

                if(value && value !== default_value) params[k] = [value];
            });

            $.each({
                'constraint': [ 'collection_with_tag', 'filter_by_tag', 'filter_by_color' ],
                'vendor': 'filter_by_vendor',
                'type': 'filter_by_type'
            }, function(k, v) {
                var arr = [];

                $.each($.isArray(v) ? v : [ v ], function() {
                    $('[name="' + this + '"]:checked').each(function() {
                        var value = $(this).val();

                        for(var i = 0; i < arr.length; i++) {
                            if(arr[i] === value) return;
                        }

                        arr.push(value);
                    });
                });

                if(arr.length) {
                    params[k] = arr;
                }
            });

            $(['filter_by_title']).each(function() {
                var value = $('[name="' + this + '"]').val();

                if(value) params.title = [value];
            });

            $(['filter_by_price']).each(function() {
                var $this = $('[name="' + this + '"]'),
                    value = $this.val();

                if(value) {
                    var values = value ? value.split(';') : null,
                        from = values ? +values[0] : +$this.attr('data-from'),
                        to = values ? +values[1] : +$this.attr('data-to');

                    if(from !== +$this.attr('data-min') || to !== +$this.attr('data-max')) {
                        params['price'] = [from * 100, to * 100];
                    }
                }
            });

            $(['filter_by_title']).each(function() {
                var value = $('[name="' + this + '"]').val();

                if(value) params.title = [value];
            });

            $(['page']).each(function () {
                var value = $('[name="' + this + '"]').val();

                if(value && +value !== 1) params[this] = [value];
            });
            
            if(Object.keys(params).length) {
                this.controls.params = params;
            }
        },
        _setControls: function() {
            var _ = this;

            $.each({
                'sort_by': 'sort_by',
                'view': 'view_length'
            }, function(k, v) {
                var value = _.url.params && _.url.params[k] ? _.url.params[k] : window.page.default[v];

                $('[name="' + v + '"]').val(value).trigger('update');
            });

            $('[name="collection"]').removeAttr('checked');
            $('[name="collection"][value="' + this.url.collection + '"]').prop('checked', 'checked');

            $('[name="collection_with_tag"], [name="filter_by_tag"], [name="filter_by_color"], [name="filter_by_vendor"], [name="filter_by_type"], [name="only_available"]').removeAttr('checked');
            $.each({
                'constraint': [ 'collection_with_tag', 'filter_by_tag', 'filter_by_color' ],
                'vendor': 'filter_by_vendor',
                'type': 'filter_by_type',
                'only_available': 'only_available'
            }, function(k, v) {
                if(_.url.params && _.url.params[k]) {
                    $.each(_.url.params[k], function() {
                        var value = this;

                        $.each($.isArray(v) ? v : [ v ], function() {
                            var for_collection = this === 'collection_with_tag' ? '[data-section-for-collection="' + _.url.collection + '"] ' : '';

                            $(for_collection + '[name="' + this + '"][value="' + value + '"]').prop('checked', 'checked');
                        });
                    });
                }
            });

            $('[name="filter_by_title"]').val(this.url.params && this.url.params['title'] ? this.url.params['title'] : '');

            if(this.url.params && this.url.params['price']) {
                var price = this.url.params['price'][0].split('-');

                theme.RangeOfPrice.update(price[0] / 100, price[1] / 100);
            } else {
                theme.RangeOfPrice.reset();
            }
        },
        _checkCurrentFilters: function (params) {
            if(params) {
                delete params.page;
                delete params.sort_by;
                delete params.view;
            }

            this.$current_filter[params && Object.keys(params).length ? 'removeClass' : 'addClass']('d-none');
        },
        loadContent: function(current_obj, event_type, callback) {
            var _ = this;

            if(this.xhr) this.xhr.abort();

            theme.Loader.set($('[data-js-collection-replace="products"]'), {
                fixed: true,
                spinner: theme.current.is_mobile ? false : null
            });

            this.xhr = $.ajax({
                type: 'GET',
                url: this.current.ajax,
                cache: false,
                dataType: 'html',
                success: function (data) {
                    var $page = $(data);

                    theme.ProductsView.update($page.find('[data-js-products]'));

                    $('[data-js-collection-replace]').each(function () {
                        var $this = $(this),
                            full_replace = $this[0].hasAttribute('data-js-collection-replace-only-full');

                        if(_.content.collection === current_obj.collection && full_replace) return;

                        var name = $this.attr('data-js-collection-replace'),
                            $element = $('[data-js-collection-replace="' + name + '"]'),
                            $page_element = $page.find('[data-js-collection-replace="' + name + '"]');

                        if(event_type === 'page' && $element.attr('data-js-collection-replace-method') === 'add') {
                            $element.append($page_element.children());

                            if(name === 'products') {
                                theme.Loader.unset($element);
                            }
                        } else {
                            $element.replaceWith($page_element);

                            if(name === 'products') {
                                theme.Loader.unset($page_element);
                            }

                            $element.remove();
                        }

                        if(theme.current.is_mobile) {
                            theme.Loader.unset(_.$sidebar);
                        }
                    });

                    theme.ImagesLazyLoad.update();

                    if(_.content.collection !== current_obj.collection) {
                        $.each({
                            'sort_by': 'sort_by',
                            'view': 'view_length'
                        }, function(k, v) {
                            var value = current_obj.params && current_obj.params[k] ? current_obj.params[k] : window.page.default[v];

                            $('[name="' + v + '"]').val(value).trigger('update');
                        });
                    }

                    theme.ProductCurrency.update();
                    theme.StoreLists.checkProductStatus();
                    theme.ProductReview.update();
                    theme.Tooltip.init();

                    $page.remove();

                    _.xhr = null;

                    _.content.collection = current_obj.collection;

                    if(callback) {
                        callback();
                    }
                }
            });
        },
        removeFilter: function(type, value) {
            switch(type) {
                case 'tag': {
                    $('[name="collection_with_tag"], [name="filter_by_tag"], [name="filter_by_color"]').filter('[value="' + value + '"]').removeAttr('checked');
                    break;
                }
                case 'title': {
                    $('[name="filter_by_title"]').val('');
                    break;
                }
                case 'price': {
                    theme.RangeOfPrice.reset();
                    break;
                }
                case 'vendor': {
                    $('[name="filter_by_vendor"]').filter('[value="' + value + '"]').removeAttr('checked');
                    break;
                }
                case 'type': {
                    $('[name="filter_by_type"]').filter('[value="' + value + '"]').removeAttr('checked');
                    break;
                }
            }
        },
        onChangeControls: function(event_type, unset_url_params) {
            var _ = this;

            if(theme.current.is_mobile) {
                theme.Loader.set(this.$sidebar, {
                    fixed: true
                });
            }
            
            if(event_type !== 'page') {
                $('[name="page"]').val(1);
            }

            this._parseControls();
            this._buildUrl(unset_url_params);
            this._setUrl();
            this.loadContent(this.controls, event_type, function () {
                _._checkCurrentFilters(_.controls.params);
            });
        },
        onChangeHistory: function() {
            var _ = this;

            if(theme.current.is_mobile) {
                theme.Loader.set(this.$sidebar, {
                    fixed: true
                });
            }
            
            this._parseUrl();
            this._setControls();
            this.loadContent(this.url, null, function () {
                _._checkCurrentFilters(_.url.params);
            });
        },
        load: function() {
            var _ = this,
                $sidebar = $('[data-js-collection-sidebar]'),
                $sticky = $('.js-sticky-sidebar');

            this.$sidebar = $sidebar;
            this.$current_filter = $sidebar.find('[data-js-collection-nav-section="current_filters"]');
            
            this._parseUrl();
            this.content.collection = _.url.collection;

            $sidebar.on('change', '[data-js-collections-menu] input', function () {
                var $this = $(this),
                    name = $this.attr('name');

                if(name === 'collection') {
                    $('[data-js-collections-menu] [name="collection_with_tag"]:checked').removeAttr('checked');
                    $('[name="filter_by_tag"], [name="filter_by_color"], [name="filter_by_vendor"], [name="filter_by_type"]').removeAttr('checked');
                    $('[name="filter_by_title"]').val('');
                    $('[name="sort_by"]').val(page.default.sort_by);
                    $('[name="view"]').val(page.default.view_length);

                    $.each({
                        'sort_by': 'sort_by',
                        'view': 'view_length'
                    }, function(k, v) {
                        $('[name="' + v + '"]').val(window.page.default[v]).trigger('update');
                    });

                    theme.RangeOfPrice.reset();
                } else if(name === 'collection_with_tag') {
                    var $current_collection = $this.parents('.collections-menu__item').find('[name="collection"]'),
                        $remove_collections = $('[data-js-collections-menu] [name="collection"]:checked').not($current_collection);

                    $remove_collections.add($remove_collections.parents('.collections-menu__item').find('[name="collection_with_tag"]:checked')).removeAttr('checked');

                    if(!$current_collection.is(':checked')) {
                        theme.RangeOfPrice.reset();
                    }

                    $current_collection.prop('checked', 'checked');
                }

                _.onChangeControls();
            });

            $sidebar.on('click', '[data-js-collections-menu] [name="collection"]:checked',function() {
                var $this = $(this),
                    $collection_with_tag = $this.parents('.collections-menu__item').find('[name="collection_with_tag"]:checked');

                if($collection_with_tag.length) {
                    $collection_with_tag.removeAttr('checked');

                    $this.change();
                }
            });

            $sidebar.on('change', '[data-js-collection-filters] input', function () {
                _.onChangeControls();
            });

            $sidebar.on('change', '[name="only_available"]', function () {
                var $this = $(this),
                    value = $this.is(':checked') ? true : false;

                $this.attr('value', value);

                _.onChangeControls();
            });

            $sidebar.on('click', '[data-js-collection-filter-by-title] button', function () {
                _.onChangeControls();
            });

            $sidebar.on('keyup', '[data-js-collection-filter-by-title] input', $.debounce(500, function () {
                _.onChangeControls();
            }));

            this.dom.$collections.on('change', '[data-js-collection-sort-by] select, [data-js-collection-view-length] select', function () {
                _.onChangeControls();
            });

            this.dom.$collections.on('click', '[data-js-collection-pagination] a', function (e) {
                var $this = $(this),
                    $pagination = $this.parents('[data-js-collection-pagination]'),
                    value = $this.attr('data-value') || $this.attr('href').split('page=')[1].split('&')[0],
                    event_type = 'page',
                    unset_url_params;

                $('[name="page"]').val(value);

                if($pagination.attr('data-pagination-type') === 'button_load_more') {
                    unset_url_params = ['page'];
                }

                _.onChangeControls(event_type, unset_url_params);

                e.preventDefault();
                return false;
            });

            $sidebar.on('click', '[data-js-collection-current-tags] [data-value]', function () {
                var $this = $(this),
                    value = $this.attr('data-value'),
                    type = $this.attr('data-filter-type');

                _.removeFilter(type, value);

                _.onChangeControls();
            });

            $sidebar.on('click', '[data-js-collection-current-tags-clear]', function () {
                $('[data-js-collection-current-tags] [data-value]').each(function() {
                    var $this = $(this),
                        value = $this.attr('data-value'),
                        type = $this.attr('data-filter-type');

                    _.removeFilter(type, value);
                });

                _.onChangeControls();
            });
            
            $(window).on('popstate', function() {
                _.onChangeHistory();
            });

            $body.on('lazyloaded', '[data-js-collection-replace="products"] img', function () {
                theme.StickySidebar.update($sticky);
            });
        },
        logs: function() {
            console.log('current', this.current);
            console.log('url', this.url);
            console.log('controls', this.controls);
            console.log('content', this.content);
            console.log(this.logId ? ++this.logId : this.logId = 1);
        }
    });

    theme.Collections = new Collections;
};



theme.StickySidebar = function() {
    function StickySidebar() {
        this.selectors = {
            elements: '.js-sticky-sidebar'
        };
    };

    StickySidebar.prototype = $.extend({}, StickySidebar.prototype, {
        init: function ($container, is_parent) {
            if(edge || ie) {
                return;
            }

            var $sticky = $container[is_parent ? 'parents' : 'find'](this.selectors.elements);

            if($sticky.length) {
                if(moz && $sticky[0].hasAttribute('data-disable-moz')) {
                    return;
                }

                function calculate($sticky) {
                    $sticky.each(function () {
                        var $this = $(this),
                            $inner = $this.find('[data-sticky-sidebar-inner]');

                        if(theme.current.is_desktop) {
                            if(!$this.hasClass('initialize')) {
                                var $parent = $this.parents('[data-sticky-sidebar-parent]'),
                                    topSpacing = theme.StickyHeader.$sticky ? theme.StickyHeader.$sticky.stickyHeader('getStickyHeight') : 0,
                                    bottomSpacing = 0,
                                    own_topSpacing = $this.attr('data-top-spacing'),
                                    own_bottomSpacing = $this.attr('data-bottom-spacing');

                                if(own_topSpacing !== undefined) {
                                    topSpacing += +own_topSpacing;
                                }

                                if(own_bottomSpacing !== undefined) {
                                    bottomSpacing += +own_bottomSpacing;
                                }

                                $this.stickySidebar({
                                    containerSelector: $parent,
                                    innerWrapperSelector: $inner,
                                    topSpacing: topSpacing,
                                    bottomSpacing: bottomSpacing
                                }).addClass('initialize active');
                            } else if(!$this.hasClass('active')) {
                                $this.stickySidebar('updateSticky');
                                $this.addClass('active');
                            }
                        } else {
                            if($this.hasClass('initialize active')) {
                                $this.stickySidebar('destroy');
                                $this.removeClass('initialize active');
                                $this.removeAttr('style');
                                $inner.removeAttr('style');
                            }
                        }
                    });
                };

                $window.on('theme.changed.breakpoint.sticky-sidebar', function () {
                    calculate($sticky);
                });

                calculate($sticky);
            }
        },
        update: function ($sticky) {
            if(edge || ie) {
                return;
            }

            if($sticky.length && theme.current.is_desktop) {
                if(moz && $sticky[0].hasAttribute('data-disable-moz')) {
                    return;
                }

                $sticky.stickySidebar('updateSticky');
            }
        },
        destroy: function ($container, is_parent) {
            if(edge || ie) {
                return;
            }

            var $sticky = $container[is_parent ? 'parents' : 'find'](this.selectors.elements);

            if($sticky.length && $sticky.hasClass('initialize')) {
                if(moz && $sticky[0].hasAttribute('data-disable-moz')) {
                    return;
                }

                $window.unbind('theme.changed.breakpoint.sticky-sidebar');
                $sticky.stickySidebar('destroy');
            }
        }
    });

    theme.StickySidebar = new StickySidebar;
};
theme.ButtonsBlocksVisibility = function() {

    function ButtonsBlocksVisibility() {
        this.selectors = {
            buttons: '.js-button-block-visibility'
        };

        this.load();
    };

    ButtonsBlocksVisibility.prototype = $.extend({}, ButtonsBlocksVisibility.prototype, {
        load: function() {
            $('[data-block-visibility]').each(function () {
                var $this = $(this),
                    name = $this.attr('data-block-visibility');

                if(window.location.href.indexOf(name) != -1) {
                    $this.removeClass('d-none-important');

                    $this.find('[data-block-visibility-focus]').focus();
                }
            });

            $body.on('click', this.selectors.buttons, function (e) {
                var $this = $(this),
                    name = $this.attr('data-block-link'),
                    $block = $('[data-block-visibility="' + name + '"]');

                if($block.length) {
                    var close_popup = $this.attr('data-action-close-popup');

                    $block[$this.attr('data-action') === 'close' ? 'addClass' : $this.attr('data-action') === 'open' ? 'removeClass' : 'toggleClass']('d-none-important');

                    if(close_popup) theme.Popups.closeByName(close_popup);

                    if(!$block.hasClass('d-none-important')) $block.find('[data-block-visibility-focus]').focus();

                    e.preventDefault();
                    return false;
                }
            });
        }
    });

    theme.ButtonsBlocksVisibility = new ButtonsBlocksVisibility;
};
theme.Tooltip = function() {

    function Tooltip() {
        this.params = {
            size: 'small',
            arrow: true,
            animation: 'fade',
            inertia: false,
            duration: [200, 0],
            delay: 0,
            theme: 'shella'
        };

        this.load();
    };

    Tooltip.prototype = $.extend({}, Tooltip.prototype, {
        load: function () {
            this.params = $.extend(this.params, {
                animation: window.theme.animations.tooltip.type,
                inertia: window.theme.animations.tooltip.inertia,
                touch: false
            });

            this.init();
        },
        init: function (obj) {
            this.params = $.extend(this.params, {
                duration: [window.theme.animations.tooltip.show_duration * 1000, window.theme.animations.tooltip.hide_duration * 1000]
            });

            if(obj) {
                this.params = $.extend(this.params, obj); 
            }

            this.api = tippy('[data-js-tooltip]', this.params);
        },
        reinit: function (obj) {
            this.destroy();
            this.init(obj);
        },
        destroy: function () {
            if(this.api) {
                this.api.destroyAll();
                this.api = null;
            }
        }
    });

    theme.Tooltip = new Tooltip;
};
theme.Trigger = function() {

    function Trigger() {
        this.load();
    };

    Trigger.prototype = $.extend({}, Trigger.prototype, {
        load: function () {
            var _ = this;

            $body.on('click', '[data-js-trigger]', function () {
                _.process($(this).attr('data-js-trigger'));
            });
        },
        process: function (id, event) {
            event = event || 'click';

            $('[data-js-trigger-id="' + id + '"]').trigger(event);
        }
    });

    theme.Trigger = new Trigger;
};

/*================ Sections ================*/
var Section = {};

Section.prototype = $.extend({}, Section.prototype, {
    _registerHansler: function() {
        if(!this.elemsHasHandler) {
            this.elemsHasHandler = [];
        }

        for (var i = 0; i < arguments.length; i++) {
            this.elemsHasHandler.push(arguments[i]);
        }
    },
    _offHanslers: function() {
        if(this.elemsHasHandler && $.isArray(this.elemsHasHandler)) {
            for (var i = 0; i < this.elemsHasHandler.length; i++) {
                $(this.elemsHasHandler[i]).off();
            }
            
            delete this.elemsHasHandler;
        }
    }
});

theme.Header = (function() {

    var selectors = {
        menu: '.js-menu'
    };

    function Header(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.header';

        this.onLoad();
    };

    Header.prototype = $.extend({}, Section.prototype, Header.prototype, {
        _tape: function () {
            var $tape = this.$container.find('.js-header-tape'),
                duration = function () {
                    return theme.animations.header_tape.duration * 1000;
                };

            if($tape.length) {
                var $btn_close = $tape.find('[data-js-action="close"]'),
                    cookie = $.cookie('header-tape'),
                    show_once = $tape.attr('data-js-show-once'),
                    delay = +$tape.attr('data-js-delay'),
                    cookies_life = +$tape.attr('data-js-cookies-life');

                if(cookie !== 'off') {
                    setTimeout(function () {
                        $tape.removeClass('d-none');

                        $tape.velocity('slideDown', {
                            duration: duration(),
                            complete: function () {
                                $tape.removeAttr('style');
                            }
                        });
                    }, delay * 1000);

                    $btn_close.on('click', function() {
                        if(show_once === 'true') {
                            var date = new Date(),
                                timer = 24 * 60 * 60 * 1000 * cookies_life;

                            date.setTime(date.getTime() + timer);

                            $.cookie('header-tape', 'off', {
                                expires: date,
                                path: '/'
                            });
                        }

                        $(this).off();

                        $tape.velocity('slideUp', {
                            duration: duration(),
                            complete: function () {
                                $tape.remove();
                            }
                        });
                    });
                }

                this._registerHansler($btn_close);
            }
        },
        _menu: {
            init: function(namespace) {
                var $menu = $(selectors.menu);

                if($menu.length) {
                    this.$menu = $menu;

                    this.api = theme.Menu.init($menu, {
                        namespace: namespace
                    });
                }
            },
            destroy: function() {
                if(this.api) {
                    this.$menu.unbind('mouseenter');

                    this.api.destroy();
                    this.api = null;
                }

                if(this.handler) {
                    this.handler.destroy();
                }
            }
        },
        _sticky: {
            init: function() {
                var $sticky = $('.js-header-sticky'),
                    sticky = $sticky.attr('data-js-sticky'),
                    need_sidebar = $sticky.attr('data-js-desktop-sticky-sidebar');

                if($sticky.length) {
                    var params = {
                        bp: 1024
                    };

                    if(sticky === 'desktop_and_mobile' || sticky === 'desktop') {
                        $.extend(params, {
                            desktop: {
                                sticky: '[data-js-desktop-sticky]',
                                limit: 'bottom',
                                fade: true,
                                duration: function () {
                                    return theme.animations.sticky_header.duration * 1000;
                                }
                            }
                        });
                        
                        if(need_sidebar === 'true') {
                            $.extend(params.desktop, {
                                move: [
                                    {
                                        elem: '[data-js-sticky-replace-element="logo"]',
                                        to: '[data-js-sticky-replace-here="logo"]'
                                    },
                                    {
                                        elem: '[data-js-sticky-replace-element="cart"]',
                                        to: '[data-js-sticky-replace-here="cart"]'
                                    },
                                    {
                                        elem: '[data-js-sticky-replace-element="wishlist"]',
                                        to: '[data-js-sticky-replace-here="wishlist"]'
                                    },
                                    {
                                        elem: '[data-js-sticky-replace-element="compare"]',
                                        to: '[data-js-sticky-replace-here="compare"]'
                                    }
                                ]
                            });
                        }
                    }

                    if(sticky === 'desktop_and_mobile' || sticky === 'mobile') {
                        $.extend(params, {
                            mobile: {
                                sticky: '[data-js-mobile-sticky]',
                                limit: 'bottom',
                                fade: false
                            }
                        });
                    }

                    this.api = theme.StickyHeader.init($sticky, params);
                }
            },
            destroy: function() {
                if(this.api) {
                    this.api.destroy();
                    this.api = null;
                }
            }
        },
        _languages: {
            init: function() {
                var _ = this;

                $(window).on('load', function() {
                    var $languages = $('.js-languages-list'),
                        $weglot = $('.weglot-container').eq(0);
                    
                    if($languages.length && $weglot.length) {
                        var $weglot_current = $weglot.find('.wgcurrent'),
                            $weglot_list = $weglot.find('ul'),
                            $header_current = $languages.find('.header__btn-language span'),
                            $header_list = $languages.find('ul');

                        _.$header_list = $header_list;

                        function insert() {
                            var current_html = $weglot_current.find('a').html(),
                                $span = $('<span>').html(current_html),
                                $li = $('<li>').addClass('active').attr('data-l', $weglot_current.attr('data-l')).append($span);

                            $header_current.html(current_html);

                            $header_list.html('').append($li);

                            $weglot_list.find('li').each(function() {
                                var $this = $(this),
                                    $span = $('<span>').html($this.find('a').html()),
                                    $li = $('<li>').attr('data-l', $this.attr('data-l')).append($span);

                                $header_list.append($li);
                            });
                        };

                        function update() {
                            var current_code = $weglot_current.attr('data-l'),
                                current_html = $weglot_current.find('a').html();

                            $header_current.html(current_html);

                            $header_list.find('li').removeClass('active').filter('[data-l="' + current_code + '"]').addClass('active');
                        };

                        insert();

                        $languages.removeClass('d-none-important');

                        $header_list.on('click', 'li:not(.active)', function() {
                            var $this = $(this);

                            $weglot_list.find('li[data-l="' + $this.attr('data-l') + '"] a').trigger('click');

                            update();

                            $this.parents('[data-js-dropdown]').trigger('hide');
                        });
                    }
                });
            },
            destroy: function() {
                if(this.api) {
                    this.api.destroy();
                    this.api = null;
                }

                if(this.$header_list) {
                    this.$header_list.off();
                }
            }
        },
        _currency: {
            init: function(namespace) {
                var $currencies = $('.js-currencies-list');
                
                if($currencies.length && theme.ProductCurrency) {
                    var namespace = namespace + '.currencies',
                        $current_currency = $currencies.find('[data-current-currency]'),
                        cookieCurrency;

                    try {
                        cookieCurrency = Currency.cookie.read();
                    } catch(err) {}

                    function cheackList(currentCurrency) {
                        var active_button_name;

                        $currencies.find('li').each(function () {
                            var $this = $(this);

                            if ($this.data('currency-code') == currentCurrency) {
                                $this.addClass('active');

                                active_button_name = $this.attr('data-button-name') || currentCurrency;
                            } else {
                                $this.removeClass('active');
                            }
                        });

                        return active_button_name;
                    };

                    if(cookieCurrency != null && cookieCurrency !== Currency.shopCurrency) {
                        var button_name = cheackList(cookieCurrency);

                        $current_currency.html(button_name);
                    }

                    $currencies.on('click' + namespace, 'li', function (e) {
                        var $this = $(this);

                        if(!$this.hasClass('active')) {
                            var newCurrency = $this.data('currency-code'),
                                button_name = $this.attr('data-button-name') || newCurrency;

                            theme.ProductCurrency.setCurrency(newCurrency);

                            cheackList(newCurrency);
                            $current_currency.html(button_name);

                            if(theme.current.is_desktop) {
                                $this.parents('[data-js-dropdown]').trigger('hide');
                            } else {
                                theme.Popups.closeByName('navigation');
                            }
                        }

                        e.preventDefault();
                        return false;
                    });

                    this.api = {
                        destroy: function() {
                            $body.unbind('click' + namespace);
                        }
                    };
                }
            },
            destroy: function() {
                if(this.api) {
                    this.api.destroy();
                    this.api = null;
                }
            }
        },
        onLoad: function() {
            if(theme.is_loaded) {
                theme.Position.update('menu');
                theme.Position.update('currency');
                theme.Tooltip.init();
            }

            theme.StoreLists.updateHeaderCount();

            this._menu.init(this.namespace);
            this._sticky.init();
            this._tape();
            this._languages.init();
            this._currency.init(this.namespace);
        },
        onUnload: function() {
            this.$container.off(this.namespace);
            this._offHanslers();
            this._menu.destroy();
            this._sticky.destroy();
            this._languages.init();
            this._currency.destroy();
            theme.Tooltip.destroy();
        }
    });

    return Header;
})();

theme.SliderRevolution = (function() {

	function SliderRevolution(container) {
		this.$container = $(container);

		//var sectionId = this.$container.attr('data-section-id');

		//this.settings = {};

		this.namespace = '.slider-revolution';

		this.onLoad();
	};

	SliderRevolution.prototype = $.extend({}, Section.prototype, SliderRevolution.prototype, {
		onLoad: function() {
			try {
				this.revapi = page.RevolutionInit();
			} catch(e) {
				console.log('JavaScript Error', e);
			}
		},
		onUnload: function() {
			this.$container.off(this.namespace);

			if(this.revapi) {
				this.revapi.revkill();
			}
		}
	});

	return SliderRevolution;
})();
theme.HomeBuilder = (function() {

	function HomeBuilder(container) {
		this.$container = $(container);

		//var sectionId = this.$container.attr('data-section-id');

		//this.settings = {};

		this.namespace = '.home-builder';

		this.onLoad();
	};

	HomeBuilder.prototype = $.extend({}, Section.prototype, HomeBuilder.prototype, {
		onLoad: function() {
			var _ = this,
				$slider = this.$container.find('.rev_slider'),
				$instafeed = this.$container.find('#instafeed'),
				$promobox = this.$container.find('.promobox'),
				$products = $('.product-featured');

			$slider.each(function () {
				var $this = $(this),
					gridwidth = $this.data('gridwidth').split(','),
					gridheight = $this.data('gridheight').split(','),
					minheight = $this.data('minheight');

				var revapi = $this.show().revolution({
					sliderLayout: 'auto',
					responsiveLevels: [1259, 1024, 777, 540],
					gridwidth: [+gridwidth[0], +gridwidth[1], +gridwidth[2], +gridwidth[3]],
					gridheight: [+gridheight[0], +gridheight[1], +gridheight[2], +gridheight[3]],
					minHeight: minheight !== undefined ? minheight : false,
					visibilityLevels:[1259, 1024, 777, 540],
					delay: $this.data('delay') * 1000,
					disableProgressBar: 'on',
					lazyType: 'single',
					spinner: 'none',
					navigation: {
						arrows: {
							enable: $this.data('arrows'),
							style: 'uranus',
							hide_onleave: false
						},
						bullets: {
							enable: $this.data('bullets'),
							h_align: 'center',
							v_align: 'bottom',
							h_offset: 0,
							v_offset: 74,
							space: 24,
							hide_onleave: false
						},
						touch: {
							touchenabled: 'on'
						}
					},
					parallax: {
						type: 'mouse',
						origo: 'slidercenter',
						speed: 400,
						levels: [2,4,6,8,10,12,14,16,18,20,25,30,35,40,45,50],
						disable_onmobile: 'on'
					}
				});

				_.$container.one('section.unload', function () {
					revapi.revkill();
				});
			});

			if($instafeed.length) {
				var template = $($instafeed.find('template')[0].content).children().html();

				$instafeed.on('lazyloaded', 'img', function () {
					if(!$instafeed.find('[data-src]').length) {
						$instafeed.removeClass('invisible');
					}
				});

				var feed = new Instafeed({
					get: 'user',
					sortBy: 'most-liked',
					resolution: "standard_resolution",
					userId: $instafeed.data('userid'),
					clientId: $instafeed.data('clientid'),
					accessToken: $instafeed.data('accesstoken'),
					limit: $instafeed.data('limit'),
					template: template.replace(/{\\{/g, '{{').replace(/post-link/g, '{{link}}').replace(/post-image/g, '{{image}}'),
					after: function () {
						if($instafeed.find('img').length) {
							theme.ImagesLazyLoad.update();
						} else {
							$instafeed.removeClass('invisible');
						}
					}
				});

				$instafeed.html('').removeClass('d-none');

				feed.run();
			}

			if($promobox.length) {
				var $image = $promobox.find('img');

				if(theme.is_loaded && $image.length && $image[0].hasAttribute('data-src')) {
					$image.on('lazyloaded', function () {
						theme.Parallax.init(_.$container.find('.js-parallax'));
					});
				} else {
					theme.Parallax.init(_.$container.find('.js-parallax'));
				}
			}

			if($promobox.length || $products.length) {
				if(theme.is_loaded) {
					theme.ImagesLazyLoad.update();
				}
			}

			if($products.length) {
				if(theme.is_loaded) {
					theme.ProductReview.update();
					theme.Tooltip.init();
				}
			}
		},
		onUnload: function() {
			this.$container.off(this.namespace);

			this.$container.trigger('section.unload');

			theme.Tooltip.destroy();

			theme.Parallax.destroy(this.$container.find('.js-parallax'));
		}
	});

	return HomeBuilder;
})();
theme.listCollections = (function() {

	function listCollections(container) {
		this.$container = $(container);

		//var sectionId = this.$container.attr('data-section-id');

		//this.settings = {};

		this.namespace = '.list-collections';

		this.onLoad();
	};

	listCollections.prototype = $.extend({}, Section.prototype, listCollections.prototype, {
		onLoad: function() {
			if(theme.is_loaded) {
				theme.ImagesLazyLoad.update();
				theme.Masonry.init(true);
			}
		},
		onUnload: function() {
			this.$container.off(this.namespace);

			theme.Masonry.destroy();
		}
	});

	return listCollections;
})();
theme.ProductPage = (function() {

  function ProductPage(container) {
    this.$container = $(container);

    //var sectionId = this.$container.attr('data-section-id');

    //this.settings = {};

    this.namespace = '.product-page';

    this.onLoad();
  }

  ProductPage.prototype = $.extend({}, ProductPage.prototype, {
    onLoad: function () {
      var $product = this.$container.find('[data-js-product]'),
          $gallery = $product.find('[data-js-product-gallery]'),
          $countdown = $product.find('[data-js-product-countdown] .js-countdown'),
          $text_countdown = $product.find('.js-text-countdown'),
          $visitors = $product.find('.js-visitors');

      if($gallery.length) {
        this.$gallery = $gallery;
        
        if(this.$gallery.find('[data-js-product-gallery-main]').attr('data-js-product-gallery-main') === 'mobile') {
          function initGallery() {
            if(theme.current.is_mobile) {
              theme.ProductGallery.init($gallery);
            }
          };

          $window.on('theme.resize', initGallery);

          initGallery();
        } else {
          theme.ProductGallery.init($gallery);
        }
      }

      if(theme.is_loaded) {
        theme.ProductReview.update();
        theme.Tooltip.init();

        if($countdown.length) {
          theme.ProductCountdown.init($countdown);
        }
        
        if($text_countdown.length) {
          theme.ProductTextCountdown.init($text_countdown);
        }

        if($visitors.length) {
          theme.ProductVisitors.init($visitors);
        }

        theme.StoreLists.checkProductStatus($product);

        theme.Tabs.init();
      }

      theme.StickySidebar.init(this.$container);
    },
    onUnload: function() {
      this.$container.off(this.namespace);

      if(this.$gallery && this.$gallery.length) {
        theme.ProductGallery.destroy(this.$gallery);
        this.$gallery = null;
      }

      theme.StickySidebar.destroy(this.$container);

      theme.Tooltip.destroy();
    }
  });

  return ProductPage;
})();

theme.CollectionSidebar = (function() {

    function CollectionSidebar(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.collection-sidebar';

        this.onLoad();
    };

    CollectionSidebar.prototype = $.extend({}, Section.prototype, CollectionSidebar.prototype, {
        _rangePrice: {
            init: function() {
                theme.RangeOfPrice.init();
            },
            destroy: function() {
                theme.RangeOfPrice.destroy();
            }
        },
        onLoad: function() {
            theme.StickySidebar.init(this.$container, true);
            this._rangePrice.init();

            if(theme.is_loaded) {
                theme.ImagesLazyLoad.update();
                theme.ProductReview.update();
            }
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            theme.StickySidebar.destroy(this.$container, true);
            this._rangePrice.destroy();
        }
    });

    return CollectionSidebar;
})();

theme.CarouselProducts = (function() {

    function CarouselProducts(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.carousel-products';

        this.onLoad();
    };

    CarouselProducts.prototype = $.extend({}, Section.prototype, CarouselProducts.prototype, {
        _checkProduct: function ($slide, beforeAjax) {
            var _ = this,
                handle = $slide.attr('data-handle');

            if(handle) {
                if(beforeAjax) {
                    beforeAjax($slide);
                }

                $.ajax({
                    type: 'GET',
                    url: 'https://' + window.location.hostname + '/products/' + handle,
                    data: {
                        view: 'collection'
                    },
                    cache: false,
                    dataType: 'html',
                    success: function (data) {
                        var $data = $(data).clone();

                        $data.find('img').one('load', function () {
                            $slide.add(_.$slick.find('.slick-cloned[data-handle="' + handle + '"]')).html($data).removeAttr('data-handle');
                        });

                        $slide.trigger('loaded');
                    }
                });

                return true;
            } else {
                return false;
            }
        },
        onLoad: function() {
            var _ = this,
                $carousel = this.$container.find('[data-js-carousel]'),
                $slick = this.$container.find('[data-js-carousel-slick]'),
                $control = this.$container.find('[data-carousel-control]'),
                $products = this.$container.find('[data-carousel-items]'),
                xhr = null;

            this.$control = $control;

            if($slick.length) {
                var $slides = $slick.find('> *'),
                    $prev = $carousel.find('[data-js-carousel-prev]'),
                    $next = $carousel.find('[data-js-carousel-next]'),
                    $arrows = $prev.add($next),
                    count = +$carousel.attr('data-count'),
                    autoplay = $carousel.attr('data-autoplay') === 'true' ? true : false,
                    speed = +$carousel.attr('data-speed'),
                    infinite = $carousel.attr('data-infinite') === 'true' ? true : false,
                    arrows = $carousel.attr('data-arrows') === 'true' ? true : false,
                    bullets = $carousel.attr('data-bullets') === 'true' ? true : false;

                this.$slick = $slick;

                if(arrows) {
                    function arrowsPosition() {
                        var max_height = 0;

                        $slick.find('.carousel__item img').each(function () {
                            max_height = Math.max(max_height, $(this).innerHeight());
                        });

                        $arrows.css({top: max_height / 2});
                    };

                    $window.on('theme.resize.carousel-products', arrowsPosition);

                    $carousel.on('lazyloaded', 'img', function () {
                        arrowsPosition();
                    });
                }

                function initSlick() {
                    $slick.one('init', function() {
                        $carousel.removeClass('invisible');

                        theme.Loader.unset($carousel.parent());
                    });

                    $slick.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        var check_before = nextSlide - 1,
                            check_after = nextSlide + count;

                        function beforeAjax($slide) {
                            $slides.unbind('loaded');

                            $slide.one('loaded', function () {
                                theme.ProductReview.update();
                            });
                        };

                        _._checkProduct($slick.find('[data-slick-index="' + check_before + '"]'), beforeAjax);

                        for(var i = check_after; i > currentSlide + 1; i--) {
                            _._checkProduct($slick.find('[data-slick-index="' + i + '"]'), beforeAjax);
                        }
                    });

                    $slick.on('afterChange', function () {
                        theme.Tooltip.init();
                    });
                    
                    $slick.slick({
                        arrows: arrows,
                        prevArrow: $prev,
                        nextArrow: $next,
                        dots: bullets,
                        dotsClass: 'slick-dots d-flex flex-wrap flex-center list-unstyled mt-7',
                        adaptiveHeight: true,
                        autoplay: autoplay,
                        autoplaySpeed: speed,
                        infinite: infinite,
                        slidesToShow: count,
                        slidesToScroll: count,
                        rtl: theme.rtl,
                        responsive: [
                            {
                                breakpoint: theme.breakpoints.values.xl,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3
                                }
                            },
                            {
                                breakpoint: theme.breakpoints.values.md,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2
                                }
                            },
                            {
                                breakpoint: theme.breakpoints.values.sm,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2
                                }
                            }
                        ]
                    });
                };

                initSlick();

                $control.on('click', 'a', function (e) {
                    var $this = $(this);

                    if(!$this.hasClass('active')) {
                        if(xhr) {
                            xhr.abort();
                        }

                        theme.Loader.set($carousel);

                        $carousel.css({
                            'min-height': $products.innerHeight()
                        });

                        var collection = $this.attr('data-collection');

                        xhr = $.ajax({
                            type: 'GET',
                            url: '/collections/' + collection,
                            cache: false,
                            data: {
                                view: 'carousel',
                                constraint: 'max_count=' + $products.attr('data-max-count') + '+products_pre_row=' + $products.attr('data-products-pre-row') + '+async_ajax_loading=' + $products.attr('data-async-ajax-loading')
                            },
                            dataType: 'html',
                            success: function (data) {
                                $carousel.addClass('invisible');

                                $slick.slick('destroy').off();

                                $slick.one('init', function () {
                                    $carousel.removeAttr('style');

                                    theme.Loader.unset($carousel);
                                });

                                $products.html(data);

                                $slides = $slick.find('> *');

                                initSlick();

                                theme.ImagesLazyLoad.update();
                                theme.ProductReview.update();
                                theme.Tooltip.init();

                                $control.find('a').removeClass('active');
                                $this.addClass('active');

                                xhr = null;
                            }
                        });
                    }

                    e.preventDefault();
                    return false;
                });

                if(theme.is_loaded) {
                    theme.ImagesLazyLoad.update();
                    theme.ProductReview.update();
                    theme.Tooltip.init();
                }
            }
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            if(this.$slick) {
                this.$slick.slick('destroy').off();
                this.$slick = null;

                $window.unbind('theme.resize.carousel-products');
            }

            this.$control.off();

            theme.Tooltip.destroy();
        }
    });

    return CarouselProducts;
})();

theme.CarouselBrands = (function() {

    function CarouselBrands(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.carousel-brands';

        this.onLoad();
    };

    CarouselBrands.prototype = $.extend({}, Section.prototype, CarouselBrands.prototype, {
        onLoad: function() {
            var $carousel = this.$container.find('[data-js-carousel]'),
                $slick = $carousel.find('[data-js-carousel-slick]');

            if($slick.length) {
                var $prev = $carousel.find('[data-js-carousel-prev]'),
                    $next = $carousel.find('[data-js-carousel-next]'),
                    $arrows = $prev.add($next),
                    count = +$carousel.attr('data-count'),
                    autoplay = $carousel.attr('data-autoplay') === 'true' ? true : false,
                    speed = +$carousel.attr('data-speed'),
                    infinite = $carousel.attr('data-infinite') === 'true' ? true : false,
                    arrows = $carousel.attr('data-arrows') === 'true' ? true : false,
                    bullets = $carousel.attr('data-bullets') === 'true' ? true : false;

                this.$slick = $slick;

                if(arrows) {
                    function arrowsPosition() {
                        var max_height = 0;

                        $slick.find('.carousel__item').each(function () {
                            max_height = Math.max(max_height, $(this).innerHeight());
                        });

                        $arrows.css({ top: max_height/2 });
                    };

                    $window.on('theme.resize.carousel-brands', arrowsPosition);

                    $carousel.on('lazyloaded', 'img', function () {
                        arrowsPosition();
                    });
                }

                $slick.on('init', function() {
                    $carousel.removeClass('invisible');

                    theme.Loader.unset($carousel.parent());
                });
                
                $slick.slick({
                    arrows: arrows,
                    prevArrow: $prev,
                    nextArrow: $next,
                    dots: bullets,
                    dotsClass: 'slick-dots d-flex flex-wrap flex-center list-unstyled mt-40',
                    adaptiveHeight: true,
                    autoplay: autoplay,
                    autoplaySpeed: speed,
                    infinite: infinite,
                    slidesToShow: count,
                    slidesToScroll: count,
                    rtl: theme.rtl,
                    responsive: [
                        {
                            breakpoint: theme.breakpoints.values.xl,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 5
                            }
                        },
                        {
                            breakpoint: theme.breakpoints.values.lg,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4
                            }
                        },
                        {
                            breakpoint: theme.breakpoints.values.md,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: theme.breakpoints.values.sm,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }
                    ]
                });

                if(theme.is_loaded) {
                    theme.ImagesLazyLoad.update();
                }
            }
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            if(this.$slick) {
                this.$slick.slick('destroy').off();
                this.$slick = null;

                $window.unbind('theme.resize.carousel-brands');
            }
        }
    });

    return CarouselBrands;
})();

theme.CarouselArticles = (function() {

    function CarouselArticles(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.carousel-articles';

        this.onLoad();
    };

    CarouselArticles.prototype = $.extend({}, Section.prototype, CarouselArticles.prototype, {
        onLoad: function() {
            var $carousel = this.$container.find('[data-js-carousel]'),
                $slick = $carousel.find('[data-js-carousel-slick]');

            if($slick.length) {
                var $prev = $carousel.find('[data-js-carousel-prev]'),
                    $next = $carousel.find('[data-js-carousel-next]'),
                    $arrows = $prev.add($next),
                    count = +$carousel.attr('data-count'),
                    autoplay = $carousel.attr('data-autoplay') === 'true' ? true : false,
                    speed = +$carousel.attr('data-speed'),
                    infinite = $carousel.attr('data-infinite') === 'true' ? true : false,
                    arrows = $carousel.attr('data-arrows') === 'true' ? true : false,
                    bullets = $carousel.attr('data-bullets') === 'true' ? true : false;

                this.$slick = $slick;

                if(arrows) {
                    function arrowsPosition() {
                        var max_height = 0;

                        $slick.find('.carousel__item img').each(function () {
                            max_height = Math.max(max_height, $(this).innerHeight());
                        });

                        $arrows.css({ top: max_height/2 });
                    };

                    $window.on('theme.resize.carousel-articles', arrowsPosition);

                    $carousel.on('lazyloaded', 'img', function () {
                        arrowsPosition();
                    });
                }

                $slick.on('init', function() {
                    $carousel.removeClass('invisible');

                    theme.Loader.unset($carousel.parent());
                });

                $slick.slick({
                    arrows: arrows,
                    prevArrow: $prev,
                    nextArrow: $next,
                    dots: bullets,
                    dotsClass: 'slick-dots d-flex flex-wrap flex-center list-unstyled mt-35',
                    adaptiveHeight: true,
                    autoplay: autoplay,
                    autoplaySpeed: speed,
                    infinite: infinite,
                    slidesToShow: count,
                    slidesToScroll: count,
                    rtl: theme.rtl,
                    responsive: [
                        {
                            breakpoint: theme.breakpoints.values.xl,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: theme.breakpoints.values.lg,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: theme.breakpoints.values.sm,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });

                if(theme.is_loaded) {
                    theme.ImagesLazyLoad.update();
                }
            }
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            if(this.$slick) {
                this.$slick.slick('destroy').off();
                this.$slick = null;

                $window.unbind('theme.resize.carousel-articles');
            }
        }
    });

    return CarouselArticles;
})();

theme.CollectionHead = (function() {

    function CollectionHead(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.collection-head';

        this.onLoad();
    };

    CollectionHead.prototype = $.extend({}, Section.prototype, CollectionHead.prototype, {
        onLoad: function() {
            if(theme.is_loaded) {
                theme.ImagesLazyLoad.update();
            }
        },
        onUnload: function() {
            this.$container.off(this.namespace);
        }
    });

    return CollectionHead;
})();

theme.CollectionBody = (function() {

    function CollectionBody(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.collection-body';

        this.onLoad();
    };

    CollectionBody.prototype = $.extend({}, Section.prototype, CollectionBody.prototype, {
        onLoad: function() {
            if(theme.is_loaded) {
                theme.ImagesLazyLoad.update();
                theme.Tooltip.init();
            }
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            theme.Tooltip.destroy();
        }
    });

    return CollectionBody;
})();

theme.BlogSidebar = (function() {

    function BlogSidebar(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.blog-sidebar';

        this.onLoad();
    };

    BlogSidebar.prototype = $.extend({}, Section.prototype, BlogSidebar.prototype, {
        onLoad: function() {
            theme.StickySidebar.init(this.$container);
            
            if(theme.is_loaded) theme.ImagesLazyLoad.update();
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            theme.StickySidebar.destroy(this.$container);
        }
    });

    return BlogSidebar;
})();

theme.BlogBody = (function() {

    function BlogBody(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.blog-body';

        this.onLoad();
    };

    BlogBody.prototype = $.extend({}, Section.prototype, BlogBody.prototype, {
        onLoad: function() {
            if(theme.is_loaded) {
                theme.ImagesLazyLoad.update();
                theme.Masonry.init(true);
            }
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            theme.Masonry.destroy();
        }
    });

    return BlogBody;
})();

theme.ArticleBody = (function() {

    function ArticleBody(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.article-body';

        this.onLoad();
    };

    ArticleBody.prototype = $.extend({}, Section.prototype, ArticleBody.prototype, {
        slider: {
            init: function ($container) {
                var $slider = $container.find('.article-slider'),
                    $insert = $('#article-slider');

                if($insert.length && $slider.length) {
                    $insert.append($slider);

                    var $slick = $slider.find('.article-slider__slick'),
                        $dots = $slider.find('.article-slider__dots'),
                        autoplay = $slick.attr('data-autoplay') === 'true' ? true : false,
                        speed = +$slick.attr('data-speed'),
                        infinite = $slick.attr('data-infinite') === 'true' ? true : false;

                    $slider.removeClass('d-none');

                    $slick.slick({
                        prevArrow: '<div class="slick-prev d-none d-md-flex flex-center position-absolute left-0 ml-10 rounded-circle overflow-hidden cursor-pointer"><i class="icon-064 position-relative mr-2"></i></div>',
                        nextArrow: '<div class="slick-next d-none d-md-flex flex-center position-absolute right-0 mr-10 rounded-circle overflow-hidden cursor-pointer"><i class="icon-074 position-relative ml-3"></i></div>',
                        dots: true,
                        appendDots: $dots,
                        dotsClass: 'slick-dots d-flex flex-wrap flex-center list-unstyled m-0 my-15',
                        autoplay: autoplay,
                        autoplaySpeed: speed,
                        infinite: infinite,
                        rtl: theme.rtl
                    });

                    $slider.removeClass('invisible');

                    this.$dom = $slick;
                }
            },
            destroy: function () {
                if(this.$dom) {
                    this.$dom.slick('destroy');
                    this.$dom = null;
                }
            }
        },
        onLoad: function() {
            if(theme.is_loaded) {
                theme.ImagesLazyLoad.update();
            }

            this.slider.init(this.$container);
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            this.slider.destroy();
        }
    });

    return ArticleBody;
})();

theme.Gallery = (function() {

    function Gallery(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.gallery';

        this.onLoad();
    };

    Gallery.prototype = $.extend({}, Section.prototype, Gallery.prototype, {
        onLoad: function() {
            if(theme.is_loaded) {
                theme.ImagesLazyLoad.update();
                theme.Masonry.init(true);
            }

            var $gallery = $('.gallery'),
                $fotorama = $gallery.find('.gallery__fotorama');

            var fotorama = $fotorama.fotorama({
                thumbmargin: 0,
                thumbborderwidth: 0
            }).data('fotorama');

            $fotorama.addClass('d-none-important');

            this.fotorama = fotorama;
            
            $('.fotorama__arr--prev').append($('<i class="icon-064">'));
            $('.fotorama__arr--next').append($('<i class="icon-074">'));
            $('.fotorama__fullscreen-icon').append($('<i class="icon-643">'));

            $gallery.on('click', '.gallery__item', function () {
                var index = $(this).attr('data-index'),
                    scroll_t = Math.max($html.scrollTop(), $body.scrollTop());

                fotorama.show({
                    index: index,
                    time: 0
                });

                $fotorama.removeClass('d-none-important invisible position-absolute');
                fotorama.requestFullScreen();
                $html.scrollTop(scroll_t);
            });

            $fotorama.on('fotorama:fullscreenexit', function () {
                $fotorama.addClass('d-none-important invisible position-absolute');
            });
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            theme.Masonry.destroy();

            if(this.fotorama) {
                this.fotorama.destroy();
                this.fotorama = null;
            }

        }
    });

    return Gallery;
})();

theme.SortingCollections = (function() {

    function SortingCollections(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.sorting-collections';

        this.onLoad();
    };

    SortingCollections.prototype = $.extend({}, Section.prototype, SortingCollections.prototype, {
        onLoad: function() {
            var $control = this.$container.find('[data-sorting-collections-control]'),
                $products = this.$container.find('[data-sorting-collections-items]'),
                xhr = null;

            this.$control = $control;

            $control.on('click', 'a', function (e) {
                var $this = $(this);

                if(!$this.hasClass('active')) {
                    if(xhr) {
                        xhr.abort();
                    }

                    theme.Loader.set($products);

                    var collection = $this.attr('data-collection');

                    xhr = $.ajax({
                        type: 'GET',
                        url: '/collections/' + collection,
                        cache: false,
                        data: {
                            view: 'sorting',
                            constraint: 'limit=' + $products.attr('data-limit') + '+grid=' + encodeURIComponent($products.attr('data-grid'))
                        },
                        dataType: 'html',
                        success: function (data) {
                            $products.html(data);

                            theme.ImagesLazyLoad.update();
                            theme.ProductReview.update();

                            $control.find('a').removeClass('active');
                            $this.addClass('active');

                            theme.Loader.unset($products);

                            xhr = null;
                        }
                    });
                }

                e.preventDefault();
                return false;
            });

            if(theme.is_loaded) {
                theme.ImagesLazyLoad.update();
                theme.ProductReview.update();
            }
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            this.$control.off();
        }
    });

    return SortingCollections;
})();

theme.LookBook = (function() {

	function LookBook(container) {
		this.$container = $(container);

		//var sectionId = this.$container.attr('data-section-id');

		//this.settings = {};

		this.namespace = '.lookbook';

		this.onLoad();
	};

	LookBook.prototype = $.extend({}, Section.prototype, LookBook.prototype, {
		onLoad: function() {
			var $items = this.$container.find('.lookbook__item');

			theme.Global.responsiveHandler({
				namespace: '.lookbook',
				element: $items,
				delegate: '[data-lookbook-picker-button]',
				on_desktop: true,
				events: {
					'click': function() {
						var $this = $(this),
							$product = $this.parents('[data-lookbook-picker]').find('[data-lookbook-product]');
alert()
						$this[$this.hasClass('open') ? 'removeClass' : 'addClass']('open');
						$product[$this.hasClass('open') ? 'removeClass' : 'addClass']('d-none');
					}
				}
			});

			theme.Global.responsiveHandler({
				namespace: '.lookbook',
				element: $items,
				delegate: '[data-lookbook-picker]',
				on_desktop: true,
				events: {
					'mouseenter mouseleave': function(e) {
						var $this = $(this),
							$btn = $this.find('[data-lookbook-product-button]'),
							$product = $this.find('[data-lookbook-product]');

						if(!$btn.hasClass('open')) {
							$product[e.type === 'mouseenter' ? 'removeClass' : 'addClass']('d-none');
						}
					}
				}
			});

			theme.Global.responsiveHandler({
				namespace: '.lookbook',
				element: $items,
				delegate: '[data-lookbook-product-close]',
				on_desktop: true,
				events: {
					'click': function() {
						$(this).parents('[data-lookbook-picker]').find('[data-lookbook-picker-button]').addClass('open').trigger('click');
					}
				}
			});

			if($items.length && theme.is_loaded) {
				theme.ImagesLazyLoad.update();
			}
		},
		onUnload: function() {
			this.$container.off(this.namespace);

			this.$container.trigger('section.unload');

			this.$container.find('.lookbook__item').unbind();
		}
	});

	return LookBook;
})();
theme.Footbar = (function() {
    function Footbar(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.footbar';

        this.onLoad();
    };

    Footbar.prototype = $.extend({}, Section.prototype, Footbar.prototype, {
        onLoad: function() {
            theme.Notifications.init(this.$container);
            theme.ProductFootbar.init(this.$container);
        },
        onUnload: function() {
            this.$container.off(this.namespace);
            
            theme.Notifications.destroy(this.$container);
            theme.ProductFootbar.destroy();
        }
    });

    return Footbar;
})();

theme.PasswordPageContent = (function() {

	function PasswordPageContent(container) {
		this.$container = $(container);

		//var sectionId = this.$container.attr('data-section-id');

		//this.settings = {};

		this.namespace = '.password-page-content';

		this.onLoad();
	};

	PasswordPageContent.prototype = $.extend({}, Section.prototype, PasswordPageContent.prototype, {
		onLoad: function() {
			if(theme.is_loaded) {
				theme.ImagesLazyLoad.update();
			}
		},
		onUnload: function() {
			this.$container.off(this.namespace);
		}
	});

	return PasswordPageContent;
})();
theme.Footer = (function() {

    function Footer(container) {
        this.$container = $(container);

        //var sectionId = this.$container.attr('data-section-id');

        //this.settings = {};

        this.namespace = '.footer';

        this.onLoad();
    };

    Footer.prototype = $.extend({}, Section.prototype, Footer.prototype, {
        _back_to_top: {
            init: function(namespace) {
                var _ = this,
                    $button = $('[data-js-button-back-to-top]'),
                    namespace = namespace + '.buttonToTop';

                if($button.length) {
                    var bp = $button.attr('data-js-button-back-to-top') || 1000,
                        duration = function () {
                            return theme.animations.backtotop.scroll_duration * 1000;
                        },
                        is_animate = false,
                        unbind = true;

                    $(window).on('scroll' + namespace + ' resize' + namespace, function () {
                        var scroll_t = pageYOffset || Math.max($('body').scrollTop(), $('html').scrollTop());

                        if(!$button.attr('data-bind')) {
                            $button[scroll_t > bp ? 'addClass' : 'removeClass']('show');
                        }

                        if(scroll_t > bp && unbind) {
                            $button.removeAttr('data-bind');
                        }
                    });

                    $button.on('click', function(e) {
                        if(!is_animate) {
                            is_animate = true;

                            var bind = $button.attr('data-bind');

                            if(bind) {
                                $('html, body').velocity('stop').velocity( 'scroll' , {
                                    offset: bind,
                                    duration: duration(),
                                    complete: function () {
                                        $button.removeAttr('data-bind');

                                        is_animate = false;
                                    }
                                });
                            } else {
                                var scroll_t = pageYOffset || Math.max($('body').scrollTop(), $('html').scrollTop());

                                unbind = false;

                                $button.attr('data-bind', scroll_t);

                                $('html, body').velocity('stop').velocity( 'scroll' , {
                                    offset: 0,
                                    duration: duration(),
                                    complete: function () {
                                        is_animate = false;
                                        unbind = true;
                                    }
                                });
                            }
                        }

                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    });

                    this.destroy = function() {
                        $(window).unbind('scroll' + namespace + ' resize' + namespace);
                        $button.off();
                        delete _.destroy;
                    };
                }
            },
            destroy: function() {
                if(this.destroy) {
                    this.destroy();
                }
            }
        },
        _fixed: {
            init: function ($footer, namespace) {
                if($footer.length && $footer[0].hasAttribute('data-js-footer-fixed')) {
                    var $parent = $footer.parent(),
                        $main = $('#MainContent');

                    function calculate() {
                        var footer_height = $footer.innerHeight(),
                            can_fix = $main.innerHeight() > footer_height + window.innerHeight;
                        
                        $footer[can_fix && theme.current.is_desktop ? 'addClass' : 'removeClass']('footer--fixed');

                        $footer.css({
                            width: theme.current.is_desktop && $parent.hasClass('container') ? $parent.width() + 'px' : ''
                        });

                        $main.css({
                            marginBottom: can_fix && theme.current.is_desktop ? footer_height + parseInt($footer.css('margin-top')) : ''
                        });
                    };

                    $window.on('theme.resize' + namespace, calculate);

                    calculate();
                }
            },
            destroy: function (namespace) {
                $window.unbind('theme.resize' + namespace);
            }
        },
        onLoad: function() {
            var $footer = $('.js-footer');

            this._fixed.init($footer, this.namespace);
            this._back_to_top.init(this.namespace);

            if(theme.is_loaded) {
                theme.Tooltip.init();
            }
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            this._fixed.destroy(this.namespace);
            this._back_to_top.destroy(this.namespace);

            theme.Tooltip.destroy();
        }
    });

    return Footer;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  //theme
  theme.Global();
  theme.ProductCurrency();
  theme.ImagesLazyLoad();
  theme.Masonry();
  theme.Position();
  theme.Parallax();
  theme.Menu();
  theme.Dropdown();
  theme.Select();
  theme.StickyHeader();
  theme.Loader();
  theme.Popups();
  theme.PopupAccount();
  theme.PopupSearch();
  theme.PopupCart();
  theme.PopupSubscription();
  theme.PopupQuickView();
  theme.Notifications();
  theme.ProductQuantity();
  theme.ProductCountdown();
  theme.ProductTextCountdown();
  theme.ProductVisitors();
  theme.ProductImagesNavigation();
  theme.ProductImagesHover();
  theme.ProductOptions();
  theme.ProductsView();
  theme.ProductReview();
  theme.ProductGallery();
  theme.ProductFootbar();
  theme.DynamicCheckout();
  theme.Cart();
  theme.StoreLists();
  theme.Accordion();
  theme.Tabs();
  theme.RangeOfPrice();
  theme.Collections();
  theme.StickySidebar();
  theme.ShippingRatesCalculation();
  theme.ButtonsBlocksVisibility();
  theme.Tooltip();
  theme.Trigger();

  //register sections
  var sections = new slate.Sections();
  sections.register('header', theme.Header);
  sections.register('slider-revolution', theme.SliderRevolution);
  sections.register('home-builder', theme.HomeBuilder);
  sections.register('list-collections', theme.listCollections);
  sections.register('carousel-products', theme.CarouselProducts);
  sections.register('carousel-brands', theme.CarouselBrands);
  sections.register('carousel-articles', theme.CarouselArticles);
  sections.register('collection-sidebar', theme.CollectionSidebar);
  sections.register('collection-head', theme.CollectionHead);
  sections.register('collection-body', theme.CollectionBody);
  sections.register('blog-sidebar', theme.BlogSidebar);
  sections.register('blog-body', theme.BlogBody);
  sections.register('article-body', theme.ArticleBody);
  sections.register('product-page', theme.ProductPage);
  sections.register('gallery', theme.Gallery);
  sections.register('sorting-collections', theme.SortingCollections);
  sections.register('lookbook', theme.LookBook);
  sections.register('footbar', theme.Footbar);
  sections.register('password-page-content', theme.PasswordPageContent);
  sections.register('footer', theme.Footer);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper'
  });

  // Target iframes to make them responsive
  var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
